webpackJsonp([4],{

/***/ "+7Vn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Iw0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"con"},[_c('mt-tabbar',{class:{'mt-custom': _vm.isIphoneX}},[_c('mt-tab-item',{attrs:{"id":"个人文件"}},[_c('router-link',{staticClass:"tab-link",attrs:{"to":{path:'/index'},"tag":"div"}},[_c('span',{class:{color:_vm.id===1}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.id===1),expression:"id===1"}],staticClass:"iconfont icon-file-text"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.id!==1),expression:"id!==1"}],staticClass:"iconfont icon-file-text"}),_vm._v(" "),_vm._v("\n            个人文件\n          ")])])],1),_vm._v(" "),_c('mt-tab-item',{attrs:{"id":"共享文件"}},[_c('router-link',{staticClass:"tab-link",attrs:{"to":{path:'/shareFile'},"tag":"div"}},[_c('span',{class:{color:_vm.id===2}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.id===2),expression:"id===2"}],staticClass:"iconfont icon-usergroup"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.id!==2),expression:"id!==2"}],staticClass:"iconfont icon-usergroup"}),_vm._v("\n            共享文件\n          ")])])],1),_vm._v(" "),_c('mt-tab-item',{attrs:{"id":"传输"}},[_c('router-link',{staticClass:"tab-link",attrs:{"to":{path:'/transfer'},"tag":"div"}},[_c('span',{class:{color:_vm.id===3}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.id===3),expression:"id===3"}],staticClass:"iconfont icon-chuanshu"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.id!==3),expression:"id!==3"}],staticClass:"iconfont icon-chuanshu"}),_vm._v("\n            传输\n          ")])])],1),_vm._v(" "),_c('mt-tab-item',{attrs:{"id":"更多"}},[_c('router-link',{staticClass:"tab-link",attrs:{"to":{path:'/more/setinfo'},"tag":"div"}},[_c('span',{class:{color:_vm.id===4}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.id===4),expression:"id===4"}],staticClass:"iconfont icon-gengduo"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.id!==4),expression:"id!==4"}],staticClass:"iconfont icon-gengduo"}),_vm._v("\n            更多\n          ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+ztV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/3UT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/kF+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-share",attrs:{"id":"myShare"}},[_c('div',{staticClass:"head yp-topbar"},[_c('ul',{staticClass:"clearfix"},[_c('span',{staticClass:"back fl",on:{"click":_vm.back}}),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.index))])])]),_vm._v(" "),_c('mt-navbar',{model:{value:(_vm.selectedTab),callback:function ($$v) {_vm.selectedTab=$$v},expression:"selectedTab"}},[_c('mt-tab-item',{attrs:{"id":"sendWorkmate"}},[_vm._v("发给同事")]),_vm._v(" "),_c('mt-tab-item',{attrs:{"id":"linkShare"}},[_vm._v("链接分享")])],1),_vm._v(" "),_c('mt-tab-container',{model:{value:(_vm.selectedTab),callback:function ($$v) {_vm.selectedTab=$$v},expression:"selectedTab"}},[_c('mt-tab-container-item',{attrs:{"id":"sendWorkmate"}},[_c('workmate-share')],1),_vm._v(" "),_c('mt-tab-container-item',{attrs:{"id":"linkShare"}},[_c('link-share')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/nRP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_tools__ = __webpack_require__("jt1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard__ = __webpack_require__("V33R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_download_js__ = __webpack_require__("AuSF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_share__ = __webpack_require__("Eg0l");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import downList from '../../components/strore.js'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isShow: false,
      opacity: true,
      // 隐藏与显示
      isA: false,
      isB: false,
      len: 0,
      fileId: '',
      up: '',
      time: 0,
      ids: [],
      delfileids: [],
      currentValue: false,
      isChooseAll: false,
      shareVisible: false,
      clipFlag: true,
      pid: 'rootpath',
      totalPages: '',
      page: 0,
      size: 20,
      parentId: [],
      info: {
        page: 0,
        size: 20
      },
      list: [],
      select: '',
      flag: false,
      id: 'id'
    };
  },

  components: {
    formaTime: __WEBPACK_IMPORTED_MODULE_2__assets_js_tools__["c" /* formaTime */],
    MessageBox: __WEBPACK_IMPORTED_MODULE_3_mint_ui__["MessageBox"],
    Toast: __WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"],
    downLoadFile: __WEBPACK_IMPORTED_MODULE_5__components_download_js__["a" /* downLoadFile */],
    share: __WEBPACK_IMPORTED_MODULE_6__components_share__["a" /* default */]
  },
  mounted: function mounted() {
    this.load();
  },

  methods: {
    listenToShare: function listenToShare(data) {
      this.currentValue = data;
    },
    classObject: function classObject(val, val2, val3) {
      var type = this.sliceType(val, val2, val3);
      return 'icon-' + type;
    },
    styleObject: function styleObject(val, val2, val3) {
      var type = this.sliceType(val, val2, val3);
      if (type === 'excel') {
        return 'excel';
      } else if (type === 'pdf') {
        return 'pdf';
      } else if (type === 'word') {
        return 'word';
      } else if (type === 'txt') {
        return 'txt';
      } else if (type === 'pic') {
        return 'pic';
      } else if (type === 'muisc') {
        return 'muisc';
      } else if (type === 'dir') {
        return 'dir';
      } else if (type === 'html') {
        return 'html';
      } else if (type === 'shareDir') {
        return 'shareDir1';
      } else {
        return 'weizhi';
      }
    },
    toggleUp: function toggleUp(index) {
      if (this.select === index) {
        this.select = '';
        this.up = '';
      } else {
        this.select = index;
        this.up = index;
      }
    },
    checkMobile: function checkMobile() {
      this.flag ? this.flag = false : this.flag = true;
      this.isA ? this.isA = false : this.isA = true;
      this.select = '';
    },
    choose: function choose() {
      if (this.isChooseAll) {
        this.cancelChooseAll();
      } else {
        this.checkAll();
      }
    },
    checkAll: function checkAll() {
      this.isChooseAll = true;
      this.len = this.list.length;
      if (this.list.length > 0) {
        this.list.forEach(function (row) {
          row.isB = true;
        });
      }
      this.opacity = false;
    },
    cancelChooseAll: function cancelChooseAll() {
      this.isChooseAll = false;
      this.len = 0;
      if (this.list.length > 0) {
        this.list.forEach(function (row) {
          row.isB = false;
        });
      }
      this.opacity = true;
    },
    checked: function checked(item) {
      if (item.isB === undefined) {
        this.$set(item, 'isB', true);
        this.len++;
        this.opacity = false;
        return;
      }
      if (item.isB) {
        item.isB = false;
        this.len--;
        if (this.len === 0) {
          this.opacity = true;
        } else {
          this.opacity = false;
        }
      } else {
        item.isB = true;
        this.opacity = false;
        this.len++;
      }
    },
    cancel: function cancel() {
      this.index = this.indexs;
      this.isB = false;
      this.opacity = true;
      this.isA ? this.isA = false : this.isA = true;
      this.isChooseAll = false;
      this.cancelChooseAll();
    },
    noCollect: function noCollect() {
      var _this = this;
      var id = this.$refs.nocollect[0].id;
      __WEBPACK_IMPORTED_MODULE_3_mint_ui__["MessageBox"].confirm('取消收藏', '', {
        message: '<div class="title">取消收藏</div><div class="info">确定要取消收藏吗？</div>',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].removeFavorite, { fileIds: id }).then(function () {
          _this.load();
          Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
            message: '取消收藏',
            iconClass: 'icon-success'
          });
          _this.restore();
        }).catch(function (error) {
          Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
            message: error.response.data.message,
            iconClass: 'icon-error'
          });
        });
      });
    },
    currency: function currency(itemId, type) {
      this.fileId = itemId;
      if (type === '分享') {
        this.currentValue = true;
        this.time = 0;
      }
    },
    shareBegin: function shareBegin() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].share, {
        fileIds: _this.fileId,
        shareType: 0,
        validTime: _this.time
      }).then(function (response) {
        Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
          message: '分享成功',
          iconClass: 'icon-success'
        });
        _this.clipFlag = false;
        var shareLink = response.data.shareLink;
        /* eslint-disable */
        if (_this.clipFlag === false) {
          new __WEBPACK_IMPORTED_MODULE_4_clipboard___default.a('#clipboard', {
            text: function text() {
              return shareLink;
            }
          });
        }
      }).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
          message: error.response.data.message,
          iconClass: 'icon-error'
        });
      });
    },
    clip: function clip() {
      if (this.clipFlag === false) {
        this.restore();
        this.cancelChooseAll();
        Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
          message: '链接已复制',
          iconClass: 'icon-success'
        });
      }
    },
    noCollects: function noCollects() {
      var _this2 = this;

      if (this.list.length > 0) {
        this.list.forEach(function (item) {
          if (item.isB) {
            _this2.ids.push(item.id);
            _this2.box();
          }
        });
      }
    },
    delActions: function delActions() {
      var _this3 = this;

      this.list.forEach(function (item) {
        if (item.isB) {
          _this3.currentValue = true;
          _this3.ids.push(item.id);
        }
      });
      this.fileId = this.ids;
    },
    box: function box() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3_mint_ui__["MessageBox"].confirm('取消收藏', {
        message: '<div class="title">取消收藏</div><div class="info">确定要取消收藏吗？</div>',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].removeFavorite, { fileIds: _this4.ids.join(',') }).then(function () {
          _this4.load();
          Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
            message: '取消收藏',
            iconClass: 'icon-success'
          });
          _this4.restore();
        }).catch(function (error) {
          Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
            message: error.response.data.message,
            iconClass: 'icon-error'
          });
        });
      });
    },
    load: function load() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].favorite, _this.info).then(function (response) {
        var data = response.data.content;
        _this.list = [];
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            data[i].gmtModified = Object(__WEBPACK_IMPORTED_MODULE_2__assets_js_tools__["c" /* formaTime */])(data[i].gmtModified);
            _this.id = data[i].id;
            _this.list.push(data[i]);
          }
          _this.totalPages = response.data.totalPages;
        } else {
          _this.list = [];
        }
        return false;
      }).catch(function (error) {});
    },

    // 点击进入下一级目录
    loadMore: function loadMore() {
      var _this5 = this;

      this.loading = true;
      setTimeout(function () {
        var _this = _this5;
        _this.page++;
        //          if (_this.page < _this.totalPages) {
        //          }
        __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].favorite, { page: _this.page, size: _this.size }).then(function (res) {
          var list0 = [];
          var data = res.data.content;
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              list0.push(data[i]);
              data[i].gmtCreate = Object(__WEBPACK_IMPORTED_MODULE_2__assets_js_tools__["c" /* formaTime */])(data[i].gmtCreate);
            }
            if (_this.list && list0) {
              _this.list = _this.list.concat(list0);
            }
          }
        });
        _this5.loading = false;
      }, 250);
    },
    deepPath: function deepPath(index, fileName, isDir, fileCategory) {
      var _this = this;
      // 判断是否是一个文件夹
      if (isDir === 1) {
        __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].fileCatalog, { fileId: index }).then(function (response) {
          var data = response.data;
          if (data.length > 0) {
            if (fileCategory === 1) {
              _this.list = [{ pid: 'rootpath', index: '个人文件' }];
              for (var i = 0; i < data.length; i++) {
                _this.list.push({ pid: data[i].id, index: data[i].fileName });
              }
              _this.list.push(fileName);
              _this.$router.push({ name: 'index', params: _this.list });
              _this.index = fileName;
            } else if (fileCategory === 2) {
              _this.list = [{ pid: '', index: '共享文件' }];
              for (var i = 0; i < data.length; i++) {
                _this.list.push({ pid: data[i].id, index: data[i].fileName });
              }
              _this.list.push(fileName);
              _this.$router.push({ name: 'ShareFile', params: _this.list });
            }
          }
        }).catch(function (error) {});
      }
    },

    sliceType: function sliceType(val, num, flag) {
      //        if (num === 1 && flag !== undefined) {
      //          return 'shareDir'
      //        }
      if (val !== '' || undefined) {
        var point = val.lastIndexOf('.');
        var type = val.substring(point + 1).toLowerCase();
        if (num === 1) {
          if (flag === 2) {
            return 'shareDir';
          } else {
            return 'dir';
          }
        }
        if (type === 'jpg' || type === 'gif' || type === 'JPG' || type === 'GIF' || type === 'png') {
          return 'pic';
        } else if (type === 'avi' || type === 'rmvb' || type === 'rm' || type === 'asf' || type === 'divx' || type === 'mpg' || type === 'mpeg' || type === 'mpe' || type === 'mp4' || type === 'mkv' || type === 'vob ') {
          return 'video';
        } else if (type === 'WAVE' || type === 'AIFF' || type === 'MPEG' || type === 'MP3' || type === 'MIDI' || type === 'mp3') {
          return 'muisc';
        } else if (num === 1) {
          return 'dir';
        } else if (type === 'txt') {
          return 'txt';
        } else if (type === 'pdf') {
          return 'pdf';
        } else if (type === 'doc' || type === 'docx') {
          return 'word';
        } else if (type === 'ppt' || type === 'pptx') {
          return 'ppt';
        } else if (type === 'xls' || type === 'xlsx') {
          return 'excel';
        } else if (type === 'html' || type === 'htm') {
          return 'html';
        } else if (type === 'wps' || type === 'wpt') {
          return 'wps';
        } else if (type === 'zip' || type === 'rar') {
          return 'package';
        } else {
          return 'default';
        }
      }
    },
    restore: function restore() {
      this.opacity = true;
      this.select = '';
      this.isA = false;
      this.isB = false;
      this.fileId = '';
      this.index = this.indexs;
      this.flag = false;
      this.time = 0;
      this.len = 0;
      this.up = '';
      this.isChooseAll = false;
      this.currentValue = false;
      this.shareVisible = false;
      this.clipFlag = true;
      this.page = 0;
      this.size = 20;
      this.info = {
        page: 0,
        size: 20
      };
    },

    // 单个下载
    download: function download() {
      Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])('文件正在下载...');
      // downList.push(...arguments)
      __WEBPACK_IMPORTED_MODULE_5__components_download_js__["a" /* downLoadFile */].apply(undefined, arguments);
    },

    // 多文件下载
    downloads: function downloads() {
      var _this6 = this;

      if (this.list.length > 0) {
        this.list.forEach(function (row) {
          if (row.isB) {
            _this6.ids.push(row.id);
            _this6.download('1', _this6.ids.join(','), '0');
            _this6.restore();
          }
        });
      }
    }
  }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "00So":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_tools__ = __webpack_require__("jt1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isA: false,
      isB: false,
      isChooseAll: false,
      check: '全选',
      opacity: true,
      up: '',
      list: [],
      ids: [],
      len: 0,
      delArr: [],
      data: {
        page: 0,
        size: 20
      },
      select: '',
      isShow: false,
      noSelect: true,
      id: 'id',
      targetfileId: 'targetfileId',
      page: 0,
      size: 20,
      flag: false,
      totalElements: 0,
      totalPages: 0
    };
  },

  components: {
    sliceType: __WEBPACK_IMPORTED_MODULE_2__assets_js_tools__["e" /* sliceType */],
    MessageBox: __WEBPACK_IMPORTED_MODULE_3_mint_ui__["MessageBox"],
    Toast: __WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"]
  },
  created: function created() {
    this._showList();
  },

  methods: {
    classObject: function classObject(val, val2) {
      var type = this.sliceType(val, val2);
      return 'icon-' + type;
    },
    styleObject: function styleObject(val, val2) {
      var type = this.sliceType(val, val2);
      if (type === 'excel') {
        return 'excel';
      } else if (type === 'pdf') {
        return 'pdf';
      } else if (type === 'word') {
        return 'word';
      } else if (type === 'txt') {
        return 'txt';
      } else if (type === 'pic') {
        return 'pic';
      } else if (type === 'muisc') {
        return 'muisc';
      } else if (type === 'dir') {
        return 'dir';
      } else if (type === 'html') {
        return 'html';
      } else {
        return 'weizhi';
      }
    },
    checkMobile: function checkMobile() {
      if (this.list.length !== 0) {
        this.flag ? this.flag = false : this.flag = true;
        this.isA ? this.isA = false : this.isA = true;
        this.select = '';
      }
    },
    choose: function choose() {
      if (this.isChooseAll) {
        this.cancelcheckAll();
      } else {
        this.checkAll();
      }
    },
    checkAll: function checkAll() {
      this.isChooseAll = true;
      this.len = true;
      this.len = this.list.length;
      if (this.list.length > 0) {
        this.list.forEach(function (row) {
          row.isB = true;
        });
      }
      this.opacity = false;
    },
    cancelcheckAll: function cancelcheckAll() {
      this.isChooseAll = false;
      this.len = false;
      if (this.list.length > 0) {
        this.list.forEach(function (row) {
          row.isB = false;
        });
      }
      this.opacity = true;
    },
    checked: function checked(item) {
      if (item.isB === undefined) {
        this.$set(item, 'isB', true);
        this.opacity = false;
        this.len++;
        return;
      }
      if (item.isB) {
        item.isB = false;
        this.len--;
        if (this.len === 0) {
          this.opacity = true;
        } else {
          this.opacity = false;
        }
      } else {
        item.isB = true;
        this.opacity = false;
        this.len++;
      }
    },
    toggleUp: function toggleUp(index) {
      console.log(index);
      if (this.select === index) {
        this.select = '';
        this.up = '';
      } else {
        this.select = index;
        this.up = index;
      }
    },
    cancel: function cancel() {
      this.isA ? this.isA = false : this.isA = true;
      var _this = this;
      this.opacity = true;
      _this.isChooseAll = false;
      _this.cancelcheckAll();
    },
    one_delete: function one_delete() {
      var _this = this;
      if (_this.list.length !== 0) {
        __WEBPACK_IMPORTED_MODULE_3_mint_ui__["MessageBox"].confirm('删除', {
          message: '<div class="title">删除</div><div class="info">' + '<div>确定要删除吗？</div>' + '<div>删除后将无法恢复</div>' + '</div>',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].clearRemovedFile, {}).then(function () {
            Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
              message: '删除成功',
              iconClass: 'icon-success'
            });
            _this._showList();
          }).catch(function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
              message: error.response.data.message,
              iconClass: 'icon-error'
            });
          });
        });
      }
    },
    _showList: function _showList() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].delList, _this.data).then(function (response) {
        var data = response.data.content;
        _this.list = [];
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            _this.targetfileId = data[i].pid;
            _this.list.push(data[i]);
            _this.id = data[i].id;
          }
          _this.totalElements = response.data.totalElements;
          _this.totalPages = response.data.totalPages;
        } else {
          _this.list = [];
        }
        return false;
      });
    },
    two_delete: function two_delete(item) {
      var _this = this;
      if (item) {
        _this.ids.push(item.id);
        __WEBPACK_IMPORTED_MODULE_3_mint_ui__["MessageBox"].confirm('删除', {
          message: '<div class="title">删除</div><div class="info">' + '<div>确定要删除吗？</div>' + '<div>删除后将无法恢复</div>' + '</div>',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].permRemove, { fileIds: _this.ids.join(',') }).then(function () {
            Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
              message: '删除成功',
              iconClass: 'icon-success'
            });
            _this._showList();
            _this.restore();
          }).catch(function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
              message: error.response.data.message,
              iconClass: 'icon-error'
            });
          });
        });
      }
    },
    two_recover: function two_recover(event) {
      var _this = this;
      var id = event.target.id;
      __WEBPACK_IMPORTED_MODULE_3_mint_ui__["MessageBox"].confirm('恢复', {
        message: '<div class="title">恢复</div><div class="info">确定要恢复吗？</div>',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].recover, { fileIds: id, targetFileId: _this.targetfileId }).then(function () {
          _this._showList();
          Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
            message: '恢复成功',
            iconClass: 'icon-success'
          });
          _this.restore();
        }).catch(function (error) {
          Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
            message: error.response.data.message,
            iconClass: 'icon-error'
          });
        });
      });
    },
    recoverList: function recoverList() {
      var _this2 = this;

      this.list.forEach(function (value) {
        if (value.isB) {
          _this2.ids.push(value.id);
          _this2.box();
        }
      });
    },
    deleteList: function deleteList() {
      var _this3 = this;

      this.list.forEach(function (value) {
        if (value.isB) {
          _this3.ids.push(value.id);
          _this3.box1();
        }
      });
    },
    box: function box() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3_mint_ui__["MessageBox"].confirm('恢复', {
        message: '<div class="title">恢复</div><div class="info">确定要恢复吗？</div>',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].recover, { fileIds: _this4.ids.join(',') }).then(function () {
          _this4._showList();
          Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
            message: '恢复成功',
            iconClass: 'icon-success'
          });
          _this4.restore();
        }).catch(function (error) {
          Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
            message: error.response.data.message,
            iconClass: 'icon-error'
          });
        });
      });
    },
    box1: function box1() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_3_mint_ui__["MessageBox"].confirm('删除', {
        message: '<div class="title">删除</div><div class="info">确定要删除吗？</div>',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].permRemove, { fileIds: _this5.ids.join(',') }).then(function () {
          _this5._showList();
          Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
            message: '删除成功',
            iconClass: 'icon-success'
          });
          _this5.restore();
        }).catch(function (error) {
          Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
            message: error.response.data.message,
            iconClass: 'icon-error'
          });
        });
      });
    },
    restore: function restore() {
      this.opacity = true;
      this.select = '';
      this.isChooseAll = false;
      this.isA = false;
      this.isB = false;
      this.fileId = '';
      this.up = '';
      this.len = 0;
      this.flag = false;
      this.page = 0;
      this.size = 20;
      this.info = {
        page: 0,
        size: 20
      };
    },

    //      scroll: function () {
    //        let sw = true
    //        let _this = this
    //        let ulBox = _this.$refs.ulBox
    //        if (ulBox.scrollTop + ulBox.clientHeight >= ulBox.scrollHeight) {
    //          if (sw === true) {
    //            sw = false
    //            _this.page++
    //            apis.request(cloudApi.delList, {page: _this.page, size: _this.size}).then(function (res) {
    //              let data = res.data.content
    //              if (data.length > 0) {
    //                for (let i = 0; i < data.length; i++) {
    //                  _this.list.push(data[i])
    //                }
    //              }
    //              return false
    //            })
    //            sw = true
    //          }
    //        }
    //      },
    loadMore: function loadMore() {
      var _this6 = this;

      this.loading = true;
      var content = document.getElementById('mainlist');
      if (content.scrollHeight - content.scrollTop - content.offsetHeight < 10) {
        if (this.totalElements > this.list.length) {
          setTimeout(function () {
            var _this = _this6;
            if (_this.page < _this.totalPages) {
              _this.page++;
            }
            __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].delList, { page: _this.page, size: _this.size }).then(function (res) {
              var list0 = [];
              var data = res.data.content;
              if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                  list0.push(data[i]);
                  data[i].gmtCreate = Object(__WEBPACK_IMPORTED_MODULE_2__assets_js_tools__["c" /* formaTime */])(data[i].gmtCreate);
                }
                if (_this.list && list0) {
                  _this.list = _this.list.concat(list0);
                }
              }
            });
            _this6.loading = false;
          }, 250);
        }
      }
    },
    sliceType: function sliceType(val, num) {
      if (val !== '' || undefined) {
        var point = val.lastIndexOf('.');
        var type = val.substring(point + 1).toLowerCase();
        if (num === 1) {
          return 'dir';
        }
        if (type === 'jpg' || type === 'gif' || type === 'JPG' || type === 'GIF' || type === 'png') {
          return 'pic';
        } else if (type === 'avi' || type === 'rmvb' || type === 'rm' || type === 'asf' || type === 'divx' || type === 'mpg' || type === 'mpeg' || type === 'mpe' || type === 'mp4' || type === 'mkv' || type === 'vob ') {
          return 'video';
        } else if (num === 1) {
          return 'dir';
        } else if (type === 'txt') {
          return 'txt';
        } else if (type === 'pdf') {
          return 'pdf';
        } else if (type === 'doc' || type === 'docx') {
          return 'word';
        } else if (type === 'ppt' || type === 'pptx') {
          return 'ppt';
        } else if (type === 'xls' || type === 'xlsx') {
          return 'excel';
        } else if (type === 'html' || type === 'htm') {
          return 'html';
        } else if (type === 'wps' || type === 'wpt') {
          return 'wps';
        } else if (type === 'zip' || type === 'rar') {
          return 'package';
        } else {
          return 'default';
        }
      }
    },

    bytesToSize: function bytesToSize(bytes) {
      if (bytes === 0) return '0 B';
      if (bytes === '') return '';
      var k = 1024;
      var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return (bytes / Math.pow(k, i)).toPrecision(3) + sizes[i];
    },
    formaTime: function formaTime(val) {
      if (val !== '' || undefined || null) {
        return new Date(val).format('yyyy-MM-dd HH:mm');
      }
    }
  }
});

/***/ }),

/***/ "02uN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_crumbs__ = __webpack_require__("fclH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this2 = this;

    return {
      title: this.eleTitle || '添加新成员',
      searchMemberList: {
        search: '',
        data: [],
        pageNo: 0,
        totalElements: 0
      },
      constant: { // 常量对象
        maxSelect: 100,
        pageSize: 20 // 每次加载数据的条数
      },
      deptList: {
        pageNo: 0,
        totalElements: 0,
        data: [],
        renderData: [],
        cacheClick: {} // 缓存点击过的子集部门节点
      },
      groupList: {
        pageNo: 0,
        totalElements: 0,
        renderData: []
      },
      crumbs: {
        routes: [{
          name: '所有成员',
          id: -1
        }],
        // 点击面包屑触发
        crumbTrigger: function crumbTrigger(route) {
          if (route.id === -1) {
            // 点击所有成员
            _this2.status.triggerCrumbs = false;
            _this2.status.isAllMember = true;
            _this2.crumbs.routes = [{
              name: '所有成员',
              id: -1
            }];
            _this2.allMemberListInit();
            _this2.status.scrollObj = 1; // 成员列表滚动条出现时加载成员为所有成员
          } else if (route.id === -2) {
            // 点击组织架构方向
            if (_this2.status.isAllMember) {
              _this2.status.isAllMember = false;
            }
            _this2.deptList.renderData = _this2.deptList.data;
          } else if (route.id === -3) {
            // 点击群组方向
            if (_this2.status.isAllMember) {
              _this2.status.isAllMember = false;
            }
          } else if (route.type === 'dept') {
            if (_this2.status.isAllMember) {
              _this2.status.isAllMember = false;
            }
            _this2.deptList.renderData = _this2.deptList.cacheClick[route.id];
          }
        }
      },
      menuList: [{
        icon: 'icon-bumenguanli',
        menuName: '从部门架构中选择',
        event: function event() {
          _this2.status.isAllMember = false;
          _this2.status.triggerCrumbs = true;
          _this2.status.isSelectDept = true;
          _this2.status.scrollObj = 2; // 成员列表滚动时加载的数据为部门成员
          _this2.crumbs.routes.push({
            name: '部门架构',
            id: -2
          });
          __WEBPACK_IMPORTED_MODULE_3__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].deptList).then(function (response) {
            _this2.deptList.renderData = _this2.deptList.data = response.data;
          });
        }
      }, {
        icon: 'icon-qunzuguanli',
        menuName: '从群组中选择',
        event: function event() {
          _this2.status.isAllMember = false;
          _this2.status.triggerCrumbs = true;
          _this2.status.isSelectDept = false;
          _this2.status.scrollObj = 3; // 成员列表滚动时加载的数据为群组成员
          _this2.crumbs.routes.push({
            name: '群组',
            id: -3
          });
          _this2.groupList = {
            pageNo: 0,
            totalElements: 0,
            renderData: []
          };
          _this2.queryGroupList();
        }
      }],
      memberList: {
        pageNo: 0,
        totalElements: 0,
        data: []
      },
      status: { // 保存页面状态
        isSearch: false,
        selectedMemberId: [],
        triggerSelect: false,
        triggerCrumbs: false,
        isAllMember: true,
        isSelectDept: true,
        scrollObj: 1, // 成员列表是根据群组或部分或全部
        clickDeptOrGroup: 0 // 当前点击的群组或部门
      },
      dataListMember: this.dataList || [],
      removeId: ''
    };
  },

  computed: {
    isAllMember: function isAllMember() {
      return this.status.isAllMember;
    },
    isSearch: function isSearch() {
      return this.status.isSearch;
    },
    search: function search() {
      return this.searchMemberList.search;
    }
  },
  watch: {
    isAllMember: function isAllMember() {
      this.conputeContentPos();
    },
    isSearch: function isSearch() {
      this.conputeContentPos();
    },
    search: function search() {
      this.searchMemberList.data = [];
      this.searchMemberList.totalElements = 0;
      this.searchMemberList.pageNo = 0;
      if (!this.search) {
        return false;
      }
      this.searchMember();
    }
  },
  created: function created() {
    var _this3 = this;

    this.allMemberListInit();
    this.dataListMember.forEach(function (ele, index) {
      _this3.status.selectedMemberId.push(ele.id);
    });
    this.removeId = JSON.parse(window.sessionStorage.mobileData).id;
  },

  components: {
    crumbs: __WEBPACK_IMPORTED_MODULE_1__components_crumbs__["a" /* default */]
  },
  props: ['cancelOperation', 'confirmOperation', 'eleTitle', 'dataList', 'isFilter'],
  methods: {
    cancel: function cancel() {
      var _this4 = this;

      if (typeof this.cancelOperation === 'function') {
        window.history.back();
        new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          setTimeout(function () {
            _this4.cancelOperation(resolve, reject);
            resolve();
          });
        }).then(function () {
          _this4.clearStatus();
        });
      }
    },
    confirm: function confirm() {
      var _this5 = this;

      if (typeof this.confirmOperation === 'function') {
        new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          setTimeout(function () {
            _this5.confirmOperation(_this5.status.selectedMemberId, resolve, reject);
            resolve();
          });
        }).then(function () {
          _this5.clearStatus();
        });
      }
    },
    clearStatus: function clearStatus() {
      this.status.selectedMemberId = [];
      this.status.isSearch = false;
      this.status.triggerSelect = false;
      this.status.triggerCrumbs = false;
      this.status.isAllMember = true;
      this.status.isSelectDept = true;
      this.status.clickDeptOrGroup = 0;
      this.status.scrollObj = 1;
    },
    queryGroupList: function queryGroupList() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_3__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].groupList, {
        page: this.groupList.pageNo,
        size: this.constant.pageSize
      }).then(function (response) {
        _this6.groupList.renderData = _this6.groupList.renderData.concat(response.data.content);
        _this6.groupList.totalElements = response.data.totalElements;
      });
      this.groupList.pageNo++;
    },

    // 搜索成员
    searchMember: function searchMember() {
      var _this7 = this;

      var _this = this;
      __WEBPACK_IMPORTED_MODULE_3__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].allMemberList, {
        page: this.searchMemberList.pageNo,
        size: this.constant.pageSize,
        info: this.searchMemberList.search
      }).then(function (response) {
        response.data.content.forEach(function (val, index) {
          if (!_this.isFilter && val.id === _this.removeId) {
            response.data.content.splice(index, 1);
          }
        });
        _this7.searchMemberList.data = _this7.searchMemberList.data.concat(response.data.content);
        _this7.searchMemberList.totalElements = response.data.totalElements;
      });
      this.searchMemberList.pageNo++;
    },

    // 取消搜索
    cancelSearch: function cancelSearch() {
      this.status.isSearch = false;
      this.searchMemberList.search = '';
    },

    // 计算下方内容列表区的定位
    conputeContentPos: function conputeContentPos() {
      setTimeout(function () {
        var node = document.getElementById('memberListContent');
        while ((node = node.previousElementSibling).style.display === ('' || 'none')) {}
        Array.prototype.forEach.call(document.getElementsByClassName('yp-content'), function (value) {
          value.style.top = node.offsetHeight + node.offsetTop + 'px';
        });
      });
    },

    // 搜索区域卷起
    searchContentScroll: function searchContentScroll() {
      var content = document.getElementsByClassName('search-content')[0];
      if (content.scrollHeight - content.scrollTop - content.offsetHeight < 10) {
        if (this.searchMemberList.totalElements > this.searchMemberList.data.length) {
          this.searchMember();
        }
      }
    },

    // 成员列表div滚动时
    memberListScroll: function memberListScroll() {
      var memberListContent = document.getElementById('memberListContent');
      if (memberListContent.scrollHeight - memberListContent.scrollTop - memberListContent.offsetHeight < 10) {
        if (this.memberList.totalElements > this.memberList.data.length) {
          if (this.status.scrollObj === 1) {
            this.queryAllMemberList();
          } else if (this.status.scrollObj === 2) {
            this.queryMemberListByDept(this.status.clickDeptOrGroup);
          } else if (this.status.scrollObj === 3) {
            this.queryMemberListByGroup(this.status.clickDeptOrGroup);
          }
        }
      }
    },

    // 群组列表div滚动时
    groupListScroll: function groupListScroll() {
      var groupListContent = document.getElementById('groupListContent');
      if (groupListContent.scrollHeight - groupListContent.scrollTop - groupListContent.offsetHeight < 10) {
        if (this.groupList.totalElements > this.groupList.renderData.length) {
          this.queryGroupList();
        }
      }
    },

    // 查询所有成员列表并初始化配置
    allMemberListInit: function allMemberListInit() {
      this.memberList = {
        pageNo: 0,
        totalElements: 0,
        data: []
      };
      this.queryAllMemberList();
    },
    queryAllMemberList: function queryAllMemberList() {
      var _this8 = this;

      var _this = this;
      __WEBPACK_IMPORTED_MODULE_3__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].allMemberList, {
        page: this.memberList.pageNo,
        size: this.constant.pageSize
      }).then(function (response) {
        response.data.content.forEach(function (val, index) {
          if (!_this.isFilter && val.id === _this.removeId) {
            response.data.content.splice(index, 1);
          }
        });
        _this8.memberList.data = _this8.memberList.data.concat(response.data.content);
        _this8.memberList.totalElements = response.data.totalElements;
      });
      this.memberList.pageNo++;
    },
    queryMemberListByDept: function queryMemberListByDept(id) {
      var _this9 = this;

      var _this = this;
      __WEBPACK_IMPORTED_MODULE_3__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].memberListByDept, {
        orgId: id,
        page: this.memberList.pageNo,
        size: this.constant.pageSize
      }).then(function (response) {
        _this9.status.isAllMember = true;
        response.data.content.forEach(function (val, index) {
          if (!_this.isFilter && val.id === _this.removeId) {
            response.data.content.splice(index, 1);
          }
        });
        _this9.memberList.data = _this9.memberList.data.concat(response.data.content);
        _this9.memberList.totalElements = response.data.totalElements;
      });
      this.memberList.pageNo++;
    },
    queryMemberListByGroup: function queryMemberListByGroup(id) {
      var _this10 = this;

      var _this = this;
      __WEBPACK_IMPORTED_MODULE_3__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].memberListByGroup, {
        groupId: id,
        page: this.memberList.pageNo,
        size: this.constant.pageSize
      }).then(function (response) {
        _this10.status.isAllMember = true;
        response.data.content.forEach(function (val, index) {
          if (!_this.isFilter && val.id === _this.removeId) {
            response.data.content.splice(index, 1);
          }
        });
        _this10.memberList.data = response.data.content;
        _this10.memberList.totalElements = response.data.totalElements;
      });
      this.memberList.pageNo++;
    },

    // 群组展开
    groupExpend: function groupExpend(item) {
      this.memberList = {
        pageNo: 0,
        totalElements: 0,
        data: []
      };
      this.status.clickDeptOrGroup = item.id;
      this.queryMemberListByGroup(item.id);
      this.crumbs.routes.push({
        name: item.groupName,
        id: item.id,
        type: 'group'
      });
    },

    // 下一级部门
    nextDept: function nextDept(item) {
      var _this11 = this;

      this.deptList.renderData.some(function (value, index, array) {
        if (value.id === item.id) {
          _this11.crumbs.routes.push({
            name: item.orgName,
            id: item.id,
            type: 'dept'
          });
          if (!(item.id in _this11.deptList.cacheClick)) {
            _this11.deptList.cacheClick[item.id] = value.children;
          }
          _this11.deptList.renderData = value.children;
          return true;
        }
        return false;
      });
    },

    // 部门列表下级按钮点击
    deptExpend: function deptExpend(item) {
      this.crumbs.routes.push({
        name: item.orgName,
        id: item.id,
        type: 'dept'
      });
      this.memberList = {
        pageNo: 0,
        totalElements: 0,
        data: []
      };
      this.status.clickDeptOrGroup = item.id;
      this.queryMemberListByDept(item.id);
    },

    // 成员列表行点击
    memberRowClick: function memberRowClick(item) {
      if (!item.isSelected) {
        if (this.status.selectedMemberId.length >= this.constant.maxSelect) {
          Object(__WEBPACK_IMPORTED_MODULE_4_mint_ui__["Toast"])({
            message: '已达到人数限制',
            iconClass: 'icon-error'
          });
          return false;
        }
        this.status.selectedMemberId.push(item.id);
      } else {
        this.status.selectedMemberId.splice(this.status.selectedMemberId.indexOf(item.id), 1);
      }
      item.isSelected = !item.isSelected;
    }
  }
});

/***/ }),

/***/ "0PLB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Spf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0WDf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0xDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var u = navigator.userAgent;
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (isIOS) {
    if (screen.height === 812 && screen.width === 375) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "19DJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1AK6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      router: []
    };
  },
  created: function created() {
    this.router = this.routes;
  },

  watch: {
    routes: function routes() {
      var _this = this;

      this.router = this.routes;
      window.setTimeout(function () {
        _this.$el.scrollLeft = _this.$el.scrollWidth - _this.$el.style.width;
      });
    }
  },
  methods: {
    crumbClick: function crumbClick(item) {
      this.router.some(function (value, index, array) {
        if (value.id === item.id) {
          array.splice(index + 1);
          return true;
        }
        return false;
      });
      if (typeof this.crumbTrigger === 'function') {
        this.crumbTrigger(item);
      }
      if (item.path) {
        this.$router.push(item.path);
      }
    }
  },
  props: ['routes', 'crumbTrigger', 'height', 'separator']
});

/***/ }),

/***/ "1HsE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"group-wrap"}},[_c('div',{staticClass:"yp-topbar",attrs:{"id":"header"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isChoose),expression:"!isChoose"}],staticClass:"topbar"},[_c('div',{staticClass:"top-left"},[_c('i',{staticClass:"back",on:{"click":_vm.returnBack}})]),_vm._v(" "),_c('div',{staticClass:"top-center"},[_vm._v("群组管理")]),_vm._v(" "),_c('div',{staticClass:"top-right"},[_c('i',{staticClass:"open-mobile",on:{"click":function($event){_vm.isDialogShow = true}}}),_vm._v(" "),_c('i',{staticClass:"check-mobile",on:{"click":_vm.triggerChoose}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChoose),expression:"isChoose"}],staticClass:"topbar"},[_c('div',{staticClass:"top-left"},[_c('span',{on:{"click":_vm.choose}},[_vm._v("\n        "+_vm._s(_vm.isChooseAll ? '取消全选' : '全选')+"\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectCount > 0),expression:"selectCount > 0"}],staticClass:"top-center"},[_vm._v("已选"+_vm._s(_vm.selectCount)+"个群组")]),_vm._v(" "),_c('div',{staticClass:"top-right"},[_c('span',{on:{"click":_vm.cancle}},[_vm._v("取消")])])])]),_vm._v(" "),_c('div',{style:(("bottom:" + _vm.bottom)),attrs:{"id":"main"},on:{"scroll":_vm.groupListScroll}},[_c('ul',_vm._l((_vm.tableData),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"list-row",on:{"click":function($event){return _vm.memberManage(item)}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChoose),expression:"isChoose"}],staticClass:"checkbox",class:{'select': item.isSelected, 'unselect': !item.isSelected},on:{"click":function($event){$event.stopPropagation();return _vm.chooseOne(item)}}}),_vm._v(" "),_c('div',{staticClass:"list-left"},[_c('img',{staticClass:"head-img",attrs:{"alt":"","src":item.imgUrl}})]),_vm._v(" "),_c('div',{staticClass:"list-center1"},[_c('div',{staticClass:"groupName"},[_vm._v(_vm._s(item.groupName))]),_vm._v(" "),_c('div',{staticClass:"userCount"},[_vm._v(_vm._s(item.userCount)+"人")])]),_vm._v(" "),_c('div',{staticClass:"list-right"},[_c('i',{staticClass:"more",class:{'transform':item.isTransform},on:{"click":function($event){$event.stopPropagation();return _vm.xialaClick(item)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isXiala),expression:"item.isXiala"}],staticClass:"xiala-div toolbar"},[_c('div',{staticClass:"operation",on:{"click":function($event){_vm.isDialogShow = true;_vm.newGroupName = item.groupName;_vm.selectRow.isRename = true}}},[_c('i',{staticClass:"iconfont icon-bianjibiaoge"}),_vm._v(" "),_c('div',[_vm._v("重命名")])]),_vm._v(" "),_c('div',{staticClass:"operation",on:{"click":function($event){return _vm.deleteGroup(item)}}},[_c('i',{staticClass:"iconfont icon-lajitong"}),_vm._v(" "),_c('div',[_vm._v("删除")])])])])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChoose&&!_vm.selectCount),expression:"isChoose&&!selectCount"}],attrs:{"id":"footer-shade"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChoose),expression:"isChoose"}],staticClass:"toolbar",attrs:{"id":"footer"}},[_c('button',{on:{"click":function($event){return _vm.deleteGroup(null)}}},[_vm._v("删除")])]),_vm._v(" "),(false)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDialogShow),expression:"isDialogShow"}],staticClass:"dialog"},[_c('div',{staticClass:"dialog-title"},[_vm._v("群组名称")]),_vm._v(" "),_c('div',{staticClass:"dialog-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newGroupName),expression:"newGroupName"}],attrs:{"placeholder":_vm.placeholder},domProps:{"value":(_vm.newGroupName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newGroupName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"dialog-footer"},[_c('div',{staticClass:"dialog-left",on:{"click":function($event){_vm.isDialogShow = false; _vm.newGroupName = '';_vm.selectRow.isRename = false}}},[_vm._v("取消")]),_vm._v(" "),_c('div',{staticClass:"dialog-right",on:{"click":_vm.addGroup}},[_vm._v("确定")])])]):_vm._e(),_vm._v(" "),(false)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShadeShow),expression:"isShadeShow"}],attrs:{"id":"shade"}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.deleteTrigger),expression:"deleteTrigger"}],staticClass:"dialog"},[_c('div',{staticClass:"dialog-title"},[_vm._v("删除")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"dialog-footer"},[_c('div',{staticClass:"dialog-left",on:{"click":function($event){_vm.deleteTrigger = false;_vm.ids = []}}},[_vm._v("取消")]),_vm._v(" "),_c('div',{staticClass:"dialog-right",on:{"click":_vm.confirmDelete}},[_vm._v("确定")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-content"},[_c('span',{staticClass:"content"},[_vm._v("确认删除所选群组？")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Knd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loadDiv"}},[_c('mt-header',{staticClass:"yp-topbar",attrs:{"fixed":"","title":"传输列表"}}),_vm._v(" "),_c('div',{staticClass:"loadDivList"},[(_vm.fileList.wait.length + _vm.fileList.error.length + _vm.fileList.success.length != 0)?_c('div',[(_vm.fileList.wait.length !== 0)?_c('div',[_c('div',{staticClass:"title"},[_vm._v("正在上传("+_vm._s(_vm.fileList.wait.length)+")")]),_vm._v(" "),_c('ul',{staticClass:"listDiv"},[_c('v-touch',{on:{"swipeleft":_vm.swiperight}},_vm._l((_vm.fileList.wait),function(item,index){return _c('li',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"list"},[(_vm.sliceType(item.name)!=='package')?_c('span',{class:_vm.styleObject(item.name)},[_c('i',{staticClass:"iconfont",class:_vm.classObject(item.name)})]):_c('svg',{staticClass:"icon package",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-package"}})]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{staticClass:"right"},[_c('h3',[_vm._v(_vm._s(_vm._f("sliceNameF")(item.name)))]),_vm._v(" "),_c('span',[_vm._v("正在上传中")])]),_vm._v(" "),_c('div',{staticClass:"size"},[_vm._v(_vm._s(_vm._f("bytesToSize")(item.size)))])])]),_vm._v(" "),_c('div',{staticClass:"list-shade",style:({width: ("calc(100% * " + (item.progress) + ")")})})])}),0)],1)]):_vm._e(),_vm._v(" "),(_vm.fileList.success.length !== 0)?_c('div',[_c('div',{staticClass:"title"},[_vm._v("上传成功("+_vm._s(_vm.fileList.success.length)+")")]),_vm._v(" "),_c('ul',{staticClass:"listDiv"},_vm._l((_vm.fileList.success),function(item,index){return _c('li',[_c('v-touch',{on:{"swipeleft":function($event){return _vm.swipeleft(index)},"swiperight":function($event){return _vm.swiperight(index)}}},[_c('div',{staticClass:"list"},[(_vm.sliceType(item.name)!=='package')?_c('span',{class:_vm.styleObject(item.name)},[_c('i',{staticClass:"iconfont",class:_vm.classObject(item.name)})]):_c('svg',{staticClass:"icon package",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-package"}})]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{staticClass:"right"},[_c('h3',[_vm._v(_vm._s(_vm._f("sliceNameF")(item.name)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("formatTime")(item.newDate)))])]),_vm._v(" "),_c('div',{staticClass:"size"},[_vm._v(_vm._s(_vm._f("bytesToSize")(item.size)))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(index === _vm.delShow),expression:"index === delShow"}],staticClass:"delete",on:{"click":function($event){return _vm.deleteFile(item, '1')}}},[_vm._v("\n                删除\n              ")])])],1)}),0)]):_vm._e(),_vm._v(" "),(_vm.fileList.error.length !== 0)?_c('div',[_c('div',{staticClass:"title"},[_vm._v("上传错误("+_vm._s(_vm.fileList.error.length)+")")]),_vm._v(" "),_c('ul',{staticClass:"listDiv"},[_c('v-touch',{on:{"swipeleft":_vm.swiperight}},_vm._l((_vm.fileList.error),function(item,index){return _c('li',[_c('div',{staticClass:"list"},[(_vm.sliceType(item.name)!=='package')?_c('span',{class:_vm.styleObject(item.name)},[_c('i',{staticClass:"iconfont",class:_vm.classObject(item.name)})]):_c('svg',{staticClass:"icon package",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-package"}})]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{staticClass:"right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("上传失败，"+_vm._s(item.message))])]),_vm._v(" "),_c('div',{staticClass:"size"},[_vm._v(_vm._s(_vm._f("bytesToSize")(item.size)))])])])])}),0)],1)]):_vm._e()]):_c('div',{staticStyle:{"position":"fixed","top":"40%","left":"30%"},attrs:{"id":"noList"}},[_c('i',{staticClass:"iconfont icon-meiyoushangchuan",staticStyle:{"color":"#D4D4D4","font-size":"1.8rem"}}),_vm._v(" "),_c('p',{staticStyle:{"font-size":".28rem","color":"#999999"}},[_vm._v("您还没有上传记录哦～")])])]),_vm._v(" "),_c('tabbar',{attrs:{"id":3}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1R+O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"actionsheet-float"}},[(_vm.currentValue)?_c('div',{staticClass:"mint-actionsheet",staticStyle:{"z-index":"2001"}},[_c('ul',{staticClass:"mint-actionsheet-list",staticStyle:{"margin-bottom":"5px"}},[_c('li',{staticClass:"mint-actionsheet-listitem sharetime"},[_c('div',{staticClass:"shareTip"},[_vm._v("文件分享有效期")]),_vm._v(" "),_c('ul',{staticClass:"clearfix period"},[_c('li',{staticClass:"fl"},[_c('em',{staticClass:"aging",class:{'checked': _vm.time===1},on:{"click":function($event){_vm.time=1}}}),_vm._v("1天过期")]),_vm._v(" "),_c('li',{staticClass:"fl"},[_c('em',{staticClass:"aging",class:{'checked': _vm.time===7},on:{"click":function($event){_vm.time=7}}}),_vm._v("7天过期")]),_vm._v(" "),_c('li',{staticClass:"fl"},[_c('em',{staticClass:"aging",class:{'checked': _vm.time===0},on:{"click":function($event){_vm.time=0}}}),_vm._v("永久有效")])])]),_vm._v(" "),_c('li',{staticClass:"mint-actionsheet-listitem"},[_c('span',{on:{"click":_vm.sendWorkmate}},[_vm._v("发给同事")])]),_vm._v(" "),(!_vm.isGenerateLink)?_c('li',{staticClass:"mint-actionsheet-listitem"},[_c('span',{on:{"click":_vm.shareBegin}},[_vm._v("链接分享")])]):_c('li',{staticClass:"mint-actionsheet-listitem"},[_c('span',{attrs:{"id":"clipboard"},on:{"click":_vm.clip}},[_vm._v("复制链接")])]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"clipboard",attrs:{"type":"text","value":"1"}})]),_vm._v(" "),_c('a',{staticClass:"mint-actionsheet-button",on:{"click":function($event){$event.stopPropagation();_vm.$emit('share', false);_vm.currentValue = false;_vm.time=false;_vm.clipFlag=true}}},[_vm._v("取消")]),_vm._v(" "),(_vm.isSendWorkmate)?_c('choose-member',{attrs:{"eleTitle":"选择同事","cancelOperation":_vm.cancelSendWorkmate,"confirmOperation":_vm.confirmSendWorkmate}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1hWU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1j6G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "29bF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myShare_vue__ = __webpack_require__("oGO4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d03b245e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myShare_vue__ = __webpack_require__("/kF+");
function injectStyle (ssrContext) {
  __webpack_require__("vyk3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d03b245e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myShare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d03b245e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myShare_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2DrX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_copy_vue__ = __webpack_require__("PMk8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dc6165a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_copy_vue__ = __webpack_require__("Wh5d");
function injectStyle (ssrContext) {
  __webpack_require__("0PLB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5dc6165a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_copy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dc6165a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_copy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2IGi":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAPaSURBVFhH7ZbZUxNBEMbzJytHCEFLIXhwE4SEQxOU8sCAXIECy0IM8eIOAQxEboFwJaCij22+qepxZg/Ig8eDPnxQ6f169re7Pd3jOPv2nf6m/gNoAF/PvlH3sx56FRnXTL9TGkCou5suXc4TikbfaMaT088Ui8VpIDxIPn8LFbvd0gu5it3kb26l4ZHntLySpC9fz7R8O2kAieUVcha5NIjtnV2qraunvPwC7YYXqeTKVerp66PUwaF2Q6NMNWAF8WJ0VP6+dbuCGpv81NvXT/0DYalAMCjeAvtYiEWjr7V7qLIsQiuI+fk4ra9vmrxG7aX2aWp6hrwNDRpIk89P6cyJya8BnH7+QvVeL3X39AqIQmeRBqF6c9HE5FS2VkrkGtU1tSYICZA5OaW6eq80T8/M0uJSQoMYi0RkIvwLix9oc2tb7B6OG3VweCQeitcABHL5ugTo7AxJU2VllTRZQeCmRa6f39vpKqbWtjZaXVuTC6vKZJ/6dkWV9D96/EReEwDYNnzRU15Ox+mMtoAVxNT0tGln5BcUiriayzo8OqbSMo/wXc7LFw+BuABAVfOF5ZWPpmTICgJF+fbdBHU8fCjjKN6d3T3LNZYSy9Lnz/YSxBwg4eC9QMCUxEITAgSekv1qTUxOzcj4/Y4OLVdVS2ub9G1sbpEjFOqSAbtvCInG0ttH8fiCLUSjzydiqA+7wlz6kJC5aPuO0tIy8aOyqtoyAdpLHcikudi8LUR4cEjGUP3GdVg3b1UIT/mNm+TwZP/gR64A4fCQiFlBAI5/79u0YLwZLkb8d6DpcNJKctU2iTsjthMPGiuI0Zdj4nMZ12ChLbMfw8+xtb0jqh+B84oweP+BTOzt75fx2VhMg8Dc+JQdYGouC+DXrpdKLzaA2Ia8+HnbEIuq2zDQ3k7vJyZF37eCsFoDb4g9Pl+ziAkA7FteoMxjbkQsbDX1RiyM3Ysg0IjUp8esQVy2YoxXvlhVXaP1a1XJ1TWxl9F+2Y83k/y4KiDU7sgQ6UxGjHGOh7q65HoSADfEoGCT904jHR2npdEoFObGxqYYSCosPokRYnZuTv6urtEfTgJAGJUV2UHEZnfJFZGsenKRFcTw8Ahhy+/upTSvBgDhdfFsYDU0NtFMFgSHDaNfVTpbO2jZONRaQRj9kAmAFRmPkkv5ziy8lWCwXR7F7t4LiHNEodOp+Z50Ps0JwhYASu0fiP6PxqIufpGwnWtq60SNAIL7DGSEOBeAhQaC/oDv2NzSqh1GIBzRsa8HBgZFzRiPXegXDIF5oV7LCeBXCOcGTD9j/I8B2OlfB/hOPwDtho/wX7YojAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "2IMp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2MbT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isInitPermission)?_c('div',{staticClass:"transfer",attrs:{"id":"content"}},[_c('aaa'),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_c('uploader',{ref:"uploader",staticClass:"uploader-example",attrs:{"options":_vm.uploadOptions,"directory":_vm.directory,"file":_vm.file},on:{"upload-start":function($event){return _vm.uploadfileStart(_vm.file)},"file-progress":_vm.fileProgress,"file-success":_vm.fileSuccess,"file-error":_vm.fileError,"file-added":_vm.fileAdded,"file-complete":_vm.fileComplete}},[_c('uploader-btn',{attrs:{"attrs":_vm.attrs}})],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view',{staticClass:"content"})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2VMZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Constant__ = __webpack_require__("sMIb");








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    fileId: 'rootpath',
    fileComplete: false,
    fileList: {
      success: [],
      error: [],
      wait: []
    },
    progress: 0,
    isIphoneX: false
  },
  mutations: {
    changeId: function changeId(state, nweVal) {
      state.fileId = nweVal;
    },
    changeComplete: function changeComplete(state) {
      state.fileComplete = !state.fileComplete;
    },
    fileListPush: function fileListPush(state, obj) {
      var type = obj.type;
      var file = obj.file;
      file.progress = 0;
      type === 0 && state.fileList.wait.unshift(file);
      type === 1 && state.fileList.success.unshift(file);
      type === 2 && state.fileList.error.unshift(file);
    },
    fileListRemove: function fileListRemove(state, obj) {
      var type = obj.type;
      var file = obj.file;
      var list = void 0;
      type === 0 && (list = state.fileList.wait);
      type === 1 && (list = state.fileList.success);
      type === 2 && (list = state.fileList.error);
      list.forEach(function (i, key) {
        i.id === file.id && list.remove(key);
      });
    },

    // 上传中状态变更
    uploading: function uploading(state, data) {
      var newFile = null;
      var newIndex = -1;
      state.fileList.wait.some(function (file, index) {
        if (file.id === data.id) {
          newIndex = index;
          newFile = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(file, data);
          return true;
        }
        return false;
      });
      if (newIndex !== -1) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.fileList.wait, newIndex, newFile);
      }
    },

    // 设置current是否为iphoneX
    setSystemStatus: function setSystemStatus(state, isIphoneX) {
      state.isIphoneX = isIphoneX;
    },

    // 获取当前用户权限按钮信息列表
    SET_PERMISSION_BTN: function SET_PERMISSION_BTN(state, payload) {
      window.localStorage.setItem('permissionBtns', payload.join(__WEBPACK_IMPORTED_MODULE_6__utils_Constant__["a" /* routerSplitCharacter */]));
    }
  },
  actions: {
    getPermissionBtns: function getPermissionBtns(_ref, payload) {
      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_4__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_5__apis_cloudStorageApi__["a" /* default */].getPermissionBtn).then(function (res) {
          var array = [];
          res.data.forEach(function (item) {
            array.push(item.code);
          });
          commit('SET_PERMISSION_BTN', array);
          resolve(res.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }
}));

/***/ }),

/***/ "2nT8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backAndClose_vue__ = __webpack_require__("TRik");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0faba736_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backAndClose_vue__ = __webpack_require__("gawV");
function injectStyle (ssrContext) {
  __webpack_require__("5gDY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0faba736"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backAndClose_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0faba736_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backAndClose_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2qYx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2u6q":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3Jbd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "40PK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tabbar_vue__ = __webpack_require__("MTyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_tools__ = __webpack_require__("jt1B");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'transfer',
  data: function data() {
    return {
      delShow: null,
      fileList: {
        success: this.$store.state.fileList.success,
        error: this.$store.state.fileList.error,
        wait: this.$store.state.fileList.wait
      }
    };
  },

  props: [],
  methods: {
    // 滑动事件
    swipeleft: function swipeleft(index) {
      this.delShow = index;
    },
    // 同上
    swiperight: function swiperight(index) {
      this.delShow = '-';
    },
    // 删除文件记录或取消文件上传事件
    deleteFile: function deleteFile(file, type) {
      this.$store.commit('fileListRemove', { type: type, file: file });
      this.swiperight();
    },
    classObject: function classObject(val) {
      var type = this.sliceType(val);
      return 'icon-' + type;
    },

    sliceType: function sliceType(val) {
      if (val !== '' || val !== undefined) {
        var point = val.lastIndexOf('.');
        var type = val.substring(point + 1).toLowerCase();
        if (type === 'jpg' || type === 'gif' || type === 'JPG' || type === 'GIF' || type === 'png') {
          return 'pic';
        } else if (type === 'avi' || type === 'rmvb' || type === 'rm' || type === 'asf' || type === 'divx' || type === 'mpg' || type === 'mpeg' || type === 'mpe' || type === 'mp4' || type === 'mkv' || type === 'vob ') {
          return 'video';
        } else if (type === 'WAVE' || type === 'AIFF' || type === 'MPEG' || type === 'MP3' || type === 'MIDI' || type === 'mp3') {
          return 'muisc';
        } else if (type === 'txt') {
          return 'txt';
        } else if (type === 'pdf') {
          return 'pdf';
        } else if (type === 'doc' || type === 'docx') {
          return 'word';
        } else if (type === 'ppt' || type === 'pptx') {
          return 'ppt';
        } else if (type === 'xls' || type === 'xlsx') {
          return 'excel';
        } else if (type === 'html' || type === 'htm') {
          return 'html';
        } else if (type === 'wps' || type === 'wpt') {
          return 'wps';
        } else if (type === 'zip' || type === 'rar') {
          return 'package';
        } else {
          return 'default';
        }
      }
    },
    styleObject: function styleObject(val) {
      var type = this.sliceType(val);
      if (type === 'excel') {
        return 'excel';
      } else if (type === 'pdf') {
        return 'pdf';
      } else if (type === 'word') {
        return 'word';
      } else if (type === 'txt') {
        return 'txt';
      } else if (type === 'pic') {
        return 'pic';
      } else if (type === 'muisc') {
        return 'muisc';
      } else if (type === 'dir') {
        return 'dir';
      } else if (type === 'html') {
        return 'html';
      } else if (type === 'shareDir') {
        return 'shareDir1';
      } else {
        return 'weizhi';
      }
    }
  },
  created: function created() {
    console.log(this.fileList.success);
  },

  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0_mint_ui__["Navbar"],
    TabItem: __WEBPACK_IMPORTED_MODULE_0_mint_ui__["TabItem"],
    tabbar: __WEBPACK_IMPORTED_MODULE_1__components_tabbar_vue__["a" /* default */],
    sliceName: __WEBPACK_IMPORTED_MODULE_2__assets_js_tools__["d" /* sliceName */]
  },
  filters: {
    bytesToSize: function bytesToSize(bytes) {
      if (bytes === 0) return '0 B';
      if (bytes === '') return '';
      var k = 1024;
      var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return (bytes / Math.pow(k, i)).toPrecision(3) + sizes[i];
    },
    formatTime: function formatTime(val) {
      if (val !== '' || undefined || null) {
        return new Date(val).format('yyyy-MM-dd HH:mm');
      } else {
        return '';
      }
    },
    sliceNameF: function sliceNameF(val) {
      return val;
      // return sliceName(val, 10)
    }
  }
});

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ "4ZNh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_vue__ = __webpack_require__("i3p+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f5b079c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_vue__ = __webpack_require__("vnB+");
function injectStyle (ssrContext) {
  __webpack_require__("1j6G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f5b079c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f5b079c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4qZy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_setinfo_vue__ = __webpack_require__("cJ/I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7c0a7b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_setinfo_vue__ = __webpack_require__("BXMr");
function injectStyle (ssrContext) {
  __webpack_require__("2qYx")
  __webpack_require__("HJqF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7c0a7b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_setinfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7c0a7b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_setinfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4tMn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_acceptcode_vue__ = __webpack_require__("EZMy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_243ff435_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_acceptcode_vue__ = __webpack_require__("9ayY");
function injectStyle (ssrContext) {
  __webpack_require__("68l/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-243ff435"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_acceptcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_243ff435_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_acceptcode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "5gDY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "63ih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clipboard__ = __webpack_require__("V33R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tabbar_vue__ = __webpack_require__("MTyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__install_vue__ = __webpack_require__("zUEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_addmember__ = __webpack_require__("KoGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_share_vue__ = __webpack_require__("Eg0l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_copy_vue__ = __webpack_require__("2DrX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_download_js__ = __webpack_require__("AuSF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_image_lightbox__ = __webpack_require__("wOxb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_image_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_image_lightbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_methods__ = __webpack_require__("ilG3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_event_bus__ = __webpack_require__("evg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_js_permission__ = __webpack_require__("mHay");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















__webpack_require__("NV5O");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shareIndex',
  components: {
    tabbar: __WEBPACK_IMPORTED_MODULE_6__components_tabbar_vue__["a" /* default */],
    install: __WEBPACK_IMPORTED_MODULE_7__install_vue__["a" /* default */],
    addmember: __WEBPACK_IMPORTED_MODULE_8__components_addmember__["a" /* default */],
    MessageBox: __WEBPACK_IMPORTED_MODULE_3_mint_ui__["MessageBox"],
    Popup: __WEBPACK_IMPORTED_MODULE_3_mint_ui__["Popup"],
    Lightbox: __WEBPACK_IMPORTED_MODULE_12_vue_image_lightbox___default.a,
    share: __WEBPACK_IMPORTED_MODULE_9__components_share_vue__["a" /* default */],
    copy: __WEBPACK_IMPORTED_MODULE_10__components_copy_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isIphoneX: false,
      mark: 1, // 1 为list， 2为search
      dataList: [],
      indexing: null, // 正在操作的文件索引
      LvType: 4,
      addType: '',
      headShow: true,
      triggerAddMember: false,
      //        搜索
      isSearch: false,
      isClose: false,
      value: '',
      file: '',
      FileModalshow: false,
      FileModalHtml: '',
      uploadOptions: {
        singleFile: true,
        testChunks: false,
        uploadMethod: 'POST',
        target: __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].app.cloudStorage.baseUrl + '/api/file/simpleUpload',
        testMethod: 'POST',
        preprocess: this.preprocess,
        withCredentials: true,
        query: {
          guid: '',
          dirId: '',
          size: '',
          type: '',
          name: ''
        }
      },
      attrs: {
        uploadMethod: 'POST',
        accept: '*',
        testMethod: 'POST'
      },
      imgArray: [],
      whenId: 'rootpath',
      //        imgArray: [],
      message: __WEBPACK_IMPORTED_MODULE_4__apis_cloudStorageApi__["a" /* default */].shareFiles,
      moveShare: true,
      tab: 1,
      opacity: true,
      up: '',
      //        查看历史版本
      //        全选反选数据
      fs: false,
      //        共享参数
      //        当前共享文件夹的id
      shareFile: true,
      sharePid: '',
      shareParentId: [],
      shareFileIds: '',
      shareTarget: false,
      shareIndex: '共享文件',
      //        移动成功后重新加载数据的pid
      movePid: '',
      //        复制移动
      model: '复制',
      //        控制复制移动页面的弹出
      move: false,
      //        待复制和移动文件的id
      copyfileId: [],
      copyparam: {
        page: 0,
        size: 20
      },
      copyPage: '',
      copySize: '',
      //        点击复制移动时记住之前的页面数据
      copyArr: [],
      copyIndex: '',
      copyParentId: [],
      copyId: '',
      //        分享
      currentValue: false,
      shareVisible: false,
      //        删除
      delVisible: false,
      delaction: [{
        name: '确认删除',
        method: this.delate
      }],
      //        删除
      //        添加
      sheetVisible: false,
      //        更多
      sheet: false,
      actionList: [{
        name: '加入收藏',
        method: this.collect
      }, {
        name: '重命名',
        method: this.rename
      }],
      action: [],
      sheetson: false,
      actionSonList: [{
        name: '加入收藏',
        method: this.collect
      }, {
        name: '移动到',
        method: this.moveFile
      }, {
        name: '复制到',
        method: this.copy
      }, {
        name: '重命名',
        method: this.rename
      }],
      actionson: [],
      select: '',
      flag: false,
      //        正在操作的文件权限
      activeLvType: 0,
      index: '共享文件',
      indexs: '共享文件',
      //        存储所有文件的数组
      hello: [],
      //        删除文件的id
      delArr: [],
      //        需要操作的文件id
      fileId: '',
      //        控制全选反选和选择添加的显示隐藏
      isA: false,
      //        控制文件被是否被选中
      isB: false,
      pid: '',
      //        返回上一级文件夹所需id
      parentId: [],
      check: '全选',
      info: {
        page: 0,
        size: 20
      },
      page: 0,
      size: 20,
      totalPages: '',
      fileName: '',
      isFavorite: 0
    };
  },

  computed: {
    classType: function classType() {
      return {
        noclick: !this.operaPermissionJudge(this.LvType, '新建文件夹')
      };
    },
    uploadClass: function uploadClass() {
      return {
        noclick: !this.operaPermissionJudge(this.LvType, '上传') || !this.$customFunctions.checkPermission('upload')
      };
    }
  },
  created: function created() {
    var _this2 = this;

    var isx = this.$store.state.isIphoneX;
    this.isIphoneX = isx;
    __WEBPACK_IMPORTED_MODULE_16__utils_event_bus__["a" /* eventBus */].$on('initShareData', function () {
      __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_4__apis_cloudStorageApi__["a" /* default */].shareFiles, { fileId: _this2.sharePid, page: 0, size: 20 }).then(function (response) {
        _this2.hello = response.data.content;
        console.log('------');
        console.log(_this2.hello);
      });
    });
    var collect = this.$route.params;
    console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(collect));
    if (collect.length > 0) {
      this.shareIndex = collect[collect.length - 1];
      this.indexs = collect[collect.length - 1];
      this.sharePid = collect[collect.length - 2].pid;
      collect.pop();
      collect.pop();
      this.shareParentId = collect;
      this.whenId = this.sharePid;
      __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_4__apis_cloudStorageApi__["a" /* default */].shareFiles, { fileId: this.sharePid, page: 0, size: 20 }).then(function (response) {
        var data = response.data.content;
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            _this2.hello.push(data[i]);
            console.log(data[i]);
          }
        }
        return false;
      }).catch(function (error) {});
    } else {
      this.$store.commit('changeId', window.localStorage.getItem('sharePid'));
      if (window.localStorage.getItem('sharePid')) {
        this.sharePid = window.localStorage.getItem('sharePid');
        this.index = window.localStorage.getItem('shareIndex');
        this.indexs = window.localStorage.getItem('shareIndex');
        this.shareIndex = window.localStorage.getItem('shareIndex');
        this.shareParentId = JSON.parse(window.localStorage.getItem('shareParentId'));
        this.LvType = window.localStorage.getItem('lvType');
      }
      this.load();
    }
    this.slicetype = __WEBPACK_IMPORTED_MODULE_15_vue__["default"].filter('sliceType');
  },

  methods: {
    operaPermissionJudge: __WEBPACK_IMPORTED_MODULE_17__assets_js_permission__["a" /* default */].operaPermissionJudge,
    test: function test(val) {
      var _this3 = this;

      if (val.noclick) {
        return;
      }
      this.$store.dispatch('getPermissionBtns').then(function () {
        if (!_this3.$customFunctions.checkPermission('upload')) {
          Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
            message: '您没有权限进行此操作!',
            duration: 2000,
            iconClass: 'icon-error'
          });
        } else {
          var usedSize = JSON.parse(window.sessionStorage.mobileData).usedSize;
          var quota = JSON.parse(window.sessionStorage.mobileData).quota;
          if (usedSize < quota) {
            _this3.sheetVisible = false;
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_14_jquery___default()('.uploader-btn').click();
            });
          } else {
            Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
              message: '存储空间不足',
              duration: 5000
            });
          }
        }
      });
    },
    confirmOperation: function confirmOperation(userIds) {
      var _this = this;
      var userParm = {
        fileId: _this.fileId,
        userIds: userIds.toString(),
        permissionType: _this.addType
      };
      __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_4__apis_cloudStorageApi__["a" /* default */].addUser, userParm).then(function (response) {
        Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
          message: '成员添加成功',
          iconClass: 'icon-success'
        });
        _this.headShow = false;
        _this.triggerAddMember = false;
        _this.fs = true;
        return false;
      }).catch(function () {
        Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
          message: '成员添加失败',
          iconClass: 'icon-error'
        });
      });
    },
    cancelOperation: function cancelOperation() {
      this.fs = true;
      this.headShow = false;
      // 关掉二级页面
      this.triggerAddMember = false;
    },

    listenToMyBoy: function listenToMyBoy(somedata) {
      this.fs = somedata;
      this.headShow = true;
    },
    listenToShare: function listenToShare(somedata) {
      var _this = this;
      _this.currentValue = somedata;
    },
    listenToCopy: function listenToCopy(somedata) {
      this.move = somedata;
      this.restore();
    },
    listenToMove: function listenToMove(somedata) {
      var _this = this;
      _this.move = false;
      var deleteArr = somedata.split(',');
      for (var i = 0; i < deleteArr.length; i++) {
        _this.hello.removeByValue(deleteArr[i]);
      }
      _this.restore();
    },
    //      复制到
    copy: function copy() {
      this.model = '复制 (' + this.copyfileId.length + ')';
      this.move = true;
    },
    //      移动到
    moveFile: function moveFile() {
      this.model = '移动 (' + this.copyfileId.length + ')';
      this.move = true;
    },
    //      点击返回上一级目录
    back: function back() {
      var _this = this;
      var length = _this.shareParentId.length - 1;
      var fileId = this.whenId = _this.shareParentId[length].pid;
      this.LvType = _this.shareParentId[length].LvType;
      __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_4__apis_cloudStorageApi__["a" /* default */].shareFiles, { fileId: fileId, page: 0, size: 20 }).then(function (res) {
        _this.copyPage = 0;
        _this.shareIndex = _this.shareParentId[length].index;
        _this.pid = fileId;
        _this.shareFileIds = fileId;
        _this.sharePid = fileId;
        if (!_this.move) {
          window.localStorage.setItem('shareIndex', _this.shareParentId[length].index);
          window.localStorage.setItem('sharePid', _this.shareParentId[length].pid);
          _this.shareParentId.pop();
          var parentArr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.shareParentId);
          window.localStorage.setItem('shareParentId', parentArr);
          window.localStorage.setItem('lvType', _this.LvType);
        } else {
          _this.shareParentId.pop();
        }
        _this.hello = res.data.content;
        _this.restore();
      }).catch(function (res) {});
    },
    //      点击进入下一级目录
    next: function next(index, fileName, isDir, LvType) {
      var _this = this;
      if (isDir === 1) {
        this.whenId = index;
        this.LvType = LvType;
        var ulBox = _this.$refs.ulBox;
        //            共享文件夹的下一级
        _this.isSearch = false;
        ulBox.scrollTop = 0;
        _this.copyPage = 0;
        __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_4__apis_cloudStorageApi__["a" /* default */].shareFiles, { fileId: index, page: 0, size: 20 }).then(function (res) {
          ulBox.scrollTop = 0;
          if (_this.shareIndex === '共享文件') {
            _this.shareParentId = [{ pid: '', index: '共享文件', LvType: 4 }];
          } else {
            _this.shareParentId.push({ pid: _this.sharePid, index: _this.shareIndex, LvType: LvType });
          }
          _this.sharePid = index;
          _this.shareFileIds = index;
          _this.shareIndex = fileName;
          if (!_this.move) {
            window.localStorage.setItem('shareIndex', fileName);
            window.localStorage.setItem('sharePid', index);
            var parentArr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.shareParentId);
            window.localStorage.setItem('shareParentId', parentArr);
            window.localStorage.setItem('lvType', _this.LvType);
          }
          _this.hello = res.data.content;
          ulBox.scrollTop = 0;
          _this.restore();
        }).catch(function (res) {});
      } else {
        if (this.operaPermissionJudge(LvType, '预览')) {
          _this.filePreview.apply(_this, arguments);
        }
      }
    },
    //      点击选择多个文件
    checkMobile: function checkMobile() {
      this.sheetVisible = false;
      this.flag ? this.flag = false : this.flag = true;
      this.isA ? this.isA = false : this.isA = true;
      this.select = '';
    },
    //      单个文件重命名
    rename: function rename() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_13__components_methods__["a" /* default */].rename(_this);
    },
    //      单个文件加入收藏
    collect: function collect() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_13__components_methods__["a" /* default */].collect(_this);
    },
    //      还原
    restore: function restore() {
      this.up = '';
      this.uph = '';
      this.hselect = '';
      this.opacity = true;
      this.select = '';
      this.check = '全选';
      this.isA = false;
      this.isB = false;
      this.delArr = [];
      this.fileId = '';
      this.index = this.indexs;
      this.flag = false;
      this.currentValue = false;
      this.page = 0;
      this.size = 20;
      this.info = {
        page: 0,
        size: 20
      };
      var checkbox = this.$refs.mybox;
      for (var i = 0; i < checkbox.length; i++) {
        checkbox[i].setAttribute('class', 'check');
      }
    },
    //      删除
    delate: function delate() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_13__components_methods__["a" /* default */].del(_this, 2);
    },
    //      删除多个文件
    delActions: function delActions(type) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_13__components_methods__["a" /* default */].delActions(_this, type);
    },
    //      删除单个文件
    delAction: function delAction(itemId, type, lvType, isDir, isLove, name, index) {
      if (!this.operaPermissionJudge(lvType, type)) {
        return;
      }
      this.fileId = itemId;
      if (type === '删除') {
        this.delArr = [itemId];
        this.delVisible = true;
      } else if (type === '分享') {
        this.currentValue = true;
      } else if (type === '更多') {
        if (this.shareParentId.length === 0) {
          this.sheet = true;
          this.moreOperaPermissonFilter(lvType, this.actionList, this.action);
        } else {
          this.moreOperaPermissonFilter(lvType, this.actionSonList, this.actionson);
          this.sheetson = true;
        }
        this.activeLvType = lvType;
        this.indexing = index;
        this.copyfileId = [itemId];
        this.fileName = name;
        this.isFavorite = isLove;
      } else if (type === '设置') {
        this.fs = true;
        this.headShow = false;
      }
    },
    //      下拉操作
    selected: function selected(index) {
      if (this.select === index) {
        this.select = '';
        this.up = '';
      } else {
        this.select = index;
        this.up = index;
      }
    },
    //      新建文件夹
    prompt: function prompt() {
      var _this = this;
      if (!this.operaPermissionJudge(this.LvType, '新建文件夹')) {
        return;
      }
      _this.sheetVisible = false;
      __WEBPACK_IMPORTED_MODULE_13__components_methods__["a" /* default */].prompt(_this, '共享文件');
    },
    //      单个文件选中
    checked: function checked(index) {
      var length = this.hello.length;
      var _this = this;
      var num = this.$refs.mybox[index].className.indexOf('checked');
      var checkbox = this.$refs.mybox;
      var flag = 0;
      if (num === -1) {
        var className = this.$refs.mybox[index].getAttribute('class');
        checkbox[index].setAttribute('class', className + ' ' + 'checked');
        for (var i = 0; i < checkbox.length; i++) {
          if (checkbox[i].className.indexOf('checked') !== -1) {
            flag++;
          }
        }
        if (flag > 0) {
          _this.shareIndex = '\u5DF2\u9009\u62E9' + flag + '\u4E2A\u6587\u4EF6';
          _this.opacity = false;
        }
        if (flag === length) {
          _this.checkAll();
        }
      } else {
        _this.opacity = true;
        checkbox[index].setAttribute('class', 'check');
        for (var _i = 0; _i < checkbox.length; _i++) {
          if (checkbox[_i].className.indexOf('checked') !== -1) {
            flag++;
          }
        }
        if (flag > 0) {
          _this.shareIndex = '\u5DF2\u9009\u62E9' + flag + '\u4E2A\u6587\u4EF6';
          _this.opacity = false;
        } else {
          _this.shareIndex = _this.indexs;
        }
        if (flag === 0) {
          if (_this.check === '取消全选') {
            _this.checkAll();
          }
        }
      }
    },
    //      全选
    checkAll: function checkAll() {
      var _this = this;
      if (_this.hello.length === 0) {
        return false;
      }
      if (!this.isB) {
        this.isB = true;
        this.check = '取消全选';
        this.opacity = false;
        var checkbox = this.$refs.mybox.length;
        _this.shareIndex = '\u5DF2\u9009\u62E9' + checkbox + '\u4E2A\u6587\u4EF6';
        var box = this.$refs.mybox;
        var arr = '';
        for (var i = 0; i < box.length; i++) {
          arr += box[i].getAttribute('fileId') + ',';
        }
        arr = arr.substring(0, arr.length - 1);
        _this.delArr = arr.split(',');
        _this.fileId = arr;
      } else {
        this.isB = false;
        this.check = '全选';
        this.opacity = true;
        _this.shareIndex = _this.indexs;
      }
    },
    //      取消选中状态
    cancel: function cancel() {
      this.shareIndex = this.indexs;
      this.check = '全选';
      this.isB = false;
      this.fileId = '';
      this.select = '';
      this.up = '';
      this.opacity = true;
      this.isA ? this.isA = false : this.isA = true;
      var checkbox = this.$refs.mybox;
      for (var i = 0; i < checkbox.length; i++) {
        checkbox[i].setAttribute('class', 'check');
      }
    },
    load: function load() {
      var _this4 = this;

      this.page = 0;
      __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_4__apis_cloudStorageApi__["a" /* default */].shareFiles, { fileId: this.sharePid, page: 0, size: 20 }).then(function (response) {
        var data = response.data.content;
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            _this4.hello.push(data[i]);
          }
          _this4.totalPages = response.data.totalPages;
          console.log(_this4.hello);
        }
        return false;
      }).catch(function (error) {});
    },
    loadMore: function loadMore() {
      var _this5 = this;

      if (this.mark === 1) {
        this.loading = true;
        setTimeout(function () {
          var _this = _this5;
          if (_this.page < _this.totalPages) {
            _this.page++;
          }
          __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_4__apis_cloudStorageApi__["a" /* default */].shareFiles, {
            fileId: _this.sharePid,
            page: _this.page,
            size: _this.size
          }).then(function (res) {
            var list0 = [];
            var data = res.data.content;
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                list0.push(data[i]);
              }
              if (_this.hello && list0) {
                _this.hello = _this.hello.concat(list0);
              }
            }
          });
          _this5.loading = false;
        }, 250);
      } else {
        this.loading = true;
        setTimeout(function () {
          var _this = _this5;
          if (_this.page < _this.totalPages) {
            _this.page++;
          }
          __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_4__apis_cloudStorageApi__["a" /* default */].shareSearch, {
            key: _this.value,
            page: _this.page,
            size: _this.size
          }).then(function (res) {
            var list0 = [];
            var data = res.data.content;
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                list0.push(data[i]);
              }
              if (_this.hello && list0) {
                _this.hello = _this.hello.concat(list0);
              }
            }
          });
          _this5.loading = false;
        }, 250);
      }
    },

    moveScroll: function moveScroll() {
      var _this6 = this;

      var _this = this;
      var ulBox = _this.$refs.moveBox;
      if (ulBox.scrollTop + ulBox.clientHeight >= ulBox.scrollHeight) {
        if (_this.shareTarget) {
          _this.page++;
          __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_4__apis_cloudStorageApi__["a" /* default */].searchFile, {
            fileId: _this.pid,
            page: _this.page,
            size: _this.size
          }).then(function (response) {
            var data = response.data.content;
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                _this6.hello.push(data[i]);
              }
            }
            return false;
          }).catch(function (error) {});
        } else {
          _this.copyPage++;
          __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].request(_this.message, {
            fileId: _this.sharePid,
            page: _this.copyPage,
            size: 20
          }).then(function (response) {
            var data = response.data.content;
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                _this6.hello.push(data[i]);
              }
            }
            return false;
          }).catch(function (error) {});
        }
      }
    },
    // 文件下载操作
    downLoad: function downLoad() {
      Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])('文件正在下载...');
      __WEBPACK_IMPORTED_MODULE_11__components_download_js__["a" /* downLoadFile */].apply(undefined, arguments);
    },
    // 文件上传监听
    uploadfileStart: function uploadfileStart() {
      var file = uploader.files[0];
      this.uploadOptions.query.guid = file.uniqueIdentifier;
      this.uploadOptions.query.type = file.fileType;
      this.uploadOptions.query.size = file.size;
      this.uploadOptions.query.dirId = this.whenId;
      this.uploadOptions.query.lastModifiedDate = file.file.lastModifiedDate;
      this.uploadOptions.query.name = file.name;
      __WEBPACK_IMPORTED_MODULE_3_mint_ui__["Indicator"].open({
        text: '文件正在上传请稍后...',
        spinnerType: 'fading-circle'
      });
    },
    fileAdded: function fileAdded(file, e) {},
    filePreview: function filePreview() {
      var _this7 = this,
          _arguments = arguments;

      var _this = this;
      this.$store.dispatch('getPermissionBtns').then(function () {
        if (!_this7.$customFunctions.checkPermission('preview')) {
          Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
            message: '您没有权限进行此操作!',
            duration: 2000,
            iconClass: 'icon-error'
          });
        } else {
          _this7.imgArray = [];
          for (var i = 0; i < _this.hello.length; i++) {
            if (_this.slicetype(_this.hello[i].fileName) === 'icon-pic') {
              _this.hello[i].thumb = __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].app.cloudStorage.baseUrl + __WEBPACK_IMPORTED_MODULE_4__apis_cloudStorageApi__["a" /* default */].unifileD.path + '?fileId=' + _this.hello[i].id + '&type=2';
              _this.hello[i].src = __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].app.cloudStorage.baseUrl + __WEBPACK_IMPORTED_MODULE_4__apis_cloudStorageApi__["a" /* default */].unifileD.path + '?fileId=' + _this.hello[i].id + '&type=2';
              var obj = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.hello[i]));
              _this.imgArray.push(obj);
            }
          }
          if (_this7.slicetype(_arguments[1]) === 'icon-pic') {
            var idx = '';
            _this.imgArray.forEach(function (value, index) {
              if (value.fileName === _arguments[1]) {
                idx = index;
              }
            });
            _this7.$refs.lightbox.showImage(idx);
          } else {
            var list = ['txt', 'doc', 'docx', 'xlsx', 'xls', 'pdf', 'wps', 'wpt', 'xls', 'pptx', 'ppt'];
            var fileType = _arguments[1].lastIndexOf('.');
            var type = _arguments[1].substring(fileType + 1).trim();
            if (list.indexOf(type) !== -1) {
              __WEBPACK_IMPORTED_MODULE_3_mint_ui__["Indicator"].open('加载中...');
              __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_4__apis_cloudStorageApi__["a" /* default */].preview, { fileId: _arguments[0] }).then(function (response) {
                if (!response.data.code) {
                  __WEBPACK_IMPORTED_MODULE_3_mint_ui__["Indicator"].close();
                  _this.FileModalshow = true;
                  _this.FileModalHtml = response.data.text;
                } else {
                  __WEBPACK_IMPORTED_MODULE_3_mint_ui__["Indicator"].close();
                  Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
                    message: '您选择的文件,正在预览处理中。请稍后再进行预览！',
                    // position: 'bottom',
                    duration: 5000
                  });
                }
              }).catch(function (error) {
                Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
                  message: '预览文件失败,请稍后重试',
                  position: 'bottom',
                  duration: 5000
                });
              });
            } else {
              Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
                message: '当前文件格式暂不支持预览',
                iconClass: 'icon-error'
              });
            }
          }
        }
      });
    },
    search: function search() {
      this.isSearch = true;
    },
    serchContent: function serchContent() {
      var _this = this;
      if (_this.value !== '') {
        //          _this.isA = false
        _this.mark = 2;
        _this.page = 0;
        _this.hello = [];
        __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_4__apis_cloudStorageApi__["a" /* default */].shareSearch, {
          key: _this.value,
          page: _this.page,
          size: _this.size
        }).then(function (res) {
          var data = res.data.content;
          _this.totalPages = res.data.totalPages;
          console.log(res.data.totalPages);
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              if (data[i].fileName.length > _this.maxLen) {
                data[i].fileName = data[i].fileName.substring(0, _this.maxLen) + '...';
              }
              _this.hello.push(data[i]);
            }
          } else {
            _this.$refs.dis.innerText = '未搜索到相关文件/文件夹';
          }
        });
      } else {
        _this.mark = 1;
        _this.hello = [];
        _this.load();
      }
    },
    cancelSearch: function cancelSearch() {
      this.isSearch = false;
      this.value = '';
      this.mark = 1;
      this.load();
      this.hello = [];
    },
    focusInput: function focusInput() {
      this.isClose = true;
    },
    blurInput: function blurInput() {
      if (this.value !== '') {
        this.isClose = true;
      } else {
        this.isClose = false;
      }
    },
    clear: function clear() {
      if (this.value !== '') {
        this.value = '';
        this.hello = [];
        this.load();
      }
    },
    add: function add(val, dataList) {
      this.fs = false;
      // this.headShow = true
      this.addType = val;
      this.dataList = dataList;
      // 打开二层页面
      this.triggerAddMember = true;
    },
    moreOperaPermissonFilter: function moreOperaPermissonFilter(lvType, actionList, targetList) {
      var _this8 = this;

      targetList.length = 0;
      actionList.forEach(function (action) {
        if (_this8.operaPermissionJudge(lvType, action.name)) {
          targetList.push(action);
        }
      });
    }
  },
  watch: {
    whenId: function whenId(val) {
      this.$store.commit('changeId', val);
    },
    LvType: function LvType(val) {},
    shareParentId: function shareParentId(val) {
      if (val.length === 0) {
        this.LvType = 4;
      }
    }
  }
});

/***/ }),

/***/ "68l/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "78am":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7hmw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7pjy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "9W5b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard__ = __webpack_require__("V33R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tabbar_vue__ = __webpack_require__("MTyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_history_vue__ = __webpack_require__("gdx1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_share_vue__ = __webpack_require__("Eg0l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_copy_vue__ = __webpack_require__("2DrX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_download_js__ = __webpack_require__("AuSF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_image_lightbox__ = __webpack_require__("wOxb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_image_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_image_lightbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_methods__ = __webpack_require__("ilG3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_event_bus__ = __webpack_require__("evg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_backAndClose_vue__ = __webpack_require__("2nT8");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















__webpack_require__("NV5O");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'index',
  components: {
    tabbar: __WEBPACK_IMPORTED_MODULE_5__components_tabbar_vue__["a" /* default */],
    downLoadFile: __WEBPACK_IMPORTED_MODULE_9__components_download_js__["a" /* downLoadFile */],
    Popup: __WEBPACK_IMPORTED_MODULE_2_mint_ui__["Popup"],
    Lightbox: __WEBPACK_IMPORTED_MODULE_10_vue_image_lightbox___default.a,
    history: __WEBPACK_IMPORTED_MODULE_6__components_history_vue__["a" /* default */],
    share: __WEBPACK_IMPORTED_MODULE_7__components_share_vue__["a" /* default */],
    copy: __WEBPACK_IMPORTED_MODULE_8__components_copy_vue__["a" /* default */],
    aaa: __WEBPACK_IMPORTED_MODULE_15__components_backAndClose_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isIphoneX: false,
      mark: 1, // 1为list， 2 为search
      shareFile: false,
      isSearch: false,
      isClose: false,
      value: '',
      file: '',
      loading: 0,
      loadings: 0,
      FileModalshow: false,
      FileModalHtml: '',
      uploadOptions: {
        singleFile: true,
        testChunks: false,
        uploadMethod: 'POST',
        target: __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].app.cloudStorage.baseUrl + '/api/file/simpleUpload',
        testMethod: 'POST',
        preprocess: this.preprocess,
        withCredentials: true,
        query: {
          guid: '',
          dirId: '',
          size: '',
          type: '',
          name: ''
        }
      },
      attrs: {
        uploadMethod: 'POST',
        accept: '*',
        testMethod: 'POST'
      },
      imgArray: [],
      //        确认是否收藏
      isFavorite: 0,
      tab: 1,
      hisFlag: false,
      opacity: true,
      up: '',
      //        查看历史版本
      //        全选反选数据
      ish: false,
      //        其他
      history: false,
      fs: false,
      actionh: [{
        name: '加入收藏',
        method: this.collect
      }, {
        name: '移动到',
        method: this.moveFile
      }, {
        name: '复制到',
        method: this.copy
      }, {
        name: '重命名',
        method: this.rename
      }, {
        name: '查看历史版本',
        method: this.clickFn
      }],
      //        当前共享文件夹的id
      sharePid: '',
      shareParentId: [],
      shareFileIds: '',
      shareTarget: true,
      shareIndex: '共享文件',
      //        移动成功后重新加载数据的pid
      movePid: '',
      //        复制移动
      model: '复制',
      //        控制复制移动页面的弹出
      move: false,
      //        待复制和移动文件的id
      copyfileId: [],
      copyparam: {
        page: 0,
        size: 20
      },
      copyPage: '',
      copySize: '',
      //        点击复制移动时记住之前的页面数据
      copyArr: [],
      copyIndex: '',
      copyParentId: [],
      copyId: '',
      //        分享
      currentValue: false,
      shareVisible: false,
      //        删除
      delVisible: false,
      delaction: [{
        name: '确认删除',
        method: this.delate
      }],
      //        添加
      sheetVisible: false,
      //        更多
      sheet: false,
      action: [{
        name: '加入收藏',
        method: this.collect
      }, {
        name: '移动到',
        method: this.moveFile
      }, {
        name: '复制到',
        method: this.copy
      }, {
        name: '重命名',
        method: this.rename
      }],
      select: '',
      flag: false,
      //        正在操作的文件索引
      indexing: 0,
      index: '个人文件',
      indexs: '个人文件',
      //        存储所有文件的数组
      hello: [],
      //        删除文件的id
      delArr: [],
      //        需要操作的文件id
      fileId: '',
      //        控制全选反选和选择添加的显示隐藏
      isA: false,
      //        控制文件被是否被选中
      isB: false,
      message: __WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].searchFile,
      pid: 'rootpath',
      //        返回上一级文件夹所需id
      parentId: [],
      check: '全选',
      whenId: 'rootpath',
      page: 0,
      size: 20,
      totalPages: '',
      fileName: '',
      inputVlaue: ''
    };
  },

  computed: {
    isCanUpload: function isCanUpload() {
      return this.$customFunctions.checkPermission('upload');
    },
    isCanDownload: function isCanDownload() {
      return this.$customFunctions.checkPermission('download');
    }
  },
  created: function created() {
    var _this2 = this;

    var isx = this.$store.state.isIphoneX;
    this.isIphoneX = isx;
    __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].show).then(function (res) {
      window.sessionStorage.mobileData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data);
    });
    __WEBPACK_IMPORTED_MODULE_14__utils_event_bus__["a" /* eventBus */].$on('initFileData', function () {
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(_this2.message, { fileId: _this2.pid, page: 0, size: 20 }).then(function (response) {
        _this2.hello = response.data.content;
      });
    });
    var collect = this.$route.params;
    if (collect.length > 0) {
      this.index = collect[collect.length - 1];
      this.indexs = collect[collect.length - 1];
      this.pid = collect[collect.length - 2].pid;
      collect.pop();
      collect.pop();
      this.parentId = collect;
      this.whenId = this.pid;
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(this.message, { fileId: this.pid, page: 0, size: 20 }).then(function (response) {
        var data = response.data.content;
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            _this2.hello.push(data[i]);
          }
        }
        return false;
      }).catch(function (error) {
        this.$store.commit('changeId', 'rootpath');
      });
    } else {
      this.$store.commit('changeId', window.localStorage.getItem('pid') || 'rootpath');
      if (window.localStorage.getItem('pid')) {
        this.pid = window.localStorage.getItem('pid');
        this.index = window.localStorage.getItem('index');
        this.indexs = window.localStorage.getItem('index');
        this.parentId = JSON.parse(window.localStorage.getItem('parentId'));
      }
      this.load();
    }
    this.slicetype = __WEBPACK_IMPORTED_MODULE_12_vue__["default"].filter('sliceType');
  },

  methods: {
    test: function test() {
      var _this3 = this;

      this.$store.dispatch('getPermissionBtns').then(function () {
        if (!_this3.$customFunctions.checkPermission('upload')) {
          Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
            message: '您没有权限进行此操作!',
            duration: 2000,
            iconClass: 'icon-error'
          });
        } else {
          var usedSize = JSON.parse(window.sessionStorage.mobileData).usedSize;
          var quota = JSON.parse(window.sessionStorage.mobileData).quota;
          if (usedSize < quota) {
            _this3.sheetVisible = false;
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_11_jquery___default()('.uploader-btn').click();
            });
          } else {
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: '存储空间不足',
              duration: 5000
            });
          }
        }
      });
    },
    uploadNewFile: function uploadNewFile(val, val2, val3) {
      __WEBPACK_IMPORTED_MODULE_11_jquery___default()('.btnuploader-btn').click();
    },

    closeModal: function closeModal() {
      this.FileModalshow = false;
    },
    //      点击查看历史版本
    clickFn: function clickFn() {
      this.fs = true;
    },
    listenToHistory: function listenToHistory(somedata) {
      this.fs = somedata;
    },
    listenToShare: function listenToShare(somedata) {
      this.currentValue = somedata;
    },
    listenToCopy: function listenToCopy(somedata) {
      this.move = somedata;
      this.restore();
      this.hello = [];
      this.load();
    },
    listenToMove: function listenToMove(somedata) {
      var _this = this;
      _this.move = false;
      var deleteArr = somedata.split(',');
      for (var i = 0; i < deleteArr.length; i++) {
        _this.hello.removeByValue(deleteArr[i]);
      }
      _this.restore();
      this.hello = [];
      this.load();
    },
    //      复制到
    copy: function copy() {
      this.model = '复制 (' + this.copyfileId.length + ')';
      this.move = true;
    },
    //      移动到
    moveFile: function moveFile() {
      this.model = '移动 (' + this.copyfileId.length + ')';
      this.move = true;
    },
    //      点击返回上一级目录
    back: function back() {
      var _this = this;
      var length = _this.parentId.length - 1;
      var fileId = _this.parentId[length].pid;
      _this.whenId = fileId;
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].searchFile, { fileId: fileId, page: 0, size: 20 }).then(function (res) {
        _this.index = _this.parentId[length].index;
        _this.indexs = _this.parentId[length].index;
        _this.pid = fileId;
        if (!_this.move) {
          window.localStorage.setItem('index', _this.parentId[length].index);
          window.localStorage.setItem('pid', _this.parentId[length].pid);
          _this.parentId.pop();
          var parentArr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.parentId);
          window.localStorage.setItem('parentId', parentArr);
        } else {
          _this.parentId.pop();
        }
        _this.hello = res.data.content;
        if (_this.parentId.length === 0) {
          _this.person = false;
          _this.share = false;
          _this.kind = false;
          _this.shareFileIds = '';
        }
        _this.restore();
      }).catch(function (res) {});
    },
    //      点击进入下一级目录
    next: function next(index, fileName, isDir) {
      var _this = this;
      if (isDir === 1) {
        this.whenId = index;
        var ulBox = _this.$refs.ulBox;
        //           搜索框
        _this.isSearch = false;
        ulBox.scrollTop = 0;
        __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].searchFile, { fileId: index, page: 0, size: 20 }).then(function (res) {
          _this.hello = [];
          ulBox.scrollTop = 0;
          if (_this.pid === 'rootpath') {
            _this.parentId = [{ pid: 'rootpath', index: '个人文件' }];
          } else {
            _this.parentId.push({ pid: _this.pid, index: _this.index });
          }
          _this.pid = index;
          _this.index = fileName;
          _this.indexs = fileName;
          if (!_this.move) {
            window.localStorage.setItem('index', fileName);
            window.localStorage.setItem('pid', index);
            var parentArr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.parentId);
            window.localStorage.setItem('parentId', parentArr);
          }
          var data = res.data.content;
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              _this.hello.push(data[i]);
            }
          }
          ulBox.scrollTop = 0;
          _this.restore();
        }).catch(function (res) {});
      } else {
        this.filePreview.apply(this, arguments);
      }
    },
    //      点击选择多个文件
    checkMobile: function checkMobile() {
      this.sheetVisible = false;
      this.flag ? this.flag = false : this.flag = true;
      this.isA ? this.isA = false : this.isA = true;
      this.select = '';
    },
    //      单个文件重命名
    rename: function rename() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_13__components_methods__["a" /* default */].rename(_this);
    },
    //      单个文件加入收藏
    collect: function collect() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_13__components_methods__["a" /* default */].collect(_this);
    },
    //      还原
    restore: function restore() {
      this.up = '';
      this.opacity = true;
      this.select = '';
      this.check = '全选';
      this.isA = false;
      this.isB = false;
      this.delArr = [];
      this.fileId = '';
      this.loading = 0;
      this.loadings = 0;
      this.flag = false;
      this.currentValue = false;
      this.page = 0;
      this.size = 20;
      this.index = window.localStorage.getItem('index');
      var checkbox = this.$refs.mybox;
      for (var i = 0; i < checkbox.length; i++) {
        checkbox[i].setAttribute('class', 'check');
      }
    },
    //      删除
    delate: function delate() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_13__components_methods__["a" /* default */].del(_this, 1);
    },
    //      操作多个文件
    delActions: function delActions(type) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_13__components_methods__["a" /* default */].delActions(_this, type);
    },
    //      删除单个文件
    delAction: function delAction(itemId, type, index, isDir, isLove, name) {
      this.fileId = itemId;
      if (type === '删除') {
        this.delArr = [itemId];
        this.delVisible = true;
      } else if (type === '分享') {
        this.currentValue = true;
      } else if (type === '更多' && isDir === 1) {
        this.sheet = true;
        this.indexing = index;
        this.copyfileId = [itemId];
      } else if (type === '更多' && isDir !== 1) {
        this.history = true;
        this.indexing = index;
        this.copyfileId = [itemId];
      }
      this.isFavorite = isLove;
      this.fileName = name;
    },
    //      下拉操作
    selected: function selected(index) {
      if (this.select === index) {
        this.select = '';
        this.up = '';
      } else {
        this.select = index;
        this.up = index;
      }
    },
    //      新建文件夹
    prompt: function prompt() {
      var _this = this;
      _this.sheetVisible = false;
      __WEBPACK_IMPORTED_MODULE_13__components_methods__["a" /* default */].prompt(_this, '个人文件');
    },
    //      单个文件选中
    checked: function checked(index) {
      var length = this.hello.length;
      var _this = this;
      var num = this.$refs.mybox[index].className.indexOf('checked');
      var checkbox = this.$refs.mybox;
      var flag = 0;
      if (num === -1) {
        var className = this.$refs.mybox[index].getAttribute('class');
        checkbox[index].setAttribute('class', className + ' ' + 'checked');
        for (var i = 0; i < checkbox.length; i++) {
          if (checkbox[i].className.indexOf('checked') !== -1) {
            flag++;
          }
        }
        if (flag > 0) {
          _this.index = '\u5DF2\u9009\u62E9' + flag + '\u4E2A\u6587\u4EF6';
          _this.opacity = false;
        }
        if (flag === length) {
          _this.check = '取消全选';
          // _this.isB = true
        }
      } else {
        _this.opacity = true;
        checkbox[index].setAttribute('class', 'check');
        for (var _i = 0; _i < checkbox.length; _i++) {
          if (checkbox[_i].className.indexOf('checked') !== -1) {
            flag++;
          }
        }
        if (flag > 0) {
          _this.index = '\u5DF2\u9009\u62E9' + flag + '\u4E2A\u6587\u4EF6';
          _this.check = '全选';
          _this.opacity = false;
        } else {
          _this.index = _this.indexs;
        }
        if (flag === 0) {
          if (_this.check === '取消全选') {
            _this.checkAll();
          }
        }
      }
    },
    //      全选
    checkAll: function checkAll() {
      var _this = this;
      if (_this.hello.length === 0) {
        return false;
      }
      if (_this.check === '全选') {
        var checkboxs = _this.$refs.mybox;
        for (var i = 0; i < checkboxs.length; i++) {
          checkboxs[i].setAttribute('class', 'check checked');
        }
        // _this.isB = true
        this.check = '取消全选';
        this.opacity = false;
        var checkbox = this.$refs.mybox.length;
        _this.index = '\u5DF2\u9009\u62E9' + checkbox + '\u4E2A\u6587\u4EF6';
        var box = this.$refs.mybox;
        var arr = '';
        for (var _i2 = 0; _i2 < box.length; _i2++) {
          arr += box[_i2].getAttribute('fileId') + ',';
        }
        arr = arr.substring(0, arr.length - 1);
        _this.delArr = arr.split(',');
        _this.fileId = arr;
      } else {
        // this.isB = false
        this.check = '全选';
        this.opacity = true;
        _this.index = _this.indexs;
        var _checkbox = this.$refs.mybox;
        for (var _i3 = 0; _i3 < _checkbox.length; _i3++) {
          _checkbox[_i3].setAttribute('class', 'check');
        }
      }
    },
    //      取消选中状态
    cancel: function cancel() {
      this.index = this.indexs;
      this.check = '全选';
      this.isB = false;
      this.fileId = '';
      this.select = '';
      this.up = '';
      this.opacity = true;
      this.isA ? this.isA = false : this.isA = true;
      var checkbox = this.$refs.mybox;
      for (var i = 0; i < checkbox.length; i++) {
        checkbox[i].setAttribute('class', 'check');
      }
    },
    load: function load() {
      var _this4 = this;

      this.page = 0;
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(this.message, { fileId: this.pid, page: 0, size: 20 }).then(function (response) {
        var data = response.data.content;
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            _this4.hello.push(data[i]);
          }
          _this4.totalPages = response.data.totalPages;
        } else {
          _this4.hello = [];
        }
        return false;
      }).catch(function (error) {});
    },
    // 加载更多
    loadMore: function loadMore() {
      var _this5 = this;

      var _this = this;
      if (this.mark === 1) {
        if (this.page < this.totalPages && _this.loading === 0) {
          _this.loading = 1;
          this.page++;
        } else {
          return;
        }
        setTimeout(function () {
          var _this = _this5;
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(_this.message, { fileId: _this.pid, page: _this.page, size: _this.size }).then(function (res) {
            var list0 = [];
            var data = res.data.content;
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                list0.push(data[i]);
              }
              if (_this.hello && list0) {
                _this.hello = _this.hello.concat(list0);
              }
              _this.loading = 0;
              _this.check = '全选';
            }
          });
        }, 250);
      } else {
        if (_this.page < _this.totalPages && _this.loadings === 0) {
          this.page++;
          _this.loadings = 1;
        } else {
          return;
        }
        setTimeout(function () {
          var _this = _this5;
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].fileSearch, { key: _this.value, page: _this.page, size: _this.size }).then(function (res) {
            var list0 = [];
            var data = res.data.content;
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                list0.push(data[i]);
              }
              if (_this.hello && list0) {
                _this.hello = _this.hello.concat(list0);
              }
            }
            _this.loadings = 0;
          });
        }, 250);
      }
    },

    // 文件预览
    filePreview: function filePreview() {
      var _this6 = this,
          _arguments = arguments;

      var _this = this;
      this.$store.dispatch('getPermissionBtns').then(function () {
        if (!_this6.$customFunctions.checkPermission('preview')) {
          Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
            message: '您没有权限进行此操作!',
            duration: 2000,
            iconClass: 'icon-error'
          });
        } else {
          _this6.imgArray = [];
          var sliceType = __WEBPACK_IMPORTED_MODULE_12_vue__["default"].filter('sliceType');
          for (var i = 0; i < _this.hello.length; i++) {
            if (sliceType(_this.hello[i].fileName) === 'icon-pic') {
              _this.hello[i].thumb = __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].app.cloudStorage.baseUrl + __WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].unifileD.path + '?fileId=' + _this.hello[i].id + '&type=2';
              _this.hello[i].src = __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].app.cloudStorage.baseUrl + __WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].unifileD.path + '?fileId=' + _this.hello[i].id + '&type=2';
              var obj = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.hello[i]));
              _this.imgArray.push(obj);
            }
          }
          if (sliceType(_arguments[1]) === 'icon-pic') {
            var idx = '';
            _this.imgArray.forEach(function (value, index) {
              if (value.fileName === _arguments[1]) {
                idx = index;
              }
            });
            _this6.$refs.lightbox.showImage(idx);
          } else {
            var list = ['txt', 'doc', 'docx', 'xlsx', 'xls', 'pdf', 'wps', 'wpt', 'xls', 'pptx', 'ppt'];
            var fileType = _arguments[1].lastIndexOf('.');
            var type = _arguments[1].substring(fileType + 1).trim();
            if (list.indexOf(type) !== -1) {
              var uSized = _arguments[4] / 1024 / 1024;
              if (uSized < 10) {
                __WEBPACK_IMPORTED_MODULE_2_mint_ui__["Indicator"].open('加载中...');
                __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].preview, { fileId: _arguments[0] }).then(function (response) {
                  if (!response.data.code) {
                    __WEBPACK_IMPORTED_MODULE_2_mint_ui__["Indicator"].close();
                    _this.FileModalHtml = response.data.text;
                    _this.FileModalshow = true;
                  } else {
                    __WEBPACK_IMPORTED_MODULE_2_mint_ui__["Indicator"].close();
                    Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
                      message: '文件正在预览处理中,请稍后再试！',
                      // position: 'bottom',
                      duration: 5000
                    });
                  }
                }).catch(function (error) {
                  __WEBPACK_IMPORTED_MODULE_2_mint_ui__["Indicator"].close();
                  Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
                    message: '预览文件失败,请稍后重试',
                    position: 'bottom',
                    duration: 5000
                  });
                });
              } else {
                Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
                  message: '您预览文件较大,请下载后预览',
                  duration: 5000
                });
              }
            } else {
              Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
                message: '当前文件格式暂不支持预览',
                iconClass: 'icon-error'
              });
            }
          }
        }
      });
    },
    downLoad: function downLoad() {
      Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])('文件正在下载...');
      __WEBPACK_IMPORTED_MODULE_9__components_download_js__["a" /* downLoadFile */].apply(undefined, arguments);
    },
    search: function search() {
      this.isSearch = true;
    },
    focusInput: function focusInput() {
      this.isClose = true;
    },
    blurInput: function blurInput() {
      if (this.value !== '') {
        this.isClose = true;
      } else {
        this.isClose = false;
      }
    },
    clear: function clear() {
      if (this.value !== '') {
        this.value = '';
        this.load();
        this.hello = [];
        this.restore();
      }
    },
    cancelSearch: function cancelSearch() {
      this.isSearch = false;
      this.value = '';
      this.mark = 1;
      this.load();
      this.restore();
      this.hello = [];
    },
    serchContent: function serchContent() {
      var _this = this;
      if (_this.value !== '') {
        _this.mark = 2;
        _this.page = 0;
        _this.hello = [];
        __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].fileSearch, {
          key: _this.value,
          page: _this.page,
          size: _this.size
        }).then(function (res) {
          var data = res.data.content;
          _this.totalPages = res.data.totalPages;
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              if (data[i].fileName.length > _this.maxLen) {
                data[i].fileName = data[i].fileName.substring(0, _this.maxLen) + '...';
              }
              _this.hello.push(data[i]);
            }
          } else {
            _this.$refs.dis.innerText = '未搜索到相关文件/文件夹';
          }
        });
        _this.restore();
      } else {
        _this.mark = 1;
        _this.hello = [];
        _this.load();
      }
    }
  },
  watch: {
    whenId: function whenId(val) {
      this.$store.commit('changeId', val);
    }
  }
});

/***/ }),

/***/ "9ayY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('mt-header',{attrs:{"title":"输入新的手机号码"}},[_c('router-link',{attrs:{"slot":"left","to":"/more/showinfo"},slot:"left"},[_c('span',{staticClass:"quxiao"},[_vm._v("返回")])])],1),_vm._v(" "),_c('div',{staticClass:"codeMsg"},[_c('label',{staticClass:"label"},[_vm._v("手机号")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPhone),expression:"newPhone"}],staticClass:"input",attrs:{"type":"text","placeholder":"请输入新的手机号码","autocomplete":"off","oninput":"if(value.length>11)value=value.slice(0,11)"},domProps:{"value":(_vm.newPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPhone=$event.target.value}}})]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 .4rem"}},[_c('mt-button',{staticClass:"btn",attrs:{"type":"primary","size":"large"},on:{"click":_vm.codeFinish}},[_vm._v("完成")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9pFR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
var configUrl = {
  // 需要访问的服务器
  baseUrl: '',

  // 产品名称
  productName: '法务云盘'
};

/* harmony default export */ __webpack_exports__["a"] = (configUrl);

/***/ }),

/***/ "9yZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forget_vue__ = __webpack_require__("Fxmv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b262295_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forget_vue__ = __webpack_require__("hYmq");
function injectStyle (ssrContext) {
  __webpack_require__("cix8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b262295"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b262295_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AQyz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAkCAYAAABmMXGeAAAAAXNSR0IArs4c6QAAAJ9JREFUSA1jYKAQ/P//PwuIfwFxPYVGQbRDDQRScECZwUBjQC7EBgTIcjHQJFwGTh01kLgQGA1D5PQ4mmyISzUMIzDZgEIG6O0vyOkFyv4GpBmJDDkMZUxAkR4MUQYGTqBYHRZx4oWArmrA4lqQEMUl+ajBkHgYDWN4ehwNitGggIcAnIEnVZDX6oOZjMVg8qpvmIEwGslg6hiIZDCKlwHSxWXe86vdngAAAABJRU5ErkJggg=="

/***/ }),

/***/ "AbWn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: JSON.parse(localStorage.mobileData).nickName,
      isA: true,
      opacity: false,
      isOpen: true
    };
  },

  components: {
    Toast: __WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"]
  },
  methods: {
    Null: function Null() {
      this.username = '';
      this.isOpen = false;
    },
    lightingColor: function lightingColor() {
      this.isA = false;
      this.opacity = true;
      this.isOpen = true;
    },
    finish: function finish() {
      var _this = this;
      var txt = _this.$refs.txt.value;
      if (txt === JSON.parse(localStorage.mobileData).nickName) {
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].info, { value: txt, type: 2 }).then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
          message: '修改成功',
          iconClass: 'icon-success'
        });
        var mobileData = window.localStorage.getItem('mobileData');
        mobileData = JSON.parse(mobileData);
        mobileData.nickName = txt;
        mobileData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(mobileData);
        window.localStorage.setItem('mobileData', mobileData);
        _this.$router.push({ path: '/more/showinfo' });
      }).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
          message: error.response.data.message,
          iconClass: 'icon-error'
        });
      });
    }
  }
});

/***/ }),

/***/ "Ae4w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shareFile_vue__ = __webpack_require__("63ih");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40f26342_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shareFile_vue__ = __webpack_require__("MFPJ");
function injectStyle (ssrContext) {
  __webpack_require__("r5sU")
  __webpack_require__("wAke")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40f26342"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shareFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40f26342_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shareFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Apws":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cloudStorageApi_js__ = __webpack_require__("kRT9");


/* eslint-disable */





// axios.interceptors.request.use(function (config) {
//   if (store.getters.org) {
//     config.headers.tenant = '2333'
//   }
//   return config
// }, function (err) {
//   return Promise.reject(err);
// })
var apps = {
  cloudStorage: {
    name: '云存储接口',
    headerTitle: '法务云盘',
    description: '',
    baseUrl: ''
    // baseUrl: 'http://172.16.5.243:9191'
    // baseUrl: ''
    // baseUrl: 'http://172.16.5.216:9191'
  }
};

var http = {
  app: apps,
  request: function request(api, params, header) {
    var app = apps[api.app];
    var url = app.baseUrl + api.path;
    if (api.defaultParam) {
      params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(api.defaultParam, params);
    }
    var data = __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(params);
    var dataType = 'json';
    var method = 'POST';
    var timeout = null;
    if (api.method != null || api.method !== undefined) {
      method = api.method;
      if (method === 'get') {
        url += '?' + data;
      }
    }

    if (api.dataType != null || api.dataType !== undefined) {
      dataType = api.dataType;
    }

    if (api.timeout != null || api.timeout !== undefined) {
      timeout = api.timeout;
    }
    var config = {
      url: url,
      method: method,
      withCredentials: true,
      emulateJSON: true,
      data: data,
      timeout: timeout,
      dataType: dataType,
      error: function error() {},
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
        'CS-NETWORKENV': 'public'
      }
    };
    if (header !== '' && header !== null && header !== undefined) {
      config.headers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(config.headers, header);
    }
    return __WEBPACK_IMPORTED_MODULE_2_axios___default()(config);
  }
};
var onLoginStatus = false;
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.response.use(function (res) {
  return res;
}, function (error) {
  // let url = window.location.href
  console.log(error.response);
  if (error.response.data.errorCode === 'NO_LOGIN' || error.response.data.errorCode === '401' || error.response.data.errorCode === 'SESSION_TIME_OUT') {
    if (navigator.userAgent.toLowerCase().indexOf('yicbridge') !== -1) {
      if (onLoginStatus) {
        return;
      }
      var sign = GetQueryString('sign');
      var _this = this;
      onLoginStatus = true;
      http.request(__WEBPACK_IMPORTED_MODULE_5__cloudStorageApi_js__["a" /* default */].login2, { sign: sign }).finally(function (res) {
        onLoginStatus = false;
      });
      return;
    }
    window.sessionStorage.removeItem('mobileData');
    // window.location.href = url.slice(0, url.lastIndexOf('#') + 2) + 'login'
    // router.push({path: './index.html#/login'})
    __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ path: '/login' });
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (http);

/***/ }),

/***/ "AuSF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = downLoadFile;
/* unused harmony export doDownLoadFile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);





function downLoadFile(downType, fileId, isdir, vId, name) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$customStore.dispatch('getPermissionBtns').then(function () {
    if (!__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$customFunctions.checkPermission('download')) {
      Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
        message: '您没有权限进行此操作!',
        duration: 3000,
        iconClass: 'icon-error'
      });
    } else {
      doDownLoadFile(downType, fileId, isdir, vId, name);
    }
  });
}

function doDownLoadFile(downType, fileId, isdir, vId, name) {
  var downloadId = downType;
  var hasDir = isdir;
  // 用于存储请求下载的文件id
  var ids = '';
  // 请求链接
  var url = '';
  if (!downloadId) {
    return false;
  }
  if (downloadId === '1') {
    // 文件
    ids = fileId;
  } else if (downloadId === '2') {
    // 历史版本
    ids = vId;
  }
  // 没有选择需要下载的文件
  if (!ids) {
    return false;
  }
  if (downloadId === '1') {
    if (ids.indexOf(',') > -1) {
      url = __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].app.cloudStorage.baseUrl + __WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].multifilesD.path + '?fileIds=' + ids;
    } else {
      if (hasDir === 0) {
        url = __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].app.cloudStorage.baseUrl + __WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].unifileD.path + '?fileId=' + ids;
      } else {
        url = __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].app.cloudStorage.baseUrl + __WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].multifilesD.path + '?fileIds=' + ids;
      }
    }
  } else if (downloadId === '2') {
    url = __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].app.cloudStorage.baseUrl + __WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].versionUnifileD.path + '?vid=' + ids;
  }

  if (!url) {
    return false;
  }
  var eleLink = document.createElement('a');
  eleLink.style.display = 'none';
  eleLink.href = url;
  // 触发点击
  document.body.appendChild(eleLink);
  eleLink.click();
  // 然后移除
  document.body.removeChild(eleLink);
}

/***/ }),

/***/ "B963":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],ref:"ulBox",staticClass:"ulBox",attrs:{"infinite-scroll-distance":"0","infinite-scroll-immediate-check":"false","infinite-scroll-disabled":"moreLoading"}},_vm._l((_vm.shareArr),function(item,index){return _c('li',[_c('div',{staticClass:"list"},[(_vm.sliceType(item.fileName,item.isDir,item.fileCategory)!=='package')?_c('span',{class:_vm.styleObject(item.fileName,item.isDir,item.fileCategory)},[_c('i',{staticClass:"iconfont",class:_vm.classObject(item.fileName,item.isDir,item.fileCategory)})]):_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-package"}})]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{staticClass:"right"},[_c('h3',[_vm._v(_vm._s(_vm.delateFile(item.fileName, item.shareStatus)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formaTime(item.gmtCreate)))])]),_vm._v(" "),_c('div',{staticClass:"size"},[_vm._v(_vm._s(_vm.expire(item.remainDays)))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.shareStatus!==-1),expression:"item.shareStatus!==-1"}],staticClass:"morea",class:{'more':_vm.up===index},on:{"click":function($event){return _vm.selected(index,item.shareUrl)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.select===index),expression:"select===index"}],staticClass:"select",attrs:{"id":"clipboard"}},[_vm._m(0,true)])])}),0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('i',{staticClass:"icon-fuzhidao iconfont",staticStyle:{"font-size":".48rem","display":"block","color":"#999"}}),_vm._v(" "),_c('p',[_vm._v("复制链接")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BXMr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all"},[_c('div',{staticClass:"head clearfix yp-topbar"},[_vm._v(_vm._s(_vm.nickName))]),_vm._v(" "),_c('div',{staticClass:"circleContent yp-topbar"},[_c('canvas',{attrs:{"id":"myCanvas"}}),_vm._v(" "),_c('div',{staticClass:"contentNum"},[_c('div',[_c('span',{staticClass:"info"},[_vm._v("已用:"+_vm._s(_vm.usedSize))]),_vm._v(" "),_c('span',{staticClass:"info"},[_vm._v("容量:"+_vm._s(_vm.quota))])])])]),_vm._v(" "),_c('ul',{staticClass:"meau_icon"},[_c('li',[_c('router-link',{attrs:{"to":"/collect/collect"}},[_c('i',{staticClass:"iconfont icon-xingxing",staticStyle:{"color":"#FFD606"}}),_vm._v(" "),_c('p',[_vm._v("个人收藏")])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/myShare"}},[_c('i',{staticClass:"iconfont icon-fenxiang",staticStyle:{"color":"#FF5801"}}),_vm._v(" "),_c('p',[_vm._v("我的分享")])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/recycle/recycle"}},[_c('i',{staticClass:"iconfont icon-huishouzhan",staticStyle:{"color":"#13A1FF"}}),_vm._v(" "),_c('p',[_vm._v("回收站")])])],1)]),_vm._v(" "),_c('div',{staticClass:"meau_list"},[_c('mt-cell',{attrs:{"title":"他人分享","is-link":"","to":"/otherShare"}}),_vm._v(" "),_c('mt-cell',{attrs:{"title":"群组管理","is-link":"","to":"/groupManage"}}),_vm._v(" "),_c('mt-cell',{attrs:{"title":"个人设置","is-link":"","to":"/more/showinfo"}}),_vm._v(" "),_c('mt-cell',{attrs:{"title":"操作日志","is-link":"","to":"/log/log"}}),_vm._v(" "),_c('mt-cell',{attrs:{"title":"帐号安全","is-link":"","to":"/more/accountsafe"}})],1),_vm._v(" "),_c('div',{staticClass:"off",class:{login_out: _vm.isIphoneX}},[_c('mt-button',{attrs:{"size":"large"},on:{"click":_vm.loginOut}},[_vm._v("退出登录")])],1),_vm._v(" "),_c('tabbar',{attrs:{"id":4}}),_vm._v(" "),_c('mt-actionsheet',{staticClass:"loginout",attrs:{"actions":_vm.actions},model:{value:(_vm.sheetVisible),callback:function ($$v) {_vm.sheetVisible=$$v},expression:"sheetVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CSMX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D456":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_config__ = __webpack_require__("9pFR");
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'logo',
  data: function data() {
    return {
      productName: ''
    };
  },
  created: function created() {
    this.productName = __WEBPACK_IMPORTED_MODULE_0__apis_config__["a" /* default */].productName;
  }
});

/***/ }),

/***/ "EZMy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      phone: '',
      phone1: '',
      newPhone: ''
    };
  },
  created: function created() {
    this.phone = JSON.parse(sessionStorage.mobileData).phone;
    //    this.phone1 = this.phone.substr(0, 3) + '****' + this.phone.substr(7)
  },

  components: {
    Toast: __WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"]
  },
  methods: {
    codeFinish: function codeFinish() {
      // 要发送请求
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].info, { value: _this.newPhone, type: 3 }).then(function (res) {
        JSON.parse(sessionStorage.mobileData).phone = _this.newPhone;
        Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
          message: '修改成功',
          iconClass: 'icon-success'
        });
        _this.$router.push({ path: '/more/showinfo' });
      }).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
          message: error.response.data.message,
          iconClass: 'icon-error'
        });
      });
    }
  }
});

/***/ }),

/***/ "Eg0l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_share_vue__ = __webpack_require__("gedM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73921a99_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_share_vue__ = __webpack_require__("1R+O");
function injectStyle (ssrContext) {
  __webpack_require__("xPDF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73921a99"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_share_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73921a99_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_share_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EmL7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'install',
  components: {},
  created: function created() {
    this.flag = this.configFlag || 1;
    this.load();
    this.userCount();
  },
  data: function data() {
    return {
      continues: false,
      uploader: '可上传(0)',
      compiler: '可编辑(0)',
      viewer: '可查看(0)',
      dataList: [],
      addList: [],
      flag: 1,
      page: 0,
      txt: '',
      managerFileIds: '',
      readFileIds: '',
      editFileIds: '',
      checkMum: 0,
      delmembersModel: false,
      delmember: [{
        name: '确认删除',
        method: this.tworemove
      }],
      whenId: ''
    };
  },

  props: ['fileId', 'configFlag'],
  methods: {
    back: function back() {
      this.$emit('child', false);
    },
    //      添加之后刷新数据
    onload: function onload(type, userId) {
      var _this = this;
      var permissionType = type;
      var userIds = userId;
      var checkbox = _this.$refs.adminBox;
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].addUser, { fileId: _this.fileId, permissionType: permissionType, userIds: userIds }).then(function (res) {
        _this.continues = false;
        _this.userCount();
        for (var i = 0; i < checkbox.length; i++) {
          checkbox[i].setAttribute('class', 'check');
        }
        _this.dataList = [];
        __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].userList, { page: 0, size: 20, fileId: _this.fileId, permissionType: permissionType }).then(function (response) {
          var data = response.data.content;
          if (data.length > 0) {
            for (var _i = 0; _i < data.length; _i++) {
              _this.dataList.push(data[_i]);
            }
          }
        }).catch(function (error) {});
      });
    },
    //      移除之后刷新数据
    offload: function offload(type) {
      var _this = this;
      var permissionType = type;
      _this.dataList = [];
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].userList, { page: 0, size: 20, fileId: _this.fileId, permissionType: permissionType }).then(function (response) {
        var data = response.data.content;
        _this.userCount();
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            _this.dataList.push(data[i]);
          }
        }
      }).catch(function (error) {});
    },
    //      搜索
    search: function search() {
      var _this = this;
      var addBox = _this.$refs.addBox;
      addBox.scrollTop = 0;
      _this.addList = [];
      _this.page = 0;
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].allUser, { info: this.txt, page: 0, size: 20 }).then(function (res) {
        var data = res.data.content;
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            _this.addList.push(data[i]);
          }
        }
      });
    },
    //      取消添加成员
    close: function close() {
      var _this = this;
      _this.continues = false;
    },
    //      添加成员
    add: function add(val) {
      this.$emit('add', val, this.dataList);
      this.continues = true;
    },
    //      移除成员
    remove: function remove(id) {
      this.whenId = id;
      this.delmembersModel = true;
    },
    tworemove: function tworemove() {
      var _this = this;
      var userIds = this.whenId;
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].removeUser, { fileId: _this.fileId, userIds: userIds }).then(function (res) {
        _this.offload(_this.flag);
      });
    },
    Count: function Count(index) {
      var _this = this;
      _this.flag = index;
      _this.dataList = [];
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].userList, {
        page: 0,
        size: 20,
        fileId: _this.fileId,
        permissionType: index
      }).then(function (response) {
        var data = response.data.content;
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            _this.dataList.push(data[i]);
          }
        }
      }).catch(function (error) {});
    },
    //      设置头像
    avatarSrc: function avatarSrc(src) {
      if (src === '') {
        return '../../assets/images/defaultPic.png';
      } else {
        return src;
      }
    },
    //      加载数据
    load: function load() {
      var _this = this;
      console.log(1111111111111111);
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].userList, { page: 0, size: 20, fileId: _this.fileId, permissionType: this.flag }).then(function (response) {
        var data = response.data.content;
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            _this.dataList.push(data[i]);
          }
        }
      }).catch(function (error) {});
    },
    scroll: function scroll() {
      var _this = this;
      var ulBox = _this.$refs.ulBox;
      if (ulBox.scrollTop + ulBox.clientHeight >= ulBox.scrollHeight) {
        _this.page++;
        __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].userList, {
          page: _this.page,
          size: 20,
          fileId: _this.fileId,
          permissionType: 3
        }).then(function (response) {
          var data = response.data.content;
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              _this.dataList.push(data[i]);
            }
          }
        }).catch(function (error) {});
      }
    },
    scrollAdd: function scrollAdd() {
      var _this = this;
      var ulBox = _this.$refs.addBox;
      if (ulBox.scrollTop + ulBox.clientHeight >= ulBox.scrollHeight) {
        _this.page++;
        __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].allUser, { page: _this.page, size: 20 }).then(function (res) {
          var data = res.data.content;
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              _this.addList.push(data[i]);
            }
          }
        });
      }
    },
    //      各权限数量
    userCount: function userCount() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].userCount, { fileId: _this.fileId }).then(function (res) {
        var data = res.data;
        console.dir(data);
        if (data.uploadCount >= 0) {
          _this.uploader = '可上传(' + data.uploadCount + ')';
        }
        if (data.readCount >= 0) {
          _this.viewer = '可查看(' + data.readCount + ')';
        }
        if (data.editCount >= 0) {
          _this.compiler = '可编辑(' + data.editCount + ')';
        }
      });
    },
    //      单个文件选中
    checked: function checked(index) {
      var _this = this;
      var num = _this.$refs.adminBox[index].className.indexOf('checked');
      var checkbox = _this.$refs.adminBox;
      if (num === -1) {
        var className = _this.$refs.adminBox[index].getAttribute('class');
        checkbox[index].setAttribute('class', className + ' ' + 'checked');
      } else {
        checkbox[index].setAttribute('class', 'check');
      }
      this.checkMum = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.checked').length - 1;
    },
    //      确定添加
    addEnd: function addEnd() {
      var _this = this;
      var arr = '';
      var checkbox = _this.$refs.adminBox;
      for (var i = 0; i < checkbox.length; i++) {
        if (checkbox[i].className.indexOf('checked') !== -1) {
          arr += checkbox[i].getAttribute('fileId') + ',';
        }
      }
      arr = arr.substring(0, arr.length - 1);
      _this.managerFileIds = arr;
      var userIds = _this.managerFileIds;
      _this.onload(_this.flag, userIds);
    }
  }
});

/***/ }),

/***/ "FuCC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var CryptoJS = __webpack_require__("Av7u"); // 引用AES源码js

var key = CryptoJS.enc.Utf8.parse('1111222233334444'); // 十六位十六进制数作为密钥
var iv = CryptoJS.enc.Utf8.parse('1234567876543210'); // 十六位十六进制数作为密钥偏移量

// 解密方法
function Decrypt(word) {
  var bytes = CryptoJS.AES.decrypt(word.toString(), key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  var decryptResult = bytes.toString(CryptoJS.enc.Utf8);
  return decryptResult.toString();
}

// 加密方法
function Encrypt(word) {
  var encryptResult = CryptoJS.AES.encrypt(word, key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encryptResult.toString();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  Decrypt: Decrypt,
  Encrypt: Encrypt
});

/***/ }),

/***/ "Fxmv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_logo__ = __webpack_require__("h6b3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__ = __webpack_require__("kRT9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      time: 60,
      password: '',
      confirm_password: '',
      isFirstStep: true,
      isSecondStep: false,
      isThirdStep: false,
      isShow: false,
      isLogo: true,
      tishi: '',
      phone: '',
      code: '',
      userId: 'userId',
      sendMsgDisabled: true
    };
  },

  components: {
    logo: __WEBPACK_IMPORTED_MODULE_0__common_logo__["a" /* default */]
  },
  methods: {
    next: function next() {
      var self = this;
      var phone = self.phone.trim();
      var regMobile = /^1[3|4|5|7|8][0-9]{9}$/;
      if (phone.length === 0) {
        self.isShow = true;
        self.tishi = '手机号码不能为空';
        return false;
      }
      if (phone.length !== 11 || !regMobile.test(phone)) {
        self.isShow = true;
        self.tishi = '请正确填写您的手机号码';
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].phoneValidate, { phone: phone }).then(function (response) {
        self.isShow = true;
        self.tishi = '该手机号码尚未注册';
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].sendMsg, { type: 2, phone: phone }).then(function (response) {
          self.isShow = false;
          var cur = self.$refs.getMsg;
          self.sendMsgDisabled = false;
          cur.disabled = true;
          var interval = setInterval(function () {
            self.time--;
            if (self.time-- <= 0) {
              self.time = 60;
              self.sendMsgDisabled = true;
              cur.disabled = false;
              clearInterval(interval);
            }
          }, 1000);
        }).catch(function (error) {
          self.isShow = true;
          self.tishi = error.response.data.message;
        });
      });
    },
    changePhone: function changePhone() {
      this.isShow = false;
    },
    nextHandler: function nextHandler() {
      // 调用校验验证码的接口
      var self = this;
      var data = { phone: this.phone, smsCode: this.code };
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].psdIdentity, data).then(function (res) {
        self.isFirstStep = false;
        self.isSecondStep = true;
        self.isThirdStep = false;
        self.userId = res.data.userId;
      }).catch(function (error) {
        self.isShow = true;
        self.tishi = error.response.data.message;
      });
    },
    changePassword: function changePassword() {
      var reg = /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,16}$/;
      var self = this;
      var password = self.password;
      if (password.trim() === '') {
        self.isShow = true;
        self.tishi = '密码不能为空';
        return false;
      }
      if (password.length < 6) {
        self.isShow = true;
        self.tishi = '密码长度不能小于6个字符';
        return false;
      }
      if (password.length > 16) {
        self.isShow = true;
        self.tishi = '密码长度不能大于16个字符';
        return false;
      }
      if (!reg.test(password)) {
        self.isShow = true;
        self.tishi = '密码必须是6-16位字母、数字或符号两种以上组合';
        return false;
      }
    },
    focusPassword: function focusPassword() {
      this.isShow = false;
    },
    changeConfirm_password: function changeConfirm_password() {
      var self = this;
      var confirmpassword = self.confirm_password;
      var password = self.password;
      if (confirmpassword.trim() === '') {
        self.isShow = true;
        self.tishi = '请输入密码';
        return false;
      }
      if (confirmpassword !== password) {
        self.isShow = true;
        self.tishi = '两次密码输入不一致';
        return false;
      }
    },
    focusConfirm_password: function focusConfirm_password() {
      this.isShow = false;
    },
    nextDetermine: function nextDetermine() {
      var self = this;
      var data = { userId: self.userId, newPassword: self.confirm_password
        // 接口请求
      };__WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].reset, data).then(function () {
        self.isFirstStep = false;
        self.isSecondStep = false;
        self.isThirdStep = true;
        self.isLogo = false;
      }).catch(function (error) {});
    }
  }
});

/***/ }),

/***/ "H0Qc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_logo__ = __webpack_require__("h6b3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_crypto__ = __webpack_require__("FuCC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modifyPassword',
  components: { Logo: __WEBPACK_IMPORTED_MODULE_1__common_logo__["a" /* default */] },
  data: function data() {
    return {
      changePsdone: __webpack_require__("2IGi"),
      changePsdtwo: __webpack_require__("2IGi"),
      changePsdthree: __webpack_require__("2IGi"),
      account: '',
      textOne: 'password',
      textTwo: 'password',
      textThree: 'password',
      isShow: false,
      tishi: '',
      oldPassword: '',
      newPassword: '',
      confirm_password: ''
    };
  },
  created: function created() {
    this.account = this.$route.query.account;
  },

  methods: {
    togglePsdOne: function togglePsdOne() {
      this.textOne = this.textOne === 'text' ? 'password' : 'text';
      this.changePsdone = this.textOne === 'text' ? __webpack_require__("YgvM") : __webpack_require__("2IGi");
    },
    togglePsdTwo: function togglePsdTwo() {
      this.textTwo = this.textTwo === 'text' ? 'password' : 'text';
      this.changePsdtwo = this.textTwo === 'text' ? __webpack_require__("YgvM") : __webpack_require__("2IGi");
    },
    togglePsdThree: function togglePsdThree() {
      this.textThree = this.textThree === 'text' ? 'password' : 'text';
      this.changePsdthree = this.textThree === 'text' ? __webpack_require__("YgvM") : __webpack_require__("2IGi");
    },
    returnBack: function returnBack() {
      this.$router.push({ path: '/login' });
    },
    changeNewpassword: function changeNewpassword() {
      var reg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!-\/:-@\[-`{-~])[!-~]{8,20}$/;
      var _this = this;
      if (_this.newPassword.length === 0) {
        _this.isShow = true;
        _this.tishi = '密码不能为空';
        return false;
      }
      if (_this.newPassword.length < 6) {
        _this.isShow = true;
        _this.tishi = '密码长度不能小于6个字符';
        return false;
      }
      if (_this.newPassword.length > 16) {
        _this.isShow = true;
        _this.tishi = '密码长度不能大于16个字符';
        return false;
      }
      if (!reg.test(_this.newPassword)) {
        _this.isShow = true;
        _this.tishi = '密码必须是8-16位字母、数字和符号三种组合';
        return false;
      }
    },
    focusNewpassword: function focusNewpassword() {
      this.isShow = false;
    },
    focusConfirmpassword: function focusConfirmpassword() {
      this.isShow = false;
      if (this.oldPassword !== '' && this.newPassword !== '') {}
    },
    finsh: function finsh() {
      var _this2 = this;

      var validate = this.changeNewpassword();
      if (validate === false) {
        return validate;
      }
      if (!this.oldPassword) {
        this.isShow = true;
        this.tishi = '请输入旧密码';
        window.setTimeout(function () {
          _this2.isShow = false;
        }, 2000);
      }
      if (this.oldPassword !== '' && this.newPassword !== '') {
        this.isA = false;
        if (this.confirm_password.trim() === '') {
          this.isShow = true;
          this.tishi = '请输入新密码';
          return false;
        }
        if (this.confirm_password !== this.newPassword) {
          this.isShow = true;
          this.tishi = '两次密码输入不一致';
          return false;
        } else {
          this.isShow = false;
          var oldPassword = this.oldPassword;
          var value = this.newPassword;
          var _this = this;
          __WEBPACK_IMPORTED_MODULE_3__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].info, { value: __WEBPACK_IMPORTED_MODULE_4__utils_crypto__["a" /* default */].Encrypt(value), type: 4, oldPassword: __WEBPACK_IMPORTED_MODULE_4__utils_crypto__["a" /* default */].Encrypt(oldPassword) }).then(function (response) {
            var instance = Object(__WEBPACK_IMPORTED_MODULE_0_mint_ui__["Toast"])({
              message: '修改成功',
              iconClass: 'icon-success',
              duration: 1500
            });
            _this.oldPassword = '';
            _this.newPassword = '';
            _this.confirm_password = '';
            _this.isshow = true;
            _this.isA = true;
            setTimeout(function () {
              instance.close();
              __WEBPACK_IMPORTED_MODULE_3__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].logout, {}).then(function () {
                sessionStorage.removeItem('mobileData');
                // window.localStorage.clear()
                // _this.$router.push('/login')
                _this.$router.push({ path: '/login' });
              });
            }, 1500);
          }).catch(function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_0_mint_ui__["Toast"])({
              message: error.response.data.message,
              iconClass: 'icon-error'
            });
            _this.oldPassword = '';
            _this.isA = true;
          });
        }
      }
    }
  }
});

/***/ }),

/***/ "HJqF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Haow":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_logo__ = __webpack_require__("h6b3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_tools__ = __webpack_require__("jt1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_crypto__ = __webpack_require__("FuCC");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var checking = null;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      changePsd: __webpack_require__("2IGi"),
      types: 'password',
      codeUrl: '',
      account: '',
      password: '',
      isShow: false,
      tishi: '',
      checkCode: '',
      address: '',
      sheetVisible: false,
      ischecked: false,
      isColor: false,
      pid: '',
      maxLen: 5,
      districtCode: '',
      list1: [],
      list2: [],
      list3: [],
      tenant: '',
      one: true,
      two: false,
      three: false,
      value1: '',
      value2: '',
      value3: '',
      isOnly: ''
    };
  },

  created: function created() {
    this.cityAdress();
    this.address = localStorage.addressDataValue;
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('yicbridge') !== -1) {
      this.singlePointLogin();
    }
  },
  mounted: function mounted() {
    this.getCode();
    // this.testPlatform()
  },
  components: {
    logo: __WEBPACK_IMPORTED_MODULE_3__common_logo__["a" /* default */]
  },
  methods: {
    singlePointLogin: function singlePointLogin() {
      // let a = navigator.userAgent.toLowerCase() === 'yicbridge' && window.yicbridge.getSign()
      // let sign = a || GetQueryString('sign')
      var sign = Object(__WEBPACK_IMPORTED_MODULE_5__assets_js_tools__["a" /* GetQueryString */])('sign');
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].login2, { sign: sign }).then(function (response) {
        if (response.data === 'true') {
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].record, { channel: '3' }, function () {});
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].show).then(function (res) {
            window.sessionStorage.mobileData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data);
            _this.$router.push({ path: '/index' });
            // _this.$store.dispatch('getPermissionBtns').then(() => {
            // })
          });
        }
      });
    },
    testPlatform: function testPlatform() {
      var agent = navigator.userAgent.toLowerCase();
      var android = agent.indexOf('android');
      if (android !== -1) {
        Object(__WEBPACK_IMPORTED_MODULE_4_mint_ui__["MessageBox"])({
          title: '',
          message: '为保证正常操作，安卓用户请下载【法务云盘】app使用',
          showCancelButton: false
        });
      }
    },
    togglePsd: function togglePsd() {
      this.types = this.types === 'text' ? 'password' : 'text';
      this.changePsd = this.types === 'text' ? __webpack_require__("YgvM") : __webpack_require__("2IGi");
    },

    changeAccount: function changeAccount() {
      this.isShow = false;
    },
    focusAccount: function focusAccount() {
      this.isShow = false;
    },
    toLogin: function toLogin() {
      if (this.address === '') {
        this.isShow = true;
        this.tishi = '请选择法院';
      } else if (this.account === '' || this.password === '') {
        this.isShow = true;
        this.tishi = '帐号或密码不能为空';
      } else if (this.account.trim().length === 0) {
        this.isShow = true;
        this.tishi = '帐号不能为空';
      } else if (this.password.trim().length === 0) {
        this.isShow = true;
        this.tishi = '密码不能为空';
      } else if (this.checkCode === '') {
        this.isShow = true;
        this.tishi = '验证码不能为空';
      }
      this.changCode();
    },
    getCode: function getCode() {
      var _this2 = this;

      this.checkCode = '';
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].getCode).then(function (res) {
        _this2.codeUrl = 'data:image/gif;base64,' + res.data.base64Str;
      });
    },
    changCode: function changCode() {
      var self = this;
      var code = self.checkCode.trim();
      if (code.length === 0 || code.length > 6 || code.length < 6) {
        return;
      }
      if (code.length === 6) {
        __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].checkCode, { code: code }).then(function (response) {
          var data = response.data;
          if (data === false) {
            code = '';
            self.getCode();
            self.isShow = true;
            self.tishi = '验证码错误';
          } else {
            self.isShow = false;
            self.submitForm(true);
          }
        });
      }
    },
    submitForm: function submitForm() {
      var self = this;
      var data = { 'username': self.account, 'password': __WEBPACK_IMPORTED_MODULE_6__utils_crypto__["a" /* default */].Encrypt(self.password), 'code': self.checkCode, 'rememberMe': 'on' };
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].login, data, { 'tenant': localStorage.addressData }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].record, { channel: '3' }, function () {});
        __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].show).then(function (res) {
          if (res.data.needResetPassword) {
            self.$router.push({ path: '/modifyPassword', query: { account: self.account } });
          } else {
            window.sessionStorage.mobileData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data);
            self.$router.push({ path: '/index' });
          }
        });
        // self.$store.dispatch('getPermissionBtns').then(() => {
        // })
      }).catch(function (res) {
        if (res.response.data.errorCode === 0) {
          self.isShow = true;
          self.tishi = '帐号或者密码错误';
          //            self.account = ''
          self.password = '';
          self.getCode();
        } else if (res.response.data.errorCode === '0003') {
          self.isShow = true;
          self.tishi = '用户不存在';
          self.account = '';
          self.password = '';
          self.getCode();
        } else if (res.response.data.errorCode === '10020') {
          self.isShow = true;
          self.tishi = '用户已被停用,请联系管理员';
          self.account = '';
          self.password = '';
          self.getCode();
        } else {
          self.checkCode = '';
          self.isShow = true;
          // self.tishi = '验证码错误'
          self.tishi = res.response.data.errorMessage;
          self.getCode();
        }
        // $('.errowShow').text(JSON.parse(req.responseText).errorCode === '0' ? '邮箱或密码错误' : '验证码错误').fadeIn()
        // getCode()
      });
    },
    cityAdress: function cityAdress() {
      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].addressList, {}).then(function (res) {
        var data = res.data;
        if (data.length > 0) {
          if (data[0].children.length === 0 && data.length === 1) {
            window.localStorage.addressData = data[0].tenantCode;
            window.localStorage.addressDataValue = data[0].tenantName;
            _this.isOnly = true;
            _this.address = localStorage.addressDataValue;
            return 'true';
          }
          _this.list1 = [];
          for (var i = 0; i < data.length; i++) {
            _this.list1.push(data[i]);
          }
        } else {
          _this.list1 = [];
        }
      });
    },
    nextTown: function nextTown(item) {
      var _this = this;
      _this.one = false;
      _this.two = true;
      _this.value1 = item.cityName;
      console.log(item.children);
      var data = item.children;
      if (data.length > 0) {
        _this.list2 = [];
        data.forEach(function (item) {
          _this.list2.push(item);
        });
      } else {
        _this.list2 = [];
      }
    },
    nextTown1: function nextTown1(item) {
      var _this = this;
      _this.one = false;
      _this.two = false;
      _this.three = true;
      _this.value2 = item.districtName;
      console.log(item.children);
      var data = item.children;
      if (data.length > 0) {
        _this.list3 = [];
        data.forEach(function (item) {
          _this.list3.push(item);
        });
      } else {
        _this.list3 = [];
      }
    },
    modal: function modal() {
      this.cityAdress();
      this.sheetVisible = true;
      this.isShow = false;
      this.one = true;
      this.two = false;
      this.three = false;
    },
    cancel: function cancel() {
      this.sheetVisible = false;
    },
    modal1: function modal1() {
      var _this3 = this;

      if (this.isOnly) {
        return;
      }
      this.cityAdress().then(function (data) {
        if (!data) {
          _this3.sheetVisible = true;
          _this3.isShow = false;
          _this3.one = true;
          _this3.two = false;
          _this3.three = false;
        }
      });
    },
    stringfy: function stringfy(val) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val);
    },
    checked: function checked(item, index) {
      if (item.ischecked === undefined && item.isColor === undefined) {
        if (checking) {
          checking.ischecked = false;
          checking.isColor = false;
        }
        this.$set(item, 'ischecked', true);
        this.$set(item, 'isColor', true);
        checking = item;
        return;
      }

      if (item.ischecked) {
        item.ischecked = false;
        item.isColor = false;
        checking = null;
      } else {
        if (checking) {
          checking.ischecked = false;
          checking.isColor = false;
        }
        item.ischecked = true;
        item.isColor = true;
        checking = item;
      }
    },
    sure: function sure() {
      var _this4 = this;

      if (this.list1.length > 0) {
        this.list1.forEach(function (item) {
          if (item.ischecked) {
            _this4.address = item.tenantName;
            _this4.tenant = item.tenantCode;
            window.localStorage.addressData = _this4.tenant;
            window.localStorage.addressDataValue = _this4.address;
            _this4.sheetVisible = false;
          }
        });
      }
      if (this.list2.length > 0) {
        this.list2.forEach(function (item) {
          if (item.ischecked) {
            _this4.address = item.tenantName;
            _this4.tenant = item.tenantCode;
            window.localStorage.addressData = _this4.tenant;
            window.localStorage.addressDataValue = _this4.address;
            _this4.sheetVisible = false;
          }
        });
      }
      if (this.list3.length > 0) {
        this.list3.forEach(function (item) {
          if (item.ischecked) {
            _this4.address = item.tenantName;
            _this4.tenant = item.tenantCode;
            window.localStorage.addressData = _this4.tenant;
            window.localStorage.addressDataValue = _this4.address;
            _this4.sheetVisible = false;
          }
        });
      }
    }
  }
});

/***/ }),

/***/ "JEGS":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAA+ZJREFUWAnNWD1MU1EUps+2cZC0jT8bHWAQEhKDMhk7oomzdsAJEtqQgCay4oQrg2LAtoFOMlRnE9DJJk4Y0qQJOIhJ2dSkbXQwgK3fdzn35ZW+5vUpr+Uk993z7j33fN879//5elzK2tpa/9HR0e16vR5D0yGkqM/n66UblP1EVkLaQVne7/dvTk5O7rGuXfG1Y5jL5c5Vq9U4AGeQbrbTRtuA2EfoS+Fw+HU8Hv+jy1vljoQymcxYrVZ7DgeD2glA6tALILcNfQ95hXXQw9D7kY/g9Rp0q/9dlM8mEon3tG0l1gYNNtls9vzBwcEzFCYsFUU4XQFQLplM/rCUN6mpVOoSbBnVaVQOWwzSwWDw0cTExG9LmanaEsI4uXx4ePgWVqNiuY98Dl/3BiCMTtvCKKXT6XtosIjUJw23AoHAXYyv7ycdNRESMnkYXhXj9UgkkkT//zrZ2M376upqLybDS7QZl3afQSp2klQDIekmklGRQTSeICpP3QA72SJa84jagthtofti1u4zrA5kzHhGhlj8QH6o4I4KpknDjJDMpk2pWcegfWBaeaBg0L+CW9V9IDimZ5+KENcZmdqE3ueY8YBDg0vB4GThgrpEDtQVIS560PU6M9fuAMZXBpCuIw3QmRsRjDlpM1ipVO5TV4TAcEYqipzaojtmCDW79RPSjqOxjYFgFaVqlrnBvQmE1HYAgBWkttcZ2AbFWUByVxmxiMlG5EAuBhbAOyxgJSRHvZNCTGITk5s2u+yWECg4bQdid6qZYBboFORiJMQjBF+2mXdDLNhDJBQVEl+6QYaY6DJ9ZooaeFGHK5RXu0UIEdLHl1417btFROMiKOaO4Qc7HjsvIoW0wb/k2DS3WrUDRt0wjMdTU1P5FjYKm1z8MCghkZDr1dbqHM5uWN9tdE4eW0Jo2y/2JRLiKjuCqPHY6VbyaJeCQzPkdg5gU8de+cGujmXEhg+qOz7sQzxiLrMR5Eqn1yLg86j7jR8FmTZwatsgNSngJttRAQmeu1WEoW8YvDdB4VWFpKZ1ZSdYEYuYxCIHDPqvatrj5YUQGJYDeSf49AiWvpEsEVQRCoVC3FR3hcUiDksXRPcsEwzeRCi7vEhSUYR4o8Q68ZAFkL5yuZw6Vr17Coa6FqGHZsmBaIoQFfTfO2Rp6pBxhHP+WD39p/hW52l4T+vzNJFMQnzhjRKZWnEx2Ba8IEWf9E08CK9BxDSlaUHz6qLIMSPdpCPjfFHUNIXU2bhKa1Jn6meDJsXc6XcMTHiw02cp7toDmDXcF0/3dwwcmsJL3P/8sOLCy7VOT23TsY3SNKhtbBqKeFXx8pfeX43e94ldO5WhAAAAAElFTkSuQmCC"

/***/ }),

/***/ "JHQG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JRU0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JXTs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("9W5b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03abb44e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("OBEt");
function injectStyle (ssrContext) {
  __webpack_require__("yh+b")
  __webpack_require__("ZKdX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03abb44e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03abb44e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JYcE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap_login"},[_c('mt-header',{staticClass:"yp-topbar",attrs:{"fixed":"","title":"登录"}}),_vm._v(" "),_c('logo'),_vm._v(" "),_c('div',[_c('form',{staticClass:"loginForm",attrs:{"id":"loginForm","onsubmit":"return false"}},[(_vm.isShow)?_c('div',{staticClass:"errowShow"},[_vm._v(_vm._s(_vm.tishi))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isOnly),expression:"!isOnly"}],staticClass:"login_label"},[_vm._v("法院")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"address inputForm",staticStyle:{"width":"68%"},attrs:{"type":"text","placeholder":"请选择","readonly":"readonly"},domProps:{"value":(_vm.address)},on:{"click":function($event){return _vm.modal1()},"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-right",staticStyle:{"position":"absolute","right":".3rem","font-weight":"bolder","color":"#C7C7CC"},on:{"click":function($event){return _vm.modal()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"login_label"},[_vm._v("帐号")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account),expression:"account"}],staticClass:"account inputForm",attrs:{"for":"username","type":"text","placeholder":"请输入帐号"},domProps:{"value":(_vm.account)},on:{"blur":_vm.changeAccount,"focus":_vm.focusAccount,"input":function($event){if($event.target.composing){ return; }_vm.account=$event.target.value}}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"login_label"},[_vm._v("密码")]),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"hidden"}}),_vm._v(" "),((_vm.types)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"password inputForm",attrs:{"for":"password","placeholder":"请输入密码","maxlength":"16","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.password)?_vm._i(_vm.password,null)>-1:(_vm.password)},on:{"change":function($event){var $$a=_vm.password,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.password=$$a.concat([$$v]))}else{$$i>-1&&(_vm.password=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.password=$$c}}}}):((_vm.types)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"password inputForm",attrs:{"for":"password","placeholder":"请输入密码","maxlength":"16","type":"radio"},domProps:{"checked":_vm._q(_vm.password,null)},on:{"change":function($event){_vm.password=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"password inputForm",attrs:{"for":"password","placeholder":"请输入密码","maxlength":"16","type":_vm.types},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"togglePsd",staticStyle:{"top":"0.25rem","width":"0.4rem","height":"0.4rem"},attrs:{"src":_vm.changePsd},on:{"click":_vm.togglePsd}}),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"hidden"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"login_label"},[_vm._v("验证码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkCode),expression:"checkCode"}],staticClass:"checkCode inputForm",attrs:{"type":"text","placeholder":"请输入验证码","maxlength":"6"},domProps:{"value":(_vm.checkCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.checkCode=$event.target.value}}}),_vm._v(" "),_c('img',{ref:"imgBox",attrs:{"id":"imgcontainer","src":_vm.codeUrl},on:{"click":_vm.getCode}})]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0.4rem 0.4rem 0"}},[_c('mt-button',{staticClass:"btn",attrs:{"type":"primary","size":"large"},on:{"click":_vm.toLogin}},[_vm._v("登录")])],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sheetVisible),expression:"sheetVisible"}],staticClass:"model"},[_c('div',{staticClass:"modelTop"},[_c('div',[_c('span',{staticClass:"modelBtn fl",on:{"click":function($event){return _vm.cancel()}}},[_vm._v("取消")]),_vm._v(" "),_c('span',{staticClass:"modelBtn fr",on:{"click":function($event){return _vm.sure()}}},[_vm._v("确定")])])]),_vm._v(" "),_c('div',{staticClass:"ulList"},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.one),expression:"one"}],staticClass:"addressList"},_vm._l((_vm.list1),function(item,index){return _c('li',[_c('div',{staticStyle:{"padding":"0 .3rem"}},[_c('span',{staticClass:"check",class:{'checked': item.ischecked, 'nochecked': !item.ischecked},on:{"click":function($event){return _vm.checked(item)}}}),_vm._v(" "),_c('span',{class:{'fontColor': item.isColor,'nofontColor': !item.isColor},attrs:{"children":_vm.stringfy(item.children)},on:{"click":function($event){return _vm.nextTown(item)}}},[_vm._v(_vm._s(item.tenantName))])])])}),0),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.two),expression:"two"}],staticClass:"addressList"},_vm._l((_vm.list2),function(item,index){return _c('li',[_c('div',{staticStyle:{"padding":"0 .3rem"}},[_c('span',{staticClass:"check",class:{'checked': item.ischecked, 'nochecked': !item.ischecked},on:{"click":function($event){return _vm.checked(item)}}}),_vm._v(" "),_c('span',{class:{'fontColor': item.isColor,'nofontColor': !item.isColor},attrs:{"children":_vm.stringfy(item.children)},on:{"click":function($event){return _vm.nextTown1(item)}}},[_vm._v(_vm._s(item.tenantName))])])])}),0),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.three),expression:"three"}],staticClass:"addressList"},_vm._l((_vm.list3),function(item,index){return _c('li',[_c('div',{staticStyle:{"padding":"0 .3rem"}},[_c('span',{staticClass:"check",class:{'checked': item.ischecked, 'nochecked': !item.ischecked},on:{"click":function($event){return _vm.checked(item,index)}}}),_vm._v(" "),_c('span',{class:{'fontColor': item.isColor,'nofontColor': !item.isColor},attrs:{"children":_vm.stringfy(item.children)},on:{"click":function($event){return _vm.nextTown2(item)}}},[_vm._v(_vm._s(item.tenantName))])])])}),0)])]),_vm._v(" "),(_vm.sheetVisible)?_c('div',{staticClass:"v-model",on:{"click":function($event){_vm.sheetVisible=false;}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",staticStyle:{"display":"none"}},[_c('input',{attrs:{"type":"text"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JZ8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('mt-header',{attrs:{"title":"帐号安全"}},[_c('router-link',{attrs:{"slot":"left","to":"","tag":"div"},slot:"left"},[_c('span',{staticClass:"back",on:{"click":function($event){$event.stopPropagation();return _vm.back.apply(null, arguments)}}})]),_vm._v(" "),_c('span',{class:{'selected': true, 'selected-t': _vm.opacity},attrs:{"slot":"right"},on:{"click":_vm.finish},slot:"right"},[_vm._v(_vm._s(_vm.index))])],1),_vm._v(" "),_c('div',{staticClass:"main",on:{"click":_vm.goFirst}},[_c('mt-cell',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshow),expression:"isshow"}],attrs:{"title":"修改登录密码","is-link":""}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isshow),expression:"!isshow"}],staticClass:"revise"},[_c('form',{attrs:{"action":""}},[(_vm.isShow)?_c('div',{staticClass:"errowShow"},[_vm._v(_vm._s(_vm.tishi))]):_vm._e(),_vm._v(" "),(!_vm.isShow)?_c('div',{staticClass:"tip_info"},[_vm._v("请输入新的密码")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("旧密码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],ref:"input1",staticClass:"inputForm",attrs:{"type":"password","placeholder":"请输入旧密码","maxlength":"16"},domProps:{"value":(_vm.password)},on:{"focus":_vm.focusPassword,"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("新密码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"}],ref:"input2",staticClass:"inputForm",attrs:{"type":"password","placeholder":"请输入8位以上数字字母特殊符号组合","maxlength":"16"},domProps:{"value":(_vm.newPassword)},on:{"blur":_vm.changeNewpassword,"focus":_vm.focusNewpassword,"input":function($event){if($event.target.composing){ return; }_vm.newPassword=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("新密码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirm_password),expression:"confirm_password"}],ref:"input3",staticClass:"inputForm",attrs:{"type":"password","placeholder":"请输入再次输入新密码","maxlength":"16"},domProps:{"value":(_vm.confirm_password)},on:{"mousedown":_vm.focusConfirmpassword,"input":function($event){if($event.target.composing){ return; }_vm.confirm_password=$event.target.value}}})])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JjhU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"mint-header",staticStyle:{"position":"fixed","top":"0","right":"0","left":"0","z-index":"1"}},[_c('h1',{directives:[{name:"show",rawName:"v-show",value:(!_vm.len),expression:"!len"}],staticClass:"mint-header-title"},[_vm._v("操作日志")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.len),expression:"len"}],staticClass:"mint-header-title"},[_vm._v("已选择"+_vm._s(_vm.len)+"文件")]),_vm._v(" "),(_vm.isreally)?_c('router-link',{staticStyle:{"position":"absolute"},attrs:{"to":"/more/setinfo"}},[_c('span',{staticClass:"back"})]):_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChoose),expression:"isChoose"}],staticStyle:{"font-size":".28rem","line-height":"1.2rem","position":"absolute"},on:{"click":function($event){return _vm.choose()}}},[_vm._v("\n      "+_vm._s(_vm.isChooseAll ? '取消全选' : '全选')+"\n    ")]),_vm._v(" "),(_vm.iscancel)?_c('div',{attrs:{"slot":"right"},on:{"click":function($event){return _vm.open()}},slot:"right"},[_c('i',{staticClass:"iconfont icon-xuanze",staticStyle:{"font-size":".36rem","line-height":"1.2rem"}})]):_c('div',{staticStyle:{"font-size":".28rem","line-height":"1.2rem"},attrs:{"slot":"right"},on:{"click":function($event){return _vm.cancel()}},slot:"right"},[_vm._v("\n      取消\n    ")])],1),_vm._v(" "),(_vm.list.length===0)?_c('div',{staticClass:"jpg"},[_vm._m(0)]):_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],ref:"ulBox",staticClass:"main_in",attrs:{"infinite-scroll-distance":"20","infinite-scroll-immediate-check":"false","infinite-scroll-disabled":"moreLoading","id":"mainlist"}},_vm._l((_vm.list),function(item,index){return _c('li',[_c('div',{staticClass:"div"},[_c('div',{staticClass:"left",staticStyle:{"display":"inline-block"}},[_c('em',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshow),expression:"isshow"}],ref:"checks",refInFor:true,staticClass:"checkbox",class:{'checked': item.ischeck, 'nochecked': !item.ischeck},attrs:{"fileId":item.id},on:{"click":function($event){$event.stopPropagation();return _vm.check(item)}}})]),_vm._v(" "),_c('div',{staticClass:"right",staticStyle:{"display":"inline-block","width":"88%"}},[_c('p',[_vm._v(_vm._s(item.content))]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v(_vm._s(item.gmtCreate))])]),_vm._v(" "),_c('div',{class:{'up': _vm.isup===index},attrs:{"id":"more"},on:{"click":function($event){return _vm.toggleUp(index)}}})]),_vm._v(" "),(_vm.select===index)?_c('div',{staticClass:"select"},[_c('ul',{ref:"ul",refInFor:true,attrs:{"fileId":item.id},on:{"click":function($event){return _vm.itemDelete(item)}}},[_c('i',{staticClass:"iconfont icon-lajitong",staticStyle:{"font-size":"22px","color":"#999"}}),_vm._v(" "),_c('p',[_vm._v("删除")])])]):_vm._e()])}),0),_vm._v(" "),_c('div',{staticClass:"meauList"},[(_vm.ischange)?_c('button',{staticClass:"button",on:{"click":function($event){return _vm.one_delete()}}},[_vm._v("一键清空")]):_c('ul',{class:{'selected': _vm.isA, 'selected-t': _vm.opacity},on:{"click":function($event){return _vm.sheetVisibles()}}},[_c('i',{staticClass:"iconfont icon-lajitong",staticStyle:{"font-size":"22px"}}),_vm._v(" "),_c('p',[_vm._v("删除")])])]),_vm._v(" "),_c('mt-actionsheet',{staticClass:"del",attrs:{"actions":_vm.actions},model:{value:(_vm.sheetVisible),callback:function ($$v) {_vm.sheetVisible=$$v},expression:"sheetVisible"}}),_vm._v(" "),_c('mt-actionsheet',{staticClass:"del",attrs:{"actions":_vm.action},model:{value:(_vm.sheetVisibla),callback:function ($$v) {_vm.sheetVisibla=$$v},expression:"sheetVisibla"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":__webpack_require__("2u6q"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("您还没有任何操作～")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K8N0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@^6.5.3","_id":"elliptic@6.5.4","_inBundle":false,"_integrity":"sha512-iLhC6ULemrljPZb+QutR5TQGB+pdW6KGD5RSegS+8sorOZT+rdQFbsQFJgvN3eRqNALqJer4oQ16YvJHlU8hzQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.5.3","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.5.3","saveSpec":null,"fetchSpec":"^6.5.3"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"http://172.16.6.107:7070/repository/npm-group/elliptic/-/elliptic-6.5.4.tgz","_shasum":"da37cebd31e79a1367e941b592ed1fbebd58abbb","_spec":"elliptic@^6.5.3","_where":"/home/jenkins/.jenkins/workspace/Jenkins-107/Cloudstorage/prod_cloudstorage_mobile/node_modules/browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.4"}

/***/ }),

/***/ "Km26":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_changusername_vue__ = __webpack_require__("AbWn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22980e91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_changusername_vue__ = __webpack_require__("mbqF");
function injectStyle (ssrContext) {
  __webpack_require__("YZBe")
  __webpack_require__("WZVd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22980e91"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_changusername_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22980e91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_changusername_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KoGp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addmember_vue__ = __webpack_require__("02uN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_017de64c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addmember_vue__ = __webpack_require__("pVVV");
function injectStyle (ssrContext) {
  __webpack_require__("19DJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-017de64c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addmember_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_017de64c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addmember_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L1o+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collect_vue__ = __webpack_require__("/nRP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27fbfb6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collect_vue__ = __webpack_require__("gzJm");
function injectStyle (ssrContext) {
  __webpack_require__("K8N0")
  __webpack_require__("v0AA")
  __webpack_require__("QW8H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27fbfb6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27fbfb6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L3yj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],ref:"ulBox",staticClass:"ulBox",attrs:{"infinite-scroll-distance":"0","infinite-scroll-immediate-check":"false","infinite-scroll-disabled":"moreLoading"}},_vm._l((_vm.shareArr),function(item,index){return _c('li',[_c('div',{staticClass:"list"},[(_vm.sliceType(item.fileName,item.isDir,item.fileCategory)!=='package')?_c('span',{class:_vm.styleObject(item.fileName,item.isDir,item.fileCategory)},[_c('i',{staticClass:"iconfont",class:_vm.classObject(item.fileName,item.isDir,item.fileCategory)})]):_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-package"}})]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{staticClass:"right"},[_c('h3',[_vm._v(_vm._s(_vm.delateFile(item.fileName, item.shareStatus)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formaTime(item.gmtCreate)))])]),_vm._v(" "),_c('div',{staticClass:"size"},[_vm._v(_vm._s(_vm.expire(item.remainDays)))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.shareStatus!==-1),expression:"item.shareStatus!==-1"}],staticClass:"morea",class:{'more':_vm.up===index},on:{"click":function($event){return _vm.selected(index,item.shareUrl)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.select===index),expression:"select===index"}],staticClass:"select"},[_c('ul',[_c('li',[_c('i',{staticClass:"icon-fuzhidao iconfont",staticStyle:{"font-size":".48rem","display":"block","color":"#999"}}),_vm._v(" "),_c('p',[_c('span',{on:{"click":function($event){return _vm.cancelShare(item.id)}}},[_vm._v("取消分享")])])])])])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LYVb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LkHP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{hello: _vm.hello,'copyhello':_vm.move, 'pb': _vm.fs}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.move && !_vm.fs),expression:"!move && !fs"}],staticClass:"begin",staticStyle:{"height":"100%"}},[(!_vm.isShow)?_c('div',{staticClass:"yp-topbar",attrs:{"id":"search"}},[_c('form',{attrs:{"action":"","onsubmit":"return false"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"type":"text","placeholder":"搜索"},domProps:{"value":(_vm.value)},on:{"focus":function($event){return _vm.focusInput()},"blur":function($event){return _vm.blurInput()},"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-sousuo sousuo"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isClose),expression:"isClose"}],staticClass:"iconfont icon-guanbi1 guangbi",on:{"click":function($event){return _vm.clear(_vm.value)}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.cancelSearch()}}},[_vm._v("取消")]),_vm._v(" "),_c('span',{staticClass:"iconfont icon-sousuo search-list",on:{"click":function($event){return _vm.serchContent()}}})])]):_c('div',{staticClass:"head yp-topbar",attrs:{"id":"head"}},[_c('ul',{staticClass:"clearfix"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.check),expression:"check"},{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],staticClass:"btn fl",attrs:{"type":"button"},domProps:{"value":(_vm.check)},on:{"click":_vm.checkAll,"input":function($event){if($event.target.composing){ return; }_vm.check=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],staticClass:"btn fr",attrs:{"type":"button","value":"取消"},on:{"click":_vm.cancel}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.parentId.length && !_vm.isA>0),expression:"parentId.length && !isA>0"}],staticClass:"back fl",on:{"click":_vm.back}}),_vm._v(" "),_c('li',[_c('span',{attrs:{"id":"title"}},[_vm._v(_vm._s(_vm.index))])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isA),expression:"!isA"}],staticClass:"check-mobile",on:{"click":_vm.checkMobile}})]),_vm._v(" "),(_vm.sheetVisible)?_c('div',{staticClass:"v-model",staticStyle:{"top":"1.28rem"},on:{"click":function($event){_vm.sheetVisible=false;}}}):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"search",on:{"click":function($event){return _vm.search()}}},[_c('input',{attrs:{"type":"text","placeholder":"搜索"}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-sousuo"})]),_vm._v(" "),(_vm.hello.length===0)?_c('div',{staticClass:"jpg"},[_c('div',[_c('img',{attrs:{"src":__webpack_require__("2u6q"),"alt":""}}),_vm._v(" "),_c('p',{ref:"dis"},[_vm._v("无文件/文件夹～")])])]):_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],ref:"ulBox",staticClass:"ulBox",attrs:{"infinite-scroll-distance":"0","infinite-scroll-immediate-check":"false","infinite-scroll-disabled":"moreLoading"}},_vm._l((_vm.hello),function(item,index){return _c('li',[_c('div',{staticClass:"list"},[_c('em',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],ref:"mybox",refInFor:true,staticClass:"check",class:{'checked': _vm.isB},attrs:{"fileId":item.id},on:{"click":function($event){return _vm.checked(index, item.fileId, item.id)}}}),_vm._v(" "),(_vm.slicetype(item.fileName,item.isDir,item.permissionType, item.fileNum, item.shareStatus)!=='icon-package')?_c('span',[_c('i',{staticClass:"iconfont",class:_vm._f("sliceType")(item.fileName,item.isDir, item.permissionType, item.fileNum, item.shareStatus)})]):_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-package"}})]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{staticClass:"right",on:{"click":function($event){return _vm.next(item.fileId, item.id,item.fileName,item.isDir, item.fileNum, item.shareStatus, item.length)}}},[_c('h3',{attrs:{"title":item.fileName}},[_vm._v(_vm._s(item.shareStatus === -1 ? '分享的文件已被删除' :(item.fileName + (item.fileNum > 1 ? '等' : ''))))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("formaTime")(item.gmtCreate)))])]),_vm._v(" "),_c('div',{class:{'more':_vm.up===index},attrs:{"id":"more"},on:{"click":function($event){return _vm.selected(index)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.select===index),expression:"select===index"}],staticClass:"select"},[_c('ul',{staticClass:"clearfix",class:_vm.isRoot&&item.shareStatus!==-1 ? 'yp-ul-2' : 'yp-ul-1'},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.isRoot),expression:"isRoot"}],on:{"click":function($event){return _vm.delAction(item.id,'删除', item.fileId)}}},[_c('i',{staticClass:"iconfont icon-lajitong tubiao"}),_vm._v(" "),_c('p',[_vm._v("删除")])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(item.shareStatus!==-1),expression:"item.shareStatus!==-1"}],on:{"click":function($event){return _vm.delAction(item.id,'保存到', item.fileId)}}},[_c('i',{staticClass:"iconfont icon-yidongdao tubiao"}),_vm._v(" "),_c('p',[_vm._v("保存到")])])])])])}),0),_vm._v(" "),_c('tabbar',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isA),expression:"!isA"}],attrs:{"id":_vm.tab}}),_vm._v(" "),_c('mt-tabbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],class:{'selected': _vm.isA, 'selected-t': _vm.opacity}},[_c('mt-tab-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.isRoot),expression:"isRoot"}],attrs:{"id":"删除"}},[_c('i',{staticClass:"iconfont icon-lajitong tubiao",on:{"click":function($event){return _vm.delActions('删除')}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.delActions('删除')}}},[_vm._v("删除")])]),_vm._v(" "),_c('mt-tab-item',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isRoot),expression:"!isRoot"}],attrs:{"id":"保存到"}},[_c('i',{staticClass:"iconfont icon-yidongdao tubiao",on:{"click":function($event){return _vm.delActions('移动到')}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.delActions('移动到')}}},[_vm._v("保存到")])])],1),_vm._v(" "),(_vm.currentValue)?_c('div',{staticClass:"v-model",on:{"click":function($event){_vm.currentValue=false}}}):_vm._e()],1),_vm._v(" "),(_vm.move)?_c('copy',{attrs:{"operaRow":_vm.operaRow,"checkedItems":_vm.checkedItem,"model":_vm.model,"common":_vm.shareFile},on:{"copy":_vm.listenToCopy,"move":_vm.listenToMove}}):_vm._e(),_vm._v(" "),_c('mt-actionsheet',{staticClass:"del",attrs:{"actions":_vm.delaction},model:{value:(_vm.delVisible),callback:function ($$v) {_vm.delVisible=$$v},expression:"delVisible"}}),_vm._v(" "),_c('mt-popup',{attrs:{"position":"bottom"},model:{value:(_vm.FileModalshow),callback:function ($$v) {_vm.FileModalshow=$$v},expression:"FileModalshow"}},[_c('div',{staticClass:"closeFile"},[_c('span',{staticClass:"closeBtn",on:{"click":function($event){_vm.FileModalshow = false}}},[_vm._v("×")])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.FileModalHtml)}})]),_vm._v(" "),_c('lightbox',{ref:"lightbox",attrs:{"show-light-box":false,"images":_vm.imgArray}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da6ff348_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("7hmw");
function injectStyle (ssrContext) {
  __webpack_require__("Mzid")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da6ff348_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MFPJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{hello: _vm.hello,'copyhello':_vm.move, 'pb': _vm.fs}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.move && !_vm.fs),expression:"!move && !fs"}],staticClass:"begin",staticStyle:{"height":"100%"}},[(_vm.isSearch)?_c('div',{staticClass:"yp-topbar",attrs:{"id":"search"}},[_c('form',{attrs:{"action":"","onsubmit":"return false"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"type":"text","placeholder":"搜索"},domProps:{"value":(_vm.value)},on:{"focus":function($event){return _vm.focusInput()},"blur":function($event){return _vm.blurInput()},"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-sousuo sousuo"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isClose),expression:"isClose"}],staticClass:"iconfont icon-guanbi1 guangbi",on:{"click":function($event){return _vm.clear(_vm.value)}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.cancelSearch()}}},[_vm._v("取消")]),_vm._v(" "),_c('span',{staticClass:"iconfont icon-sousuo search-list",on:{"click":function($event){return _vm.serchContent()}}})])]):_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.headShow),expression:"headShow"}],staticClass:"head yp-topbar",attrs:{"id":"head"}},[_c('ul',{staticClass:"clearfix"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.check),expression:"check"},{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],staticClass:"btn fl",attrs:{"type":"button"},domProps:{"value":(_vm.check)},on:{"click":_vm.checkAll,"input":function($event){if($event.target.composing){ return; }_vm.check=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],staticClass:"btn fr",attrs:{"type":"button","value":"取消"},on:{"click":_vm.cancel}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.shareParentId.length && !_vm.isA>0),expression:"shareParentId.length && !isA>0"}],staticClass:"back fl",on:{"click":_vm.back}}),_vm._v(" "),_c('li',[_c('span',{attrs:{"id":"title"}},[_vm._v(_vm._s(_vm.shareIndex))])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isA),expression:"!isA"}],staticClass:"check-mobile",on:{"click":_vm.checkMobile}}),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isA),expression:"!isA"}],staticClass:"open-mobile",on:{"click":function($event){_vm.sheetVisible? _vm.sheetVisible=false:_vm.sheetVisible=true}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sheetVisible),expression:"sheetVisible"}],class:{'oneClass':_vm.shareParentId.length === 0,'pullUp': _vm.sheetVisible},staticStyle:{"z-index":"2001","display":"none"},attrs:{"id":"selectDown"}},[_c('div',{class:_vm.classType,on:{"click":_vm.prompt}},[_c('i',{staticClass:"iconfont icon-xinjianwenjianjia iconup",class:_vm.classType}),_vm._v(" "),_c('span',[_vm._v("新建文件夹")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shareParentId.length && !_vm.isA>0),expression:"shareParentId.length && !isA>0"}],class:_vm.uploadClass,staticStyle:{"position":"relative"},on:{"click":function($event){return _vm.test(_vm.uploadClass)}}},[_c('i',{staticClass:"iconfont icon-shangchuanwenjian iconup",class:_vm.uploadClass}),_vm._v("\n          上传\n        ")])]),_vm._v(" "),(_vm.sheetVisible)?_c('div',{staticClass:"v-model",staticStyle:{"z-index":"2000","height":"100%","top":"1.28rem"},on:{"click":function($event){_vm.sheetVisible=false;}}}):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSearch),expression:"!isSearch"}],staticClass:"search",on:{"click":function($event){return _vm.search()}}},[_c('input',{attrs:{"type":"text","placeholder":"搜索"}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-sousuo"})]),_vm._v(" "),(_vm.hello.length===0)?_c('div',{staticClass:"jpg"},[_c('div',[_c('img',{attrs:{"src":__webpack_require__("2u6q"),"alt":""}}),_vm._v(" "),_c('p',{ref:"dis"},[_vm._v("您还没上传过文件/文件夹～")])])]):_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],ref:"ulBox",staticClass:"ulBox",class:{ulcontent: _vm.isIphoneX},attrs:{"infinite-scroll-distance":"0","infinite-scroll-immediate-check":"false","infinite-scroll-disabled":"moreLoading"}},_vm._l((_vm.hello),function(item,index){return _c('li',[_c('div',{staticClass:"list"},[_c('em',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],ref:"mybox",refInFor:true,staticClass:"check",class:{'checked': _vm.isB},attrs:{"fileId":item.id},on:{"click":function($event){return _vm.checked(index)}}}),_vm._v(" "),(_vm.slicetype(item.fileName,item.isDir,item.permissionType)!=='package')?_c('span',[_c('i',{staticClass:"iconfont",class:_vm._f("sliceType")(item.fileName,item.isDir, item.permissionType)})]):_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-package"}})]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{staticClass:"right",on:{"click":function($event){return _vm.next(item.id,item.fileName,item.isDir, item.permissionType)}}},[_c('h3',{attrs:{"title":item.fileName}},[_vm._v(_vm._s(item.fileName))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.nickname)+"创建于"+_vm._s(_vm._f("formaTime")(item.gmtModified)))])]),_vm._v(" "),_c('div',{staticClass:"size"},[_vm._v(_vm._s(_vm._f("bytesToSize")(item.length)))]),_vm._v(" "),_c('div',{class:{'more':_vm.up===index},attrs:{"id":"more"},on:{"click":function($event){return _vm.selected(index)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.select===index),expression:"select===index"}],staticClass:"select"},[_c('ul',{staticClass:"clearfix",class:{'child':_vm.shareParentId.length>0}},[(_vm.shareParentId.length===0)?_c('li',{class:{'isClip':!_vm.operaPermissionJudge(item.permissionType, '设置')},on:{"click":function($event){return _vm.delAction(item.id,'设置',item.permissionType)}}},[_c('i',{staticClass:"iconfont icon-shezhi tubiao"}),_vm._v(" "),_c('p',[_vm._v("设置")])]):_vm._e(),_vm._v(" "),_c('li',{class:{'isClip':!_vm.operaPermissionJudge(item.permissionType, '分享')},on:{"click":function($event){return _vm.delAction(item.id,'分享',item.permissionType)}}},[_c('i',{staticClass:"iconfont icon-fenxiang tubiao"}),_vm._v(" "),_c('p',[_vm._v("分享")])]),_vm._v(" "),_c('li',{class:{'isClip':[3,4].indexOf(item.permissionType) === -1},on:{"click":function($event){return _vm.delAction(item.id,'删除', item.permissionType)}}},[_c('i',{staticClass:"iconfont icon-lajitong tubiao"}),_vm._v(" "),_c('p',[_vm._v("删除")])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.delAction(item.id,'更多',item.permissionType,item.isDir,item.isFavorite,item.fileName, index)}}},[_c('i',{staticClass:"iconfont icon-gengduodefuben tubiao"}),_vm._v(" "),_c('p',[_vm._v("更多")])])])])])}),0),_vm._v(" "),_c('tabbar',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isA),expression:"!isA"}],attrs:{"id":2}}),_vm._v(" "),_c('mt-tabbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],class:{'selected': _vm.isA, 'selected-t': _vm.opacity, ulcontent: _vm.isIphoneX}},[(_vm.operaPermissionJudge(_vm.LvType, '分享'))?_c('mt-tab-item',{attrs:{"id":"分享"}},[_c('i',{staticClass:"iconfont icon-fenxiang tubiao",on:{"click":function($event){return _vm.delActions('分享')}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.delActions('分享')}}},[_vm._v("分享")])]):_vm._e(),_vm._v(" "),(_vm.shareParentId.length>0 && _vm.operaPermissionJudge(_vm.LvType, '删除'))?_c('mt-tab-item',{attrs:{"id":"删除"}},[_c('i',{staticClass:"iconfont icon-lajitong tubiao",on:{"click":function($event){return _vm.delActions('删除')}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.delActions('删除')}}},[_vm._v("删除")])]):_vm._e(),_vm._v(" "),(_vm.shareParentId.length>0 && _vm.operaPermissionJudge(_vm.LvType, '移动到'))?_c('mt-tab-item',{attrs:{"id":"移动到"}},[_c('i',{staticClass:"iconfont icon-yidongdao tubiao",on:{"click":function($event){return _vm.delActions('移动到')}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.delActions('移动到')}}},[_vm._v("移动到")])]):_vm._e(),_vm._v(" "),(_vm.shareParentId.length>0 && _vm.operaPermissionJudge(_vm.LvType, '复制到'))?_c('mt-tab-item',{attrs:{"id":"复制到"}},[_c('i',{staticClass:"iconfont icon-fuzhidao tubiao",on:{"click":function($event){return _vm.delActions('复制到')}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.delActions('复制到')}}},[_vm._v("复制到")])]):_vm._e()],1),_vm._v(" "),_c('mt-actionsheet',{attrs:{"actions":_vm.action},model:{value:(_vm.sheet),callback:function ($$v) {_vm.sheet=$$v},expression:"sheet"}}),_vm._v(" "),_c('mt-actionsheet',{attrs:{"actions":_vm.actionson},model:{value:(_vm.sheetson),callback:function ($$v) {_vm.sheetson=$$v},expression:"sheetson"}}),_vm._v(" "),(_vm.currentValue)?_c('share',{attrs:{"fileId":_vm.fileId},on:{"share":_vm.listenToShare}}):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('div',{staticClass:"v-model",on:{"click":function($event){_vm.currentValue=false}}}):_vm._e()],1),_vm._v(" "),(_vm.move)?_c('copy',{attrs:{"fileId":_vm.fileId,"model":_vm.model,"common":_vm.shareFile},on:{"copy":_vm.listenToCopy,"move":_vm.listenToMove}}):_vm._e(),_vm._v(" "),_c('lightbox',{ref:"lightbox",attrs:{"show-light-box":false,"images":_vm.imgArray}}),_vm._v(" "),_c('mt-popup',{attrs:{"position":"bottom"},model:{value:(_vm.FileModalshow),callback:function ($$v) {_vm.FileModalshow=$$v},expression:"FileModalshow"}},[_c('div',{staticClass:"closeFile"},[_c('span',{staticClass:"closeBtn",on:{"click":function($event){_vm.FileModalshow = false}}},[_vm._v("×")])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.FileModalHtml)}})]),_vm._v(" "),_c('mt-actionsheet',{staticClass:"del",attrs:{"actions":_vm.delaction},model:{value:(_vm.delVisible),callback:function ($$v) {_vm.delVisible=$$v},expression:"delVisible"}}),_vm._v(" "),(_vm.triggerAddMember)?_c('div',{attrs:{"id":"addMember"}},[_c('addmember',{attrs:{"dataList":_vm.dataList,"confirmOperation":_vm.confirmOperation,"cancelOperation":_vm.cancelOperation}})],1):_vm._e(),_vm._v(" "),(_vm.fs)?_c('install',{attrs:{"fileId":_vm.fileId,"configFlag":_vm.addType},on:{"add":_vm.add,"child":_vm.listenToMyBoy}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MTyd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabbar_vue__ = __webpack_require__("uaVK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_186fa672_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabbar_vue__ = __webpack_require__("+Iw0");
function injectStyle (ssrContext) {
  __webpack_require__("UCkG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-186fa672"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_186fa672_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mg8F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var baseUrl = __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].app.cloudStorage.baseUrl;
var imgUrl = baseUrl + '/api/userGroup/icon/get';

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [],
      isChoose: false, // 是否触发勾选
      isChooseAll: false,
      selectCount: 0,
      ids: [], // 需要操作的行
      selectRow: {},
      deleteTrigger: false, // 删除确认触发
      page: {
        pageNo: 0,
        pageSize: 20,
        totalElements: 0
      },
      isDialogShow: false,
      newGroupName: '新增群组',
      placeholder: '请输入群组名称'
    };
  },
  created: function created() {
    this.tableInit();
  },

  watch: {
    isDialogShow: function isDialogShow(val) {
      var _this = this;

      console.log(1);
      if (val) {
        __WEBPACK_IMPORTED_MODULE_2_mint_ui__["MessageBox"].prompt('新增群组', '', {
          showInput: true,
          inputValue: this.newGroupName,
          inputPattern: /^.{1,10}$/,
          inputErrorMessage: '名字长度为1-10个字符'
        }).then(function (_ref) {
          var value = _ref.value,
              action = _ref.action;

          _this.newGroupName = value;
          _this.addGroup();
          _this.isDialogShow = false;
        }).catch(function () {
          _this.isDialogShow = false;
        });
      }
    }
  },
  computed: {
    bottom: function bottom() {
      return this.isChoose ? '0.98rem' : 0;
    },
    isShadeShow: function isShadeShow() {
      return this.isDialogShow || this.deleteTrigger;
    }
  },
  methods: {
    groupListScroll: function groupListScroll() {
      var content = document.getElementById('main');
      if (content.scrollHeight - content.scrollTop - content.offsetHeight < 10) {
        if (this.page.totalElements > this.tableData.length) {
          this.queryGroupList();
        }
      }
    },

    // 成员管理
    memberManage: function memberManage(item) {
      this.$router.push({ path: '/memberManage', query: { groupName: item.groupName, groupId: item.id } });
    },

    // 新增群组
    addGroup: function addGroup() {
      var _this2 = this;

      if (!this.newGroupName && this.newGroupName !== 0) {
        Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
          message: '请输入群组名称',
          iconClass: 'icon-error'
        });
      }
      if (this.selectRow.isRename && this.selectRow.groupName === this.newGroupName) {
        this.isDialogShow = false;
        this.selectRow.isRename = false;
        return false;
      }
      var isDuplication = this.tableData.some(function (row, index, array) {
        if (row.groupName === _this2.newGroupName) {
          Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
            message: '群组重名，请重新输入',
            iconClass: 'icon-error'
          });
          return true;
        }
        return false;
      });
      if (isDuplication) {
        return true;
      }
      if (!this.selectRow.isRename) {
        __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_0__apis_cloudStorageApi__["a" /* default */].addGroup, { groupName: this.newGroupName }).then(function () {
          _this2.isDialogShow = false;
          _this2.newGroupName = '新增群组';
          _this2.tableInit();
          Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
            message: '新增成功',
            iconClass: 'icon-success'
          });
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_0__apis_cloudStorageApi__["a" /* default */].modifyGroup, { id: this.selectRow.id, groupName: this.newGroupName }).then(function () {
          _this2.isDialogShow = false;
          _this2.selectRow.isRename = false;
          _this2.selectRow.groupName = _this2.newGroupName;
          _this2.newGroupName = '';
          Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
            message: '重命名成功',
            iconClass: 'icon-success'
          });
        });
      }
    },

    // 触发checkbox显示
    triggerChoose: function triggerChoose() {
      this.isChoose = true;
      if (this.selectRow.isXiala) {
        this.selectRow.isXiala = !this.selectRow.isXiala;
        this.selectRow.isTransform = !this.selectRow.isTransform;
      }
    },

    // 删除选中群组
    confirmDelete: function confirmDelete() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_0__apis_cloudStorageApi__["a" /* default */].deleteGroup, { ids: this.ids.join(',') }).then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
          message: '删除成功',
          iconClass: 'icon-success'
        });
        _this3.deleteTrigger = false;
        _this3.selectCount = 0;
        _this3.tableData = _this3.tableData.filter(function (row, index, array) {
          // 将未删除的数据重新赋值给列表数据
          if (_this3.ids.indexOf(row.id) === -1) {
            // 重新计算选中个数
            if (row.isSelected) {
              _this3.selectCount++;
            }
            return true;
          }
          return false;
        });
        _this3.ids = [];
        if (!_this3.tableData.length) {
          _this3.isChoose = false;
        }
      });
    },

    // 存储需要删除的行并弹出确认操作
    deleteGroup: function deleteGroup(item) {
      var _this4 = this;

      if (item) {
        this.ids.push(item.id);
      } else {
        this.tableData.forEach(function (value, index, array) {
          if (value.isSelected) {
            _this4.ids.push(value.id);
          }
        });
      }
      this.deleteTrigger = true;
    },

    // 点击下拉图标
    xialaClick: function xialaClick(item) {
      if (!item.isXiala) {
        if (this.selectRow.isXiala) {
          this.selectRow.isXiala = !this.selectRow.isXiala;
          this.selectRow.isTransform = !this.selectRow.isTransform;
        }
        this.selectRow = item;
      }
      item.isXiala = !item.isXiala;
      item.isTransform = !item.isTransform;
    },

    // 列表数据初始化
    tableInit: function tableInit() {
      this.tableData = [];
      this.page.pageNo = 0;
      this.page.totalElements = 0;
      this.queryGroupList();
    },
    queryGroupList: function queryGroupList() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_0__apis_cloudStorageApi__["a" /* default */].groupList, {
        page: this.page.pageNo,
        size: this.page.pageSize
      }).then(function (response) {
        response.data.content.forEach(function (row, index, array) {
          row.isSelected = false;
          row.isXiala = false;
          row.isTransform = false;
          row.imgUrl = imgUrl + '?id=' + row.id;
        });
        _this5.tableData = _this5.tableData.concat(response.data.content);
        _this5.page.totalElements = response.data.totalElements;
      });
      this.page.pageNo++;
    },

    // 返回
    returnBack: function returnBack() {
      this.$router.push('/more/setinfo');
    },

    // 全选或取消全选
    choose: function choose() {
      if (this.isChooseAll) {
        this.cancleChooseAll();
      } else {
        this.chooseAll();
      }
    },

    // 取消全选
    cancleChooseAll: function cancleChooseAll() {
      this.selectCount = 0;
      this.isChooseAll = false;
      this.tableData.forEach(function (row, index, array) {
        row.isSelected = false;
      });
    },

    // 全选
    chooseAll: function chooseAll() {
      this.selectCount = this.tableData.length;
      this.isChooseAll = true;
      this.tableData.forEach(function (row, index, array) {
        row.isSelected = true;
      });
    },
    cancle: function cancle() {
      this.isChoose = false;
      if (this.selectRow.isXiala) {
        this.selectRow.isXiala = !this.selectRow.isXiala;
        this.selectRow.isTransform = !this.selectRow.isTransform;
      }
      this.cancleChooseAll();
    },
    chooseOne: function chooseOne(item) {
      if (item.isSelected) {
        item.isSelected = false;
        this.selectCount--;
        if (this.isChooseAll) {
          this.isChooseAll = false;
        }
      } else {
        item.isSelected = true;
        this.selectCount++;
        if (this.selectCount === this.tableData.length) {
          this.isChooseAll = true;
        }
      }
    }
  }
});

/***/ }),

/***/ "Mh5X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mzid":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_mint_ui_css__ = __webpack_require__("ncsR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_mint_ui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_css_mint_ui_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_simple_uploader__ = __webpack_require__("LgDO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_simple_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_simple_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_img__ = __webpack_require__("Rwp6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_store_index__ = __webpack_require__("2VMZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_fileters__ = __webpack_require__("ZPUo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_CustomFunction__ = __webpack_require__("Wfzo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_lazyload__ = __webpack_require__("AXdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_touch__ = __webpack_require__("I0MY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_touch__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */









// import VueTouch from 'vue-touch'




__webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "nefe"));
__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "ksBL"));



__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "0OCa"));

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_lazyload__["default"]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_touch___default.a, { name: 'v-touch' });
Array.prototype.remove = function (obj) {
  for (var i = 0; i < this.length; i++) {
    var temp = this[i];
    if (!isNaN(obj)) {
      temp = i;
    }
    if (temp == obj) {
      for (var j = i; j < this.length; j++) {
        this[j] = this[j + 1];
      }
      this.length = this.length - 1;
    }
  }
};
Date.prototype.format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours() % 12 === 0 ? 12 : this.getHours() % 12,
    'H+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds()
  };
  var week = {
    '0': '日',
    '1': '一',
    '2': '二',
    '3': '三',
    '4': '四',
    '5': '五',
    '6': '六'
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? '星期' : '周' : '') + week[this.getDay() + '']);
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_6_axios___default.a;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$customFunctions = __WEBPACK_IMPORTED_MODULE_12__utils_CustomFunction__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$customStore = __WEBPACK_IMPORTED_MODULE_10__views_store_index__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_simple_uploader___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_mint_ui___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_v_img__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_jquery___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

window.addEventListener('popstate', function (event) {
  if (window.__wxjs_environment !== 'miniprogram') {
    window.history.pushState('forward', null, '#' + __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].history.current.fullPath);
    window.history.forward(1);
  }
});

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].afterEach(function (ref) {
  console.log(ref.path);
  // if (ref.path === '/account/register' || ref.path === '/account/forget' || ref.path === '/modifyPassword') {
  if (ref.path === '/account/register' || ref.path === '/account/forget' || ref.path === '/index' || ref.path === '/modifyPassword') {} else {
    if (sessionStorage.getItem('mobileData') === null) {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: '/login' });
    }
  }
  if (ref.path === '/index') {
    window.sessionStorage.setItem('index', '个人文件');
  }
  if (ref.path === '/shareFile') {
    window.sessionStorage.setItem('shareIndex', '共享文件');
  }
});

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_11__components_fileters__["a" /* default */]).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_11__components_fileters__["a" /* default */][key]);
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_10__views_store_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NV5O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O2Ex":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard__ = __webpack_require__("V33R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__ = __webpack_require__("kRT9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      shareArr: [],
      info: {
        page: 0,
        size: 20
      },
      page: 0,
      size: 20,
      totalPages: '',
      shareUrl: '',
      domin: '',
      select: '',
      up: ''
    };
  },

  methods: {
    selected: function selected(index, shareUrl) {
      var _this = this;
      _this.domin = window.location.protocol + '//' + window.location.host;
      _this.shareUrl = this.domin + shareUrl;
      new __WEBPACK_IMPORTED_MODULE_1_clipboard___default.a('#clipboard', {
        text: function text() {
          Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
            message: '复制成功',
            iconClass: 'icon-success'
          });
          return _this.shareUrl;
        }
      });
      if (this.select === index) {
        this.select = '';
        this.up = '';
      } else {
        this.select = index;
        this.up = index;
      }
    },
    classObject: function classObject(val, val2, val3) {
      var type = this.sliceType(val, val2, val3);
      return 'icon-' + type;
    },
    styleObject: function styleObject(val, val2, val3) {
      var type = this.sliceType(val, val2, val3);
      if (type === 'excel') {
        return 'excel';
      } else if (type === 'pdf') {
        return 'pdf';
      } else if (type === 'word') {
        return 'word';
      } else if (type === 'txt') {
        return 'txt';
      } else if (type === 'pic') {
        return 'pic';
      } else if (type === 'muisc') {
        return 'muisc';
      } else if (type === 'dir') {
        return 'dir';
      } else if (type === 'html') {
        return 'html';
      } else if (type === 'shareDir') {
        return 'shareDir1';
      } else {
        return 'weizhi';
      }
    },

    expire: function expire(time) {
      if (!time) {
        return '永久有效';
      } else {
        return time + '天后到期';
      }
    },
    delateFile: function delateFile(val, statu) {
      if (statu === -1) {
        return '分享的文件已被删除';
      } else {
        return val;
      }
    },
    sliceType: function sliceType(val, num, flag) {
      if (num === 1) {
        if (flag === 2) {
          return 'shareDir';
        } else {
          return 'dir';
        }
      }
      if (val !== '' || undefined) {
        var point = val.lastIndexOf('.');
        var type = val.substring(point + 1).toLowerCase();
        if (type === 'jpg' || type === 'gif' || type === 'JPG' || type === 'GIF' || type === 'png' || type === 'JPEG' || type === 'jpeg') {
          return 'pic';
        } else if (type === 'avi' || type === 'rmvb' || type === 'rm' || type === 'asf' || type === 'divx' || type === 'mpg' || type === 'mpeg' || type === 'mpe' || type === 'mp4' || type === 'mkv' || type === 'vob ') {
          return 'video';
        } else if (type === 'WAVE' || type === 'AIFF' || type === 'MPEG' || type === 'MP3' || type === 'MIDI' || type === 'mp3') {
          return 'muisc';
        } else if (num === 1) {
          return 'dir';
        } else if (type === 'txt') {
          return 'txt';
        } else if (type === 'pdf') {
          return 'pdf';
        } else if (type === 'doc' || type === 'docx') {
          return 'word';
        } else if (type === 'ppt' || type === 'pptx') {
          return 'ppt';
        } else if (type === 'xls' || type === 'xlsx') {
          return 'excel';
        } else if (type === 'html' || type === 'htm') {
          return 'html';
        } else if (type === 'wps' || type === 'wpt') {
          return 'wps';
        } else if (type === 'zip' || type === 'rar') {
          return 'package';
        } else {
          return 'default';
        }
      }
    },
    formaTime: function formaTime(val) {
      if (val !== '' || undefined || null) {
        return new Date(val).format('yyyy-MM-dd HH:mm');
      }
    },
    bytesToSize: function bytesToSize(bytes) {
      if (bytes === 0) return '0 B';
      if (bytes === '') return '';
      var k = 1024;
      var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return (bytes / Math.pow(k, i)).toPrecision(3) + sizes[i];
    },
    load: function load() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].sharelist, this.info).then(function (response) {
        var data = response.data.content;
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            _this2.shareArr.push(data[i]);
          }
          _this2.totalPages = response.data.totalPages;
        }
        return false;
      }).catch(function (error) {});
    },
    loadMore: function loadMore() {
      var _this3 = this;

      this.loading = true;
      setTimeout(function () {
        var _this = _this3;
        if (_this.page < _this.totalPages) {
          _this.page++;
        }
        __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].sharelist, { page: _this.page, size: _this.size }).then(function (res) {
          var list0 = [];
          var data = res.data.content;
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              list0.push(data[i]);
            }
            if (_this.shareArr && list0) {
              _this.shareArr = _this.shareArr.concat(list0);
            }
          }
        });
        _this3.loading = false;
      }, 250);
    }
  },
  created: function created() {
    this.load();
  }
});

/***/ }),

/***/ "OBEt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{hello: _vm.hello,'copyhello':_vm.move, 'pb': _vm.fs}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.move && !_vm.fs),expression:"!move && !fs"}],staticClass:"begin",staticStyle:{"height":"100%"}},[(_vm.isSearch)?_c('div',{staticClass:"yp-topbar",attrs:{"id":"search"}},[_c('form',{attrs:{"action":"","onsubmit":"return false"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"type":"text","placeholder":"搜索"},domProps:{"value":(_vm.value)},on:{"focus":function($event){return _vm.focusInput()},"blur":function($event){return _vm.blurInput()},"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-sousuo sousuo"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isClose),expression:"isClose"}],staticClass:"iconfont icon-guanbi1 guangbi",on:{"click":function($event){return _vm.clear(_vm.value)}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.cancelSearch()}}},[_vm._v("取消")]),_vm._v(" "),_c('span',{staticClass:"iconfont icon-sousuo search-list",on:{"click":function($event){return _vm.serchContent()}}})])]):_c('div',{staticClass:"head yp-topbar",attrs:{"id":"head"}},[_c('ul',{staticClass:"clearfix"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.check),expression:"check"},{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],staticClass:"btn fl",attrs:{"type":"button"},domProps:{"value":(_vm.check)},on:{"click":_vm.checkAll,"input":function($event){if($event.target.composing){ return; }_vm.check=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],staticClass:"btn fr",attrs:{"type":"button","value":"取消"},on:{"click":_vm.cancel}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.parentId.length && !_vm.isA>0),expression:"parentId.length && !isA>0"}],staticClass:"back fl",on:{"click":_vm.back}}),_vm._v(" "),_c('li',[_c('span',{attrs:{"id":"title"}},[_vm._v(_vm._s(_vm.index))])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isA),expression:"!isA"}],staticClass:"check-mobile",on:{"click":_vm.checkMobile}}),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isA),expression:"!isA"}],staticClass:"open-mobile",on:{"click":function($event){_vm.sheetVisible? _vm.sheetVisible=false:_vm.sheetVisible=true}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sheetVisible),expression:"sheetVisible"}],class:{'pullUp': _vm.sheetVisible},attrs:{"id":"selectDown"}},[_c('div',{on:{"click":_vm.prompt}},[_c('i',{staticClass:"iconfont icon-xinjianwenjianjia"}),_vm._v(" "),_c('span',[_vm._v("新建文件夹")])]),_vm._v(" "),(_vm.isCanUpload)?_c('div',{staticStyle:{"position":"relative"},on:{"click":_vm.test}},[_c('i',{staticClass:"iconfont icon-shangchuanwenjian"}),_vm._v("\n          上传\n        ")]):_vm._e()]),_vm._v(" "),(_vm.sheetVisible)?_c('div',{staticClass:"v-model",staticStyle:{"top":"1.28rem"},on:{"click":function($event){_vm.sheetVisible=false;}}}):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSearch),expression:"!isSearch"}],staticClass:"search",on:{"click":function($event){return _vm.search()}}},[_c('input',{attrs:{"type":"text","placeholder":"搜索"}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-sousuo"})]),_vm._v(" "),(_vm.hello.length===0)?_c('div',{staticClass:"jpg"},[_c('div',[_c('img',{attrs:{"src":__webpack_require__("2u6q"),"alt":""}}),_vm._v(" "),_c('p',{ref:"dis"},[_vm._v("您还没上传过文件/文件夹～")])])]):_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],ref:"ulBox",staticClass:"ulBox",class:{ulcontent: _vm.isIphoneX},attrs:{"infinite-scroll-distance":"30","infinite-scroll-immediate-check":"false","infinite-scroll-disabled":"true"}},_vm._l((_vm.hello),function(item,index){return _c('li',[_c('div',{staticClass:"list"},[_c('em',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],ref:"mybox",refInFor:true,staticClass:"check",class:{'checked': item.ischecked},attrs:{"fileId":item.id},on:{"click":function($event){return _vm.checked(index)}}}),_vm._v(" "),(_vm.slicetype(item.fileName,item.isDir,item.permissionType)!=='icon-package')?_c('span',[_c('i',{staticClass:"iconfont",class:_vm._f("sliceType")(item.fileName,item.isDir, item.permissionType)})]):_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-package"}})]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{staticClass:"right",on:{"click":function($event){return _vm.next(item.id,item.fileName,item.isDir, index, item.length)}}},[_c('h3',{attrs:{"title":item.fileName}},[_vm._v(_vm._s(item.fileName))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("formaTime")(item.gmtModified)))])]),_vm._v(" "),_c('div',{staticClass:"size"},[_vm._v(_vm._s(_vm._f("bytesToSize")(item.length)))]),_vm._v(" "),_c('div',{class:{'more':_vm.up===index},attrs:{"id":"more"},on:{"click":function($event){return _vm.selected(index)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.select===index),expression:"select===index"}],staticClass:"select"},[_c('ul',{staticClass:"clearfix"},[_c('li',{on:{"click":function($event){return _vm.delAction(item.id,'分享')}}},[_c('i',{staticClass:"iconfont icon-fenxiang tubiao"}),_vm._v(" "),_c('p',[_vm._v("分享")])]),_vm._v(" "),(_vm.isCanDownload)?_c('li',{on:{"click":function($event){return _vm.downLoad('1',item.id,item.isDir,'',item.fileName)}}},[_c('i',{staticClass:"iconfont icon-xiazai tubiao"}),_vm._v(" "),_c('p',[_vm._v("下载")])]):_vm._e(),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.delAction(item.id,'删除')}}},[_c('i',{staticClass:"iconfont icon-lajitong tubiao"}),_vm._v(" "),_c('p',[_vm._v("删除")])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.delAction(item.id,'更多',index,item.isDir,item.isFavorite,item.fileName)}}},[_c('i',{staticClass:"iconfont icon-gengduodefuben tubiao"}),_vm._v(" "),_c('p',[_vm._v("更多")])])])])])}),0),_vm._v(" "),_c('tabbar',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isA),expression:"!isA"}],attrs:{"id":_vm.tab}}),_vm._v(" "),_c('mt-tabbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],class:{'selected': _vm.isA, 'selected-t': _vm.opacity, ulcontent: _vm.isIphoneX}},[_c('mt-tab-item',{attrs:{"id":"分享"}},[_c('i',{staticClass:"iconfont icon-fenxiang tubiao",on:{"click":function($event){return _vm.delActions('分享')}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.delActions('分享')}}},[_vm._v("分享")])]),_vm._v(" "),_c('mt-tab-item',{attrs:{"id":"删除"}},[_c('i',{staticClass:"iconfont icon-lajitong tubiao",on:{"click":function($event){return _vm.delActions('删除')}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.delActions('删除')}}},[_vm._v("删除")])]),_vm._v(" "),_c('mt-tab-item',{attrs:{"id":"移动到"}},[_c('i',{staticClass:"iconfont icon-yidongdao tubiao",on:{"click":function($event){return _vm.delActions('移动到')}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.delActions('移动到')}}},[_vm._v("移动到")])]),_vm._v(" "),_c('mt-tab-item',{attrs:{"id":"下载"}},[_c('i',{staticClass:"iconfont icon-xiazai tubiao",on:{"click":function($event){return _vm.delActions('下载')}}}),_vm._v("\n        下载\n      ")]),_vm._v(" "),_c('mt-tab-item',{attrs:{"id":"复制到"}},[_c('i',{staticClass:"iconfont icon-fuzhidao tubiao",on:{"click":function($event){return _vm.delActions('复制到')}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.delActions('复制到')}}},[_vm._v("复制到")])])],1),_vm._v(" "),_c('mt-actionsheet',{attrs:{"actions":_vm.action},model:{value:(_vm.sheet),callback:function ($$v) {_vm.sheet=$$v},expression:"sheet"}}),_vm._v(" "),_c('mt-actionsheet',{attrs:{"actions":_vm.actionh},model:{value:(_vm.history),callback:function ($$v) {_vm.history=$$v},expression:"history"}}),_vm._v(" "),(_vm.currentValue)?_c('share',{attrs:{"fileId":_vm.fileId},on:{"share":_vm.listenToShare}}):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('div',{staticClass:"v-model",on:{"click":function($event){_vm.currentValue=false}}}):_vm._e()],1),_vm._v(" "),(_vm.move)?_c('copy',{attrs:{"fileId":_vm.fileId,"model":_vm.model,"common":_vm.shareFile},on:{"copy":_vm.listenToCopy,"move":_vm.listenToMove}}):_vm._e(),_vm._v(" "),_c('mt-actionsheet',{staticClass:"del",attrs:{"actions":_vm.delaction},model:{value:(_vm.delVisible),callback:function ($$v) {_vm.delVisible=$$v},expression:"delVisible"}}),_vm._v(" "),(_vm.fs)?_c('history',{attrs:{"fileId":_vm.fileId},on:{"history":_vm.listenToHistory}}):_vm._e(),_vm._v(" "),_c('mt-popup',{attrs:{"position":"bottom"},model:{value:(_vm.FileModalshow),callback:function ($$v) {_vm.FileModalshow=$$v},expression:"FileModalshow"}},[_c('div',{staticClass:"closeFile"},[_c('span',{staticClass:"closeBtn",on:{"click":function($event){_vm.FileModalshow = false}}},[_vm._v("×")])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.FileModalHtml)}})]),_vm._v(" "),_c('lightbox',{ref:"lightbox",attrs:{"show-light-box":false,"images":_vm.imgArray}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OHVs":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "PMk8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'copy',
  data: function data() {
    return {
      hello: [],
      index: '个人文件',
      move: false,
      parentId: [],
      shareParentId: [],
      shareIndex: '共享文件',
      sharePid: '',
      shareFileIds: '',
      shareTarget: true,
      //        控制title的样式参数
      share: false,
      person: false,
      kind: false,
      pid: 'rootpath',
      page: 0,
      copypage: 0
    };
  },
  created: function created() {
    var _this = this;
    if (_this.common) {
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].shareFiles, { fileId: _this.shareFileIds, page: 0, size: 20 }).then(function (res) {
        _this.hello = res.data.content;
      }).catch(function (res) {});
    } else {
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].searchFile, { fileId: _this.pid, page: 0, size: 20 }).then(function (response) {
        _this.hello = response.data.content;
      }).catch(function (error) {});
    }
    this.slicetype = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].filter('sliceType');
    this.shareTarget = !this.common;
    this.person = this.common;
  },

  methods: {
    copy: function copy() {},
    //      确认复制
    copyEnd: function copyEnd() {
      var _this2 = this;

      var _this = this;
      var com = _this.model.substring(0, 2);
      if (_this.shareTarget === true) {
        if (com === '复制') {
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].copyFiles, { fileIds: _this.fileId, targetFileId: _this.pid }).then(function (res) {
            _this.$emit('copy', false);
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: '文件复制成功',
              iconClass: 'icon-success'
            });
          }).catch(function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: error.response.data.message,
              iconClass: 'icon-error'
            });
          });
        } else if (com === '移动') {
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].moveFiles, { fileIds: _this.fileId, targetFileId: _this.pid }).then(function (res) {
            _this.$emit('move', _this.fileId);
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: '文件移动成功',
              iconClass: 'icon-success'
            });
          }).catch(function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: error.response.data.message,
              iconClass: 'icon-error'
            });
          });
        } else if (com === '保存') {
          var assignedShareId = null;
          var fileIds = [];
          if (this.operaRow.id) {
            assignedShareId = this.operaRow.id;
            fileIds.push(this.operaRow.fileId);
          } else {
            this.checkedItems.forEach(function (value) {
              assignedShareId = value.id;
              fileIds.push(value.fileIds);
            });
          }
          if (!fileIds[0]) {
            fileIds = [];
          }
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].saveOtherShare, { 'queryStr': window.encodeURI(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
              fileArr: [{
                assignedShareId: assignedShareId,
                fileIds: fileIds
              }],
              targetFileId: _this.pid
            })) }).then(function (res) {
            _this.$emit('move', _this2.operaRow);
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: '文件保存成功',
              iconClass: 'icon-success'
            });
          }).catch(function (error) {
            console.dir(error);
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: error.response.data.message,
              iconClass: 'icon-error'
            });
          });
        }
      } else if (_this.shareTarget === false) {
        if (com === '复制') {
          if (_this.sharePid === '') {
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: '请选择目标文件夹',
              iconClass: 'icon-error'
            });
            return false;
          }
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].copyFiles, {
            fileIds: _this.fileId,
            targetFileId: _this.sharePid
          }).then(function (res) {
            _this.$emit('copy', false);
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: '文件复制成功',
              iconClass: 'icon-success'
            });
          }).catch(function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: error.response.data.message,
              iconClass: 'icon-error'
            });
          });
        } else if (com === '移动') {
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].moveFiles, {
            fileIds: _this.fileId,
            targetFileId: _this.sharePid
          }).then(function (res) {
            if (_this.sharePid === '') {
              Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
                message: '请选择目标文件夹',
                iconClass: 'icon-error'
              });
              return false;
            }
            _this.$emit('move', _this.fileId);
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: '文件移动成功',
              iconClass: 'icon-success'
            });
          }).catch(function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: error.response.data.message,
              iconClass: 'icon-error'
            });
          });
        } else if (com === '保存') {
          var _assignedShareId = null;
          var _fileIds = [];
          if (this.operaRow.id) {
            _assignedShareId = this.operaRow.id;
            _fileIds.push(this.operaRow.fileId);
          } else {
            this.checkedItems.forEach(function (value) {
              _assignedShareId = value.id;
              _fileIds.push(value.fileIds);
            });
          }
          if (!_fileIds[0]) {
            _fileIds = [];
          }
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].saveOtherShare, { 'queryStr': window.encodeURI(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
              fileArr: [{
                assignedShareId: _assignedShareId,
                fileIds: _fileIds
              }],
              targetFileId: _this.pid
            })) }).then(function (res) {
            _this.$emit('move', this.operaRow);
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: '文件保存成功',
              iconClass: 'icon-success'
            });
          }).catch(function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: error.response.data.message,
              iconClass: 'icon-error'
            });
          });
        }
      }
    },
    //      滚动加载
    moveScroll: function moveScroll() {
      var _this3 = this;

      var _this = this;
      var ulBox = _this.$refs.moveBox;
      if (ulBox.scrollTop + ulBox.clientHeight >= ulBox.scrollHeight) {
        if (_this.shareTarget) {
          _this.page++;
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].searchFile, { fileId: _this.pid, page: _this.page, size: 20 }).then(function (response) {
            var data = response.data.content;
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                _this3.hello.push(data[i]);
              }
            }
            return false;
          }).catch(function (error) {});
        } else {
          _this.copyPage++;
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].shareFiles, {
            fileId: _this.sharePid,
            page: _this.copyPage,
            size: 20
          }).then(function (response) {
            var data = response.data.content;
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                _this3.hello.push(data[i]);
              }
            }
            return false;
          }).catch(function (error) {});
        }
      }
    },
    //      返回上一级
    back: function back() {
      var _this = this;
      _this.page = 0;
      if (_this.shareTarget === true) {
        var length = _this.parentId.length - 1;
        var fileId = _this.parentId[length].pid;
        _this.whenId = fileId;
        __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].searchFile, { fileId: fileId, page: 0, size: 20 }).then(function (res) {
          _this.hello = [];
          _this.index = _this.parentId[length].index;
          _this.indexs = _this.parentId[length].index;
          _this.pid = fileId;
          _this.parentId.pop();
          _this.hello = res.data.content;
          if (_this.parentId.length === 0) {
            _this.person = false;
            _this.share = false;
            _this.kind = false;
            _this.shareFileIds = '';
          }
        }).catch(function (res) {});
      } else if (_this.shareTarget === false) {
        var _length = _this.shareParentId.length - 1;
        var _fileId = _this.shareParentId[_length].pid;
        __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].shareFiles, { fileId: _fileId, page: 0, size: 20 }).then(function (res) {
          _this.hello = [];
          _this.copyPage = 0;
          _this.shareIndex = _this.shareParentId[_length].index;
          _this.pid = _fileId;
          _this.shareFileIds = _fileId;
          _this.sharePid = _fileId;
          _this.shareParentId.pop();
          _this.hello = res.data.content;
          if (_this.shareParentId.length === 0) {
            _this.person = false;
            _this.share = false;
            _this.kind = false;
            _this.pid = 'rootpath';
          }
        }).catch(function (res) {});
      }
    },
    //      点击个人文件
    personFile: function personFile() {
      var _this = this;
      _this.shareTarget = true;
      _this.hello = [];
      _this.page = 0;
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].searchFile, { fileId: _this.pid, page: 0, size: 20 }).then(function (response) {
        _this.hello = response.data.content;
      }).catch(function (error) {});
    },
    //      点击共享文件
    shareFile: function shareFile() {
      var _this = this;
      var ulBox = _this.$refs.moveBox;
      ulBox.scrollTop = 0;
      _this.shareTarget = false;
      _this.copyPage = 0;
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].shareFiles, { fileId: _this.shareFileIds, page: 0, size: 20 }).then(function (res) {
        _this.hello = [];
        ulBox.scrollTop = 0;
        var data = res.data.content;
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            _this.hello.push(data[i]);
          }
        }
      }).catch(function (res) {});
    },
    //      取消复制和移动
    cancelcopy: function cancelcopy() {
      this.$emit('copy', false);
    },
    //      进入下一级目录
    next: function next(index, fileName, isDir) {
      var _this = this;
      if (isDir === 1) {
        _this.page = 0;
        var ulBox1 = _this.$refs.moveBox;
        if (_this.shareTarget === true) {
          //            个人文件夹的下一级
          _this.person = false;
          _this.share = true;
          _this.kind = false;
          ulBox1.scrollTop = 0;
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].searchFile, { fileId: index, page: 0, size: 20 }).then(function (res) {
            ulBox1.scrollTop = 0;
            if (_this.pid === 'rootpath') {
              _this.parentId = [{ pid: 'rootpath', index: '个人文件' }];
            } else {
              _this.parentId.push({ pid: _this.pid, index: _this.index });
            }
            _this.pid = index;
            _this.index = fileName;
            _this.hello = res.data.content;
            ulBox1.scrollTop = 0;
          }).catch(function (res) {});
        } else if (_this.shareTarget === false) {
          //            共享文件夹的下一级
          _this.person = true;
          _this.share = false;
          _this.kind = true;
          ulBox1.scrollTop = 0;
          _this.copyPage = 0;
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].shareFiles, { fileId: index, page: 0, size: 20 }).then(function (res) {
            ulBox1.scrollTop = 0;
            if (_this.sharePid === '' || _this.shareIndex === '共享文件') {
              _this.shareParentId = [{ pid: '', index: '共享文件' }];
            } else {
              _this.shareParentId.push({ pid: _this.sharePid, index: _this.shareIndex });
            }
            _this.sharePid = index;
            _this.shareFileIds = index;
            _this.shareIndex = fileName;
            _this.hello = res.data.content;
            ulBox1.scrollTop = 0;
          }).catch(function (res) {});
        }
      }
    },
    //      新建文件夹
    mkdir: function mkdir() {
      var _this4 = this;

      var _this = this;
      var ulBox1 = _this.$refs.moveBox;
      if (_this.shareTarget) {
        __WEBPACK_IMPORTED_MODULE_2_mint_ui__["MessageBox"].prompt('新建文件夹', '', {
          inputValue: '新建文件夹',
          className: 'fs',
          showInput: true,
          inputPattern: /\S/,
          inputErrorMessage: '名字不允许为空',
          confirmButtonClass: 'btnClass'
        }).then(function (_ref) {
          var value = _ref.value,
              action = _ref.action;

          if (action === 'confirm' && value !== null) {
            __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].mKdir, { dirName: value, pid: _this4.pid }).then(function (response) {
              _this.parentId.push({ pid: _this.pid, index: _this.index });
              _this.pid = response.data.id;
              _this.index = value;
              _this.person = false;
              _this.share = true;
              _this.kind = false;
              __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].searchFile, { fileId: _this.pid, page: 0, size: 20 }).then(function (response) {
                var data = response.data.content;
                if (_this.hello.length > 0) {
                  ulBox1.scrollTop = 0;
                }
                _this.hello = data;
                Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
                  message: '新建成功',
                  iconClass: 'icon-success'
                });
              });
              this.$store.commit('changeId', _this.pid);
            }).catch(function (error) {
              Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
                message: error.response.data.message,
                iconClass: 'icon-error'
              });
            });
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2_mint_ui__["MessageBox"].prompt('新建文件夹', '', {
          inputValue: '新建文件夹',
          showInput: true,
          inputPattern: /\S/,
          inputErrorMessage: '名字不允许为空'
        }).then(function (_ref2) {
          var value = _ref2.value,
              action = _ref2.action;

          if (action === 'confirm' && value !== null) {
            __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].mKDir, { dirName: value, pid: _this4.sharePid }).then(function (response) {
              _this.shareParentId.push({ pid: _this.sharePid, index: _this.shareIndex });
              _this.sharePid = response.data.id;
              _this.shareIndex = response.data.fileName;
              _this.person = true;
              _this.share = false;
              _this.kind = true;
              __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].shareFiles, {
                fileId: _this.sharePid,
                page: 0,
                size: 20
              }).then(function (response) {
                var data = response.data.content;
                if (_this.hello.length > 0) {
                  ulBox1.scrollTop = 0;
                }
                _this.hello = data;
                _this.copyPage = 0;
                Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
                  message: '新建成功',
                  iconClass: 'icon-success'
                });
              });
            }).catch(function (error) {
              Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
                message: error.response.data.message,
                iconClass: 'icon-error'
              });
            });
          }
        });
      }
    }
  },
  props: ['fileId', 'model', 'common', 'checkedItems', 'operaRow']
});

/***/ }),

/***/ "Q9NE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history"},[_c('div',{staticClass:"head"},[_c('ul',{staticClass:"clearfix"},[_c('span',{staticClass:"back fl",on:{"click":_vm.backhistory}}),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('ul',{ref:"historyBox",staticClass:"ulBox",on:{"scroll":function($event){return _vm.historyScroll()}}},_vm._l((_vm.historyArr),function(item,index){return _c('li',[_c('div',{staticClass:"list"},[_c('i',{staticClass:"iconfont",class:_vm._f("sliceType")(item.fileName,item.fileName, item.isDir),staticStyle:{"vertical-align":"super"}}),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{staticClass:"right"},[_c('h4',[_c('em',[_vm._v(_vm._s(item.versionNo))]),_vm._v(" "),_c('i',[_vm._v(_vm._s(item.fileName))])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("formaTime")(item.gmtModified)))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(index === 0),expression:"index === 0"}],staticClass:"new"},[_vm._v("最新")]),_vm._v(" "),(index!==0)?_c('div',{class:{'more':_vm.up===index},attrs:{"id":"moreh"},on:{"click":function($event){return _vm.hselected(index)}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"size"},[_vm._v(_vm._s(_vm._f("bytesToSize")(item.length)))])])]),_vm._v(" "),(_vm.select===index)?_c('div',{staticClass:"select hselect"},[_c('ul',{staticClass:"clearfix",staticStyle:{"padding-top":"0.15rem"}},[_c('li',{on:{"click":function($event){return _vm.goBack(item.id)}}},[_c('img',{attrs:{"src":__webpack_require__("JEGS"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("设为最新")])])])]):_vm._e()])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "QKLI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QW8H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QYzz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_otherShare_vue__ = __webpack_require__("w3r+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3778c4e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_otherShare_vue__ = __webpack_require__("LkHP");
function injectStyle (ssrContext) {
  __webpack_require__("fGAn")
  __webpack_require__("78am")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3778c4e1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_otherShare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3778c4e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_otherShare_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Qhen":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"install",class:{'installAdd': _vm.continues}},[(!_vm.continues)?_c('div',{staticClass:"exist"},[_c('div',{staticClass:"head yp-topbar",attrs:{"id":"head"}},[_c('ul',{staticClass:"clearfix"},[_c('li',{staticClass:"left",on:{"click":_vm.back}},[_vm._v("返回")]),_vm._v(" "),_c('li',[_vm._v("设置共享人员")])])]),_vm._v(" "),_c('div',{staticClass:"tip"},[_c('ul',[_c('li',{class:{'active':_vm.flag===1},on:{"click":function($event){return _vm.Count(1)}}},[_vm._v(_vm._s(_vm.viewer))]),_vm._v(" "),_c('li',{class:{'active':_vm.flag===2},on:{"click":function($event){return _vm.Count(2)}}},[_vm._v(_vm._s(_vm.uploader))]),_vm._v(" "),_c('li',{class:{'active':_vm.flag===3},on:{"click":function($event){return _vm.Count(3)}}},[_vm._v(_vm._s(_vm.compiler))])])]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('span',{on:{"click":function($event){return _vm.add(_vm.flag)}}},[_vm._v("继续添加")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('ul',{ref:"ulBox",staticClass:"ulBox",on:{"scroll":function($event){return _vm.scroll()}}},_vm._l((_vm.dataList),function(item,index){return _c('li',[_c('div',{staticClass:"list"},[_c('img',{staticClass:"avatar",attrs:{"src":item.avator,"alt":""}}),_vm._v(" "),(item.realName!=='')?_c('span',{staticClass:"nickName"},[_vm._v(_vm._s(item.realName))]):_c('span',[_vm._v(_vm._s(item.account))]),_vm._v(" "),(item.isManager === 0)?_c('span',{staticClass:"tipManager"},[_vm._v("创建者")]):_vm._e(),_vm._v(" "),(!(_vm.flag===3&&index===0))?_c('span',{staticClass:"close",on:{"click":function($event){return _vm.remove(item.id)}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"tel",class:{'mr':_vm.flag===3&&index===0}},[_vm._v(_vm._s(item.phoneNumber))])])])}),0)])]):_vm._e(),_vm._v(" "),_c('mt-actionsheet',{staticClass:"del",attrs:{"actions":_vm.delmember},model:{value:(_vm.delmembersModel),callback:function ($$v) {_vm.delmembersModel=$$v},expression:"delmembersModel"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rw+R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_log_vue__ = __webpack_require__("XnY4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05f1f268_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_log_vue__ = __webpack_require__("JjhU");
function injectStyle (ssrContext) {
  __webpack_require__("/3UT")
  __webpack_require__("Vr46")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05f1f268"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_log_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05f1f268_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_log_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rwp6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
!function(){if("undefined"!=typeof document){var e=document.head||document.getElementsByTagName("head")[0],t=document.createElement("style"),n=' *[data-v-5928e1c7] { -webkit-box-sizing: border-box; box-sizing: border-box; } .fullscreen-v-img[data-v-5928e1c7] { z-index: 9999; height: 100%; width: 100%; position: fixed; top: 0; left: 0; overflow: hidden; background-color: rgba(0, 0, 0, 0.7); -ms-touch-action: none; touch-action: none; } .content-v-img img[data-v-5928e1c7] { width: auto; height: auto; max-width: 100%; max-height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; } .header-v-img[data-v-5928e1c7] { position: absolute; width: 100%; background-color: rgba(0, 0, 0, 0.3); height: 50px; z-index: 9999; display: flex; justify-content: space-between; align-items: center; } .title-v-img[data-v-5928e1c7] { font-family: "Avenir", Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; color: white; text-align: center; max-height: 100%; overflow: auto; } .count-v-img[data-v-5928e1c7], .buttons-v-img[data-v-5928e1c7] { width: 80px; font-family: "Avenir", Helvetica, Arial, sans-serif; } .count-v-img[data-v-5928e1c7] { font-size: 15px; color: white; margin-left: 10px; } .buttons-v-img[data-v-5928e1c7] { margin-right: 10px; text-align: right; } .buttons-v-img span path[data-v-5928e1c7] { fill: #e5e6eb; -webkit-transition: fill 0.4s ease-in-out; transition: fill 0.4s ease-in-out; } .buttons-v-img span[data-v-5928e1c7] { cursor: pointer; color: #e5e6eb; font-size: 30px; -webkit-transition: color 0.4s ease-in-out; transition: color 0.4s ease-in-out; text-decoration: none; text-align: center; } .buttons-v-img span[data-v-5928e1c7]:not(:last-child) { margin-right: 8px; } .buttons-v-img span svg[data-v-5928e1c7] { height: 20px; width: 15px; } .buttons-v-img span:hover svg path[data-v-5928e1c7] { fill: white; } .buttons-v-img span[data-v-5928e1c7]:hover { color: white; } .prev-v-img svg[data-v-5928e1c7], .next-v-img svg[data-v-5928e1c7] { margin: 5px auto; } .prev-v-img[data-v-5928e1c7], .next-v-img[data-v-5928e1c7] { color: white; width: 35px; height: 35px; position: absolute; top: 50%; margin-top: -12.5px; font-size: 15px; font-family: "Avenir", Helvetica, Arial, sans-serif; text-align: center; background-color: rgba(0, 0, 0, 0.3); z-index: 1000; opacity: 0.3; -webkit-transition: opacity 0.3s ease-in-out; transition: opacity 0.3s ease-in-out; cursor: pointer; } .prev-v-img[data-v-5928e1c7]:hover, .next-v-img[data-v-5928e1c7]:hover { opacity: 1; } .prev-v-img[data-v-5928e1c7] { left: 10px; } .next-v-img[data-v-5928e1c7] { right: 10px; } .v-img-fade-enter[data-v-5928e1c7], .v-img-fade-leave-to[data-v-5928e1c7] { opacity: 0; } .v-img-fade-enter-active[data-v-5928e1c7], .v-img-fade-leave-active[data-v-5928e1c7] { -webkit-transition: opacity 0.3s ease-in-out; transition: opacity 0.3s ease-in-out; } ';t.type="text/css",t.styleSheet?t.styleSheet.cssText=n:t.appendChild(document.createTextNode(n)),e.appendChild(t)}}();var ImgScreen={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.closed?e._e():n("div",{staticClass:"fullscreen-v-img",on:{click:function(t){if(t.target!==t.currentTarget)return null;e.close(t)}}},[n("div",{staticClass:"header-v-img"},[n("span",{staticClass:"count-v-img"},[e.images.length>1?n("span",[e._v(e._s(e.currentImageIndex+1)+"/"+e._s(e.images.length)+" ")]):e._e()]),n("span",{staticClass:"title-v-img"},[e._v(e._s(e.titles[e.currentImageIndex]))]),n("div",{staticClass:"buttons-v-img"},[e.sourceButtons[e.currentImageIndex]?n("span",[n("a",{attrs:{href:e.images[e.currentImageIndex],target:"_blank"}},[n("svg",{staticStyle:{"enable-background":"new 0 0 475.078 475.077"},attrs:{xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",version:"1.1",id:"Capa_1",x:"0px",y:"0px",width:"512px",height:"512px",viewBox:"0 0 475.078 475.077","xml:space":"preserve"}},[n("path",{attrs:{d:"M467.083,318.627c-5.324-5.328-11.8-7.994-19.41-7.994H315.195l-38.828,38.827c-11.04,10.657-23.982,15.988-38.828,15.988    c-14.843,0-27.789-5.324-38.828-15.988l-38.543-38.827H27.408c-7.612,0-14.083,2.669-19.414,7.994    C2.664,323.955,0,330.427,0,338.044v91.358c0,7.614,2.664,14.085,7.994,19.414c5.33,5.328,11.801,7.99,19.414,7.99h420.266    c7.61,0,14.086-2.662,19.41-7.99c5.332-5.329,7.994-11.8,7.994-19.414v-91.358C475.078,330.427,472.416,323.955,467.083,318.627z     M360.025,414.841c-3.621,3.617-7.905,5.424-12.854,5.424s-9.227-1.807-12.847-5.424c-3.614-3.617-5.421-7.898-5.421-12.844    c0-4.948,1.807-9.236,5.421-12.847c3.62-3.62,7.898-5.431,12.847-5.431s9.232,1.811,12.854,5.431    c3.613,3.61,5.421,7.898,5.421,12.847C365.446,406.942,363.638,411.224,360.025,414.841z M433.109,414.841    c-3.614,3.617-7.898,5.424-12.848,5.424c-4.948,0-9.229-1.807-12.847-5.424c-3.613-3.617-5.42-7.898-5.42-12.844    c0-4.948,1.807-9.236,5.42-12.847c3.617-3.62,7.898-5.431,12.847-5.431c4.949,0,9.233,1.811,12.848,5.431    c3.617,3.61,5.427,7.898,5.427,12.847C438.536,406.942,436.729,411.224,433.109,414.841z",fill:"#FFFFFF"}}),n("path",{attrs:{d:"M224.692,323.479c3.428,3.613,7.71,5.421,12.847,5.421c5.141,0,9.418-1.808,12.847-5.421l127.907-127.908    c5.899-5.519,7.234-12.182,3.997-19.986c-3.23-7.421-8.847-11.132-16.844-11.136h-73.091V36.543c0-4.948-1.811-9.231-5.421-12.847    c-3.62-3.617-7.901-5.426-12.847-5.426h-73.096c-4.946,0-9.229,1.809-12.847,5.426c-3.615,3.616-5.424,7.898-5.424,12.847V164.45    h-73.089c-7.998,0-13.61,3.715-16.846,11.136c-3.234,7.801-1.903,14.467,3.999,19.986L224.692,323.479z",fill:"#FFFFFF"}})])])]):e._e(),n("span",{on:{click:e.close}},[e._v("×")])])]),n("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.visibleUI&&1!==e.images.length?n("span",{staticClass:"prev-v-img",on:{click:e.prev}},[n("svg",{attrs:{width:"25",height:"25",viewBox:"0 0 1792 1915",xmlns:"http://www.w3.org/2000/svg"}},[n("path",{attrs:{d:"M1664 896v128q0 53-32.5 90.5t-84.5 37.5h-704l293 294q38 36 38 90t-38 90l-75 76q-37 37-90 37-52 0-91-37l-651-652q-37-37-37-90 0-52 37-91l651-650q38-38 91-38 52 0 90 38l75 74q38 38 38 91t-38 91l-293 293h704q52 0 84.5 37.5t32.5 90.5z",fill:"#fff"}})])]):e._e()]),n("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.visibleUI&&1!==e.images.length?n("span",{staticClass:"next-v-img",on:{click:e.next}},[n("svg",{attrs:{width:"25",height:"25",viewBox:"0 0 1792 1915",xmlns:"http://www.w3.org/2000/svg"}},[n("path",{attrs:{d:"M1600 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z",fill:"#fff"}})])]):e._e()]),n("div",{staticClass:"content-v-img"},[n("img",{attrs:{src:e.images[e.currentImageIndex]},on:{click:e.next}})])],1)])},staticRenderFns:[],_scopeId:"data-v-5928e1c7",data:function(){return{images:[],titles:[],sourceButtons:[],visibleUI:!0,currentImageIndex:0,closed:!0,uiTimeout:null,handlers:{}}},watch:{closed:function(e){e&&this.handlers.closed&&this.handlers.closed(),!e&&this.handlers.opened&&this.handlers.opened()}},methods:{fireChangeEvent:function(){this.handlers.changed&&this.handlers.changed(this.currentImageIndex)},close:function(){this.closed||(document.querySelector("body").classList.remove("body-fs-v-img"),this.images=[],this.currentImageIndex=0,this.closed=!0)},next:function(){!this.closed&&this.images.length>1&&(this.currentImageIndex+1<this.images.length?this.currentImageIndex++:this.currentImageIndex=0,this.fireChangeEvent())},prev:function(){!this.closed&&this.images.length>1&&(this.currentImageIndex>0?this.currentImageIndex--:this.currentImageIndex=this.images.length-1,this.fireChangeEvent())},showUI:function(){var e=this;this.closed||(clearTimeout(this.uiTimeout),this.visibleUI=!0,this.uiTimeout=setTimeout(function(){e.visibleUI=!1},3500))}},created:function(){var e=this;window.addEventListener("keyup",function(t){27!==t.keyCode&&81!==t.keyCode||e.close(),39!==t.keyCode&&76!==t.keyCode||e.next(),37!==t.keyCode&&72!==t.keyCode||e.prev()}),window.addEventListener("scroll",function(){e.close()}),window.addEventListener("mousemove",function(){e.showUI()})}},babelHelpers={},asyncGenerator=function(){function e(e){this.value=e}function t(t){function n(a,r){try{var o=t[a](r),s=o.value;s instanceof e?Promise.resolve(s.value).then(function(e){n("next",e)},function(e){n("throw",e)}):i(o.done?"return":"normal",o.value)}catch(e){i("throw",e)}}function i(e,t){switch(e){case"return":a.resolve({value:t,done:!0});break;case"throw":a.reject(t);break;default:a.resolve({value:t,done:!1})}(a=a.next)?n(a.key,a.arg):r=null}var a,r;this._invoke=function(e,t){return new Promise(function(i,o){var s={key:e,arg:t,resolve:i,reject:o,next:null};r?r=r.next=s:(a=r=s,n(e,t))})},"function"!=typeof t.return&&(this.return=void 0)}return"function"==typeof Symbol&&Symbol.asyncIterator&&(t.prototype[Symbol.asyncIterator]=function(){return this}),t.prototype.next=function(e){return this._invoke("next",e)},t.prototype.throw=function(e){return this._invoke("throw",e)},t.prototype.return=function(e){return this._invoke("return",e)},{wrap:function(e){return function(){return new t(e.apply(this,arguments))}},await:function(t){return new e(t)}}}(),_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(e[i]=n[i])}return e},toConsumableArray=function(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)},addPluginAttributes=function(e,t,n){var i="pointer",a=t.arg||null,r=void 0,o=void 0,s=e.src,c=void 0,l={};return n.altAsTitle&&(c=e.alt),r=n.openOn,o=n.sourceButton,void 0!==t.value&&(i=t.value.cursor||i,a=t.value.group||a,r=t.value.openOn||r,s=t.value.src||s,c=t.value.title||c,void 0!==t.value.sourceButton&&(o=t.value.sourceButton),l.opened=t.value.opened,l.closed=t.value.closed,l.changed=t.value.changed),e.setAttribute("data-vue-img-src",s),a&&e.setAttribute("data-vue-img-group",a),c&&e.setAttribute("data-vue-img-title",c),o&&e.setAttribute("data-vue-img-source-button",o),s||console.error("v-img element missing src parameter."),e.style.cursor=i,{cursor:i,src:s,group:a,title:c,events:l,sourceButton:o,openOn:r}},install=function(e,t){var n=e.extend(ImgScreen);t=_extends({altAsTitle:!1,sourceButton:!1,openOn:"click"},t),e.directive("img",{update:function(e,n,i,a){var r=void 0,o=void 0;a.data.attrs&&i.data.attrs&&(o=a.data.attrs.src!==i.data.attrs.src,t.altAsTitle&&(r=a.data.attrs.alt!==i.data.attrs.alt));var s=n.oldValue!==n.value;(o||r||s)&&addPluginAttributes(e,n,t)},bind:function(i,a){var r=addPluginAttributes(i,a,t),o=window.vueImg;if(!o){var s=document.createElement("div");s.setAttribute("id","imageScreen"),document.querySelector("body").appendChild(s),o=window.vueImg=(new n).$mount("#imageScreen")}i.addEventListener(r.openOn,function(){var t=void 0;t=i.dataset.vueImgGroup?[].concat(toConsumableArray(document.querySelectorAll('img[data-vue-img-group="'+i.dataset.vueImgGroup+'"]'))):[i],e.set(o,"images",t.map(function(e){return e.dataset.vueImgSrc})),e.set(o,"titles",t.map(function(e){return e.dataset.vueImgTitle})),e.set(o,"sourceButtons",t.map(function(e){return"true"===e.dataset.vueImgSourceButton})),e.set(o,"currentImageIndex",t.indexOf(i)),e.set(o,"handlers",r.events),e.set(o,"closed",!1)})}})};"undefined"!=typeof window&&window.Vue&&window.Vue.use(install);/* harmony default export */ __webpack_exports__["a"] = (install);
//# sourceMappingURL=v-img.mjs.map


/***/ }),

/***/ "RxuB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recycle_vue__ = __webpack_require__("00So");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ee5f2b7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recycle_vue__ = __webpack_require__("VdZJ");
function injectStyle (ssrContext) {
  __webpack_require__("sp5F")
  __webpack_require__("0Spf")
  __webpack_require__("m9nA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ee5f2b7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recycle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ee5f2b7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recycle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Svdy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crumbs-wrap",style:({'height': _vm.height || '0.89rem', 'line-height': _vm.height || '0.89rem'})},[_vm._l((_vm.router.slice(0, _vm.router.length - 1)),function(item,index){return _c('a',{key:index,on:{"click":function($event){return _vm.crumbClick(item)}}},[_vm._v(_vm._s(item.name)),_c('span',{staticClass:"separator"},[_vm._v(_vm._s(_vm.separator || '>'))])])}),_vm._v(" "),(_vm.router.length)?[_c('span',[_vm._v(_vm._s(_vm.router[_vm.router.length - 1].name))])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TQWo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard__ = __webpack_require__("V33R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      shareArr: [],
      info: {
        page: 0,
        size: 20
      },
      page: 0,
      size: 20,
      totalPages: '',
      shareUrl: '',
      domin: '',
      select: '',
      up: ''
    };
  },


  methods: {
    classObject: function classObject(val, val2, val3) {
      var type = this.sliceType(val, val2, val3);
      return 'icon-' + type;
    },
    styleObject: function styleObject(val, val2, val3) {
      var type = this.sliceType(val, val2, val3);
      if (type === 'excel') {
        return 'excel';
      } else if (type === 'pdf') {
        return 'pdf';
      } else if (type === 'word') {
        return 'word';
      } else if (type === 'txt') {
        return 'txt';
      } else if (type === 'pic') {
        return 'pic';
      } else if (type === 'muisc') {
        return 'muisc';
      } else if (type === 'dir') {
        return 'dir';
      } else if (type === 'html') {
        return 'html';
      } else if (type === 'shareDir') {
        return 'shareDir1';
      } else {
        return 'weizhi';
      }
    },

    expire: function expire(time) {
      if (!time) {
        return '永久有效';
      } else {
        return time + '天后到期';
      }
    },
    delateFile: function delateFile(val, statu) {
      if (statu === -1) {
        return '分享的文件已被删除';
      } else {
        return val;
      }
    },
    formaTime: function formaTime(val) {
      if (val !== '' || undefined || null) {
        return new Date(val).format('yyyy-MM-dd HH:mm');
      }
    },
    sliceType: function sliceType(val, num, flag) {
      if (num === 1) {
        if (flag === 2) {
          return 'shareDir';
        } else {
          return 'dir';
        }
      }
      if (val) {
        var point = val.lastIndexOf('.');
        var type = val.substring(point + 1).toLowerCase();
        if (type === 'jpg' || type === 'gif' || type === 'JPG' || type === 'GIF' || type === 'png' || type === 'JPEG' || type === 'jpeg') {
          return 'pic';
        } else if (type === 'avi' || type === 'rmvb' || type === 'rm' || type === 'asf' || type === 'divx' || type === 'mpg' || type === 'mpeg' || type === 'mpe' || type === 'mp4' || type === 'mkv' || type === 'vob ') {
          return 'video';
        } else if (type === 'WAVE' || type === 'AIFF' || type === 'MPEG' || type === 'MP3' || type === 'MIDI' || type === 'mp3') {
          return 'muisc';
        } else if (num === 1) {
          return 'dir';
        } else if (type === 'txt') {
          return 'txt';
        } else if (type === 'pdf') {
          return 'pdf';
        } else if (type === 'doc' || type === 'docx') {
          return 'word';
        } else if (type === 'ppt' || type === 'pptx') {
          return 'ppt';
        } else if (type === 'xls' || type === 'xlsx') {
          return 'excel';
        } else if (type === 'html' || type === 'htm') {
          return 'html';
        } else if (type === 'wps' || type === 'wpt') {
          return 'wps';
        } else if (type === 'zip' || type === 'rar') {
          return 'package';
        } else {
          return 'default';
        }
      }
    },
    bytesToSize: function bytesToSize(bytes) {
      if (bytes === 0) return '0 B';
      if (bytes === '') return '';
      var k = 1024;
      var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return (bytes / Math.pow(k, i)).toPrecision(3) + sizes[i];
    },
    selected: function selected(index, shareUrl) {
      var _this = this;
      if (this.select === index) {
        this.select = '';
        this.up = '';
      } else {
        this.select = index;
        this.up = index;
      }
    },
    load: function load() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].shareOther, this.info).then(function (response) {
        var data = response.data.content;
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            _this2.shareArr.push(data[i]);
          }
          _this2.totalPages = response.data.totalPages;
        }
        return false;
      }).catch(function (error) {});
    },
    loadMore: function loadMore() {
      var _this3 = this;

      this.loading = true;
      setTimeout(function () {
        var _this = _this3;
        if (_this.page < _this.totalPages) {
          _this.page++;
        }
        __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].shareOther, { page: _this.page, size: _this.size }).then(function (res) {
          var list0 = [];
          var data = res.data.content;
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              list0.push(data[i]);
            }
            if (_this.shareArr && list0) {
              _this.shareArr = _this.shareArr.concat(list0);
            }
          }
        });
        _this3.loading = false;
      }, 250);
    },
    cancelShare: function cancelShare(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].cancelShareWorkmate, { assignedShareIds: id }).then(function () {
        _this4.select = '';
        _this4.up = '';
        _this4.shareArr.forEach(function (value, index, array) {
          if (value.id === id) {
            array.splice(index, 1);
          }
        });
        Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
          message: '取消分享成功',
          iconClass: 'icon-success'
        });
      });
    }
  },
  created: function created() {
    this.load();
  }
});

/***/ }),

/***/ "TRik":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_back_mobile_png__ = __webpack_require__("AQyz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_back_mobile_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_back_mobile_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_36px_png__ = __webpack_require__("gsDw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_36px_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_36px_png__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      back: __WEBPACK_IMPORTED_MODULE_0__assets_images_back_mobile_png___default.a,
      close: __WEBPACK_IMPORTED_MODULE_1__assets_images_36px_png___default.a,
      isShow: false
    };
  },
  created: function created() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('yicbridge') !== -1) {
      this.isShow = true;
    }
  },

  methods: {
    closeWindow: function closeWindow() {
      this.goBack();
      window.yicbridge.quit();
    },
    goBack: function goBack() {
      window.yicbridge.close();
    }
  }
});

/***/ }),

/***/ "UCkG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UZfP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UtRH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('mt-header',{attrs:{"title":"安全验证"}},[_c('router-link',{attrs:{"slot":"left","to":"/more/showinfo"},slot:"left"},[_c('span',{staticClass:"quxiao"},[_vm._v("取消")])])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"telNum",model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}},[_vm._v("你的手机号："+_vm._s(_vm.phone))]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 .4rem"}},[_c('mt-button',{staticClass:"btn",attrs:{"type":"primary","size":"large"},on:{"click":_vm.sendMsg}},[_vm._v("修改手机号")])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('span',{staticClass:"tip"},[_vm._v("为了保证您的帐号安全，请验证身份。验证成功后进行下一步操作。")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VdZJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"head clearfix yp-topbar"},[_c('ul',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],staticClass:"fl",on:{"click":function($event){return _vm.choose()}},model:{value:(_vm.check),callback:function ($$v) {_vm.check=$$v},expression:"check"}},[_vm._v("\n        "+_vm._s(_vm.isChooseAll ? '取消全选' : '全选')+"\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],staticClass:"fr",on:{"click":_vm.cancel}},[_vm._v("\n        取消\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.len),expression:"!len"}],staticClass:"tittle"},[_vm._v("回收站")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.len),expression:"len"}],staticClass:"tittle"},[_vm._v("已选择"+_vm._s(_vm.len)+"文件")]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isA),expression:"!isA"}],staticClass:"check-mobile",attrs:{"id":"check-recycle"},on:{"click":_vm.checkMobile}}),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isA),expression:"!isA"}],attrs:{"slot":"left","to":"/more/setinfo"},slot:"left"},[_c('li',{staticClass:"back"})])],1)]),_vm._v(" "),(_vm.list.length===0)?_c('div',{staticClass:"jpg"},[_vm._m(0)]):_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],ref:"ulBox",staticClass:"ulBox",attrs:{"infinite-scroll-distance":"0","infinite-scroll-immediate-check":"false","infinite-scroll-disabled":"moreLoading","id":"mainlist"}},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"Rlist"},[_c('div',{staticClass:"Rlistin"},[_c('em',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],ref:"mycheck",refInFor:true,staticClass:"check",class:{'checked': item.isB, 'nochecked': !item.isB},attrs:{"fileId":item.id},on:{"click":function($event){return _vm.checked(item)}}}),_vm._v(" "),(_vm.sliceType(item.fileName,item.isDir)!=='package')?_c('span',{class:_vm.styleObject(item.fileName,item.isDir)},[_c('i',{staticClass:"iconfont",class:_vm.classObject(item.fileName,item.isDir),staticStyle:{"font-size":".6rem"}})]):_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true","id":"package"}},[_c('use',{attrs:{"xlink:href":"#icon-package"}})]),_vm._v(" "),_c('div',{staticClass:"middle"},[_c('div',{staticClass:"left_info"},[_c('h3',[_vm._v(_vm._s(_vm._f("sName")(item.fileName,15)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formaTime(item.gmtModified)))])]),_vm._v(" "),_c('div',{staticClass:"right_length"},[_c('span',[_vm._v(_vm._s(_vm.bytesToSize(item.length)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.remainDay)+"天")])])])]),_vm._v(" "),_c('div',{class:{'more':_vm.up===index},attrs:{"id":"more"},on:{"click":function($event){return _vm.toggleUp(index)}}}),_vm._v(" "),(_vm.select===index)?_c('div',{staticClass:"div"},[_c('ul',{staticClass:"listBox clearfix"},[_c('li',[_c('i',{staticClass:"iconfont icon-huanyuan",staticStyle:{"font-size":".48rem","display":"block","color":"#999999"}}),_vm._v(" "),_c('p',{attrs:{"id":item.id},on:{"click":function($event){return _vm.two_recover($event)}}},[_vm._v("还原")])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"iconfont icon-lajitong",staticStyle:{"font-size":".48rem","display":"block","color":"#999999"}}),_vm._v(" "),_c('p',{attrs:{"id":item.id},on:{"click":function($event){return _vm.two_delete(item)}}},[_vm._v("删除")])])])]):_vm._e()])}),0),_vm._v(" "),_c('mt-tabbar',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isA),expression:"!isA"}]},[_c('mt-tab-item',{staticClass:"active",attrs:{"id":"一键清空"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isA),expression:"!isA"}],staticClass:"button",on:{"click":_vm.one_delete}},[_vm._v("一键清空")])])],1),_vm._v(" "),_c('mt-tabbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],class:{'selected': _vm.isA, 'selected-t': _vm.opacity}},[_c('mt-tab-item',{attrs:{"id":"还原"}},[_c('i',{staticClass:"iconfont icon-huanyuan",staticStyle:{"font-size":".48rem","display":"block"},on:{"click":function($event){return _vm.recoverList('还原')}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.recoverList('还原')}}},[_vm._v("还原")])]),_vm._v(" "),_c('mt-tab-item',{attrs:{"id":"删除"}},[_c('i',{staticClass:"iconfont icon-lajitong",staticStyle:{"font-size":".48rem","display":"block"},on:{"click":function($event){return _vm.deleteList('删除')}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.deleteList('删除')}}},[_vm._v("删除")])])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":__webpack_require__("2u6q"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("您的回收站为空噢～")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vr46":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W2Q3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("Haow");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43766eaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("JYcE");
function injectStyle (ssrContext) {
  __webpack_require__("1hWU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43766eaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43766eaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WZVd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wfzo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Constant__ = __webpack_require__("sMIb");

var a = {
  checkPermission: function checkPermission(value) {
    var permissionBtn = window.localStorage.getItem('permissionBtns') || '';
    if (!permissionBtn) {
      return false;
    } else {
      permissionBtn = permissionBtn.split(__WEBPACK_IMPORTED_MODULE_0__utils_Constant__["a" /* routerSplitCharacter */]);
      return permissionBtn.indexOf(value) !== -1;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (a);

/***/ }),

/***/ "Wh5d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{copy: _vm.copy, 'move': _vm.move},staticStyle:{"height":"100%"}},[_c('div',{staticClass:"head yp-topbar"},[_c('ul',{staticClass:"clearfix",class:{'common': _vm.common && !_vm.shareParentId.length},attrs:{"id":"copy"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.parentId.length || _vm.shareParentId.length),expression:"parentId.length || shareParentId.length"}],staticClass:"back fl",on:{"click":_vm.back}}),_vm._v(" "),(!_vm.common)?_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.person),expression:"!person"}],class:{'shareTarget': !_vm.shareTarget,'list': _vm.share},on:{"click":_vm.personFile}},[_vm._v(_vm._s(_vm.index))]):_vm._e(),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.share),expression:"!share"}],class:{'shareTarget': _vm.shareTarget,'list': _vm.kind},on:{"click":_vm.shareFile}},[_vm._v(_vm._s(_vm.shareIndex))]),_vm._v(" "),_c('span',{attrs:{"id":"cancel"},on:{"click":_vm.cancelcopy}},[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"tip"},[_vm._v("\n      选择目标文件夹\n    ")])]),_vm._v(" "),_c('ul',{ref:"moveBox",staticClass:"ulBox",on:{"scroll":function($event){return _vm.moveScroll()}}},_vm._l((_vm.hello),function(item,index){return _c('li',[_c('div',{staticClass:"list"},[(_vm.slicetype(item.fileName,item.isDir,item.permissionType)!=='icon-package')?_c('span',[_c('i',{staticClass:"iconfont",class:_vm._f("sliceType")(item.fileName,item.isDir, item.permissionType)})]):_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-package"}})]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{staticClass:"right",on:{"click":function($event){return _vm.next(item.id,item.fileName,item.isDir,item.fileName)}}},[_c('h3',[_vm._v(_vm._s(item.fileName))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("formaTime")(item.gmtModified)))])]),_vm._v(" "),_c('div',{staticClass:"size"},[_vm._v(_vm._s(_vm._f("bytesToSize")(item.length)))])])])])}),0),_vm._v(" "),_c('div',{staticClass:"copy-bottom"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.shareTarget),expression:"shareTarget"}],staticStyle:{"width":"49%"},on:{"click":_vm.mkdir}},[_vm._v("新建文件夹")]),_vm._v(" "),_c('span',{style:({width: _vm.shareTarget ? '49%' : '100%'}),on:{"click":_vm.copyEnd}},[_vm._v(_vm._s(_vm.model))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XKeC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newphone_vue__ = __webpack_require__("tlhh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_390ba102_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newphone_vue__ = __webpack_require__("uDHu");
function injectStyle (ssrContext) {
  __webpack_require__("3Jbd")
  __webpack_require__("7pjy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-390ba102"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newphone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_390ba102_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newphone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XnY4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_tools__ = __webpack_require__("jt1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      info: {
        page: 0,
        size: 20
      },
      moreLoading: false,
      allLoaded: false,
      isChoose: true,
      len: 0,
      page: 0,
      size: 20,
      list: [],
      ids: [],
      isshow: false,
      iscancel: true,
      isreally: true,
      isup: false,
      isChooseAll: false,
      islen: true,
      select: '',
      ischange: true,
      isA: true,
      opacity: false,
      totalElements: 0,
      totalPages: 0,
      actions: [{
        name: '删除',
        method: this.deleted
      }],
      sheetVisible: false,
      action: [{
        name: '删除',
        method: this.deleteone
      }],
      sheetVisibla: false,
      fileId: '',
      delArr: []
    };
  },

  components: {
    formaTime: __WEBPACK_IMPORTED_MODULE_2__assets_js_tools__["c" /* formaTime */],
    MessageBox: __WEBPACK_IMPORTED_MODULE_3_mint_ui__["MessageBox"],
    Toast: __WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"]
  },
  computed: {
    params: function params() {
      return {
        size: this.size
      };
    }
  },
  created: function created() {
    this.load();
    // this.actionTypes()
  },

  methods: {
    load: function load() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].log, _this.info).then(function (response) {
        var data = response.data.content;
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            _this.totalElements = response.data.totalElements;
            _this.totalPages = response.data.totalPages;
            data[i].gmtCreate = Object(__WEBPACK_IMPORTED_MODULE_2__assets_js_tools__["c" /* formaTime */])(data[i].gmtCreate);
            _this.list.push(data[i]);
          }
        } else {
          _this.list = [];
        }
        return false;
      });
    },

    //      scroll: function () {
    //        let sw = true
    //        let _this = this
    //       _this.page = 1
    //        let ulBox = _this.$refs.ulBox
    //        if (ulBox.scrollTop + ulBox.clientHeight >= ulBox.scrollHeight) {
    //          if (sw === true) {
    //            sw = false
    //            _this.page++
    //            apis.request(cloudApi.log, {page: _this.page, size: _this.size}).then(function (res) {
    //              let data = res.data.content
    //              if (data.length > 0) {
    //                for (let i = 0; i < data.length; i++) {
    //                  if (data[i].fileName.length > _this.maxLen) {
    //                    data[i].fileName = data[i].fileName.substring(0, _this.maxLen) + '...'
    //                  }
    //                  data[i].gmtCreate = formaTime(data[i].gmtCreate)
    //                  _this.list.push(data[i])
    //                }
    //              }
    //            }).catch(function (error) {
    //            })
    //            sw = true
    //          }
    //        }
    //      },
    loadMore: function loadMore() {
      var _this2 = this;

      this.loading = true;
      var content = document.getElementById('mainlist');
      if (content.scrollHeight - content.scrollTop - content.offsetHeight < 10) {
        if (this.totalElements > this.list.length) {
          setTimeout(function () {
            var _this = _this2;
            if (_this.page < _this.totalPages) {
              _this.page++;
            }
            __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].log, { page: _this.page, size: _this.size }).then(function (res) {
              var list0 = [];
              var data = res.data.content;
              if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                  list0.push(data[i]);
                  data[i].gmtCreate = Object(__WEBPACK_IMPORTED_MODULE_2__assets_js_tools__["c" /* formaTime */])(data[i].gmtCreate);
                }
                if (_this.list && list0) {
                  _this.list = _this.list.concat(list0);
                }
              }
            });
            _this2.loading = false;
          }, 250);
        }
      }
    },

    // 全选或者取消选择
    choose: function choose() {
      if (this.isChooseAll) {
        this.cancelChooseAll();
      } else {
        this.checkAll();
      }
    },
    checkAll: function checkAll() {
      // 全选
      var _this = this;
      _this.len = _this.list.length;
      console.log(_this.len);
      _this.isChooseAll = true;
      if (_this.list.length > 0) {
        _this.list.forEach(function (row, index, array) {
          row.ischeck = true;
        });
        _this.islen = false;
        _this.isA = false;
        _this.opacity = true;
      }
    },
    cancelChooseAll: function cancelChooseAll() {
      this.len = 0;
      this.isChooseAll = false;
      this.isA = true;
      this.opacity = false;
      this.list.forEach(function (row, index, array) {
        row.ischeck = false;
      });
      this.islen = true;
    },
    check: function check(item) {
      var _this = this;
      if (item.ischeck === undefined) {
        this.$set(item, 'ischeck', true);
        _this.isA = false;
        _this.opacity = true;
        _this.len++;
        return;
      }
      if (item.ischeck) {
        item.ischeck = false;
        _this.len--;
        _this.islen = false;
        if (_this.len === 0) {
          _this.isA = true;
          _this.opacity = false;
        } else {
          _this.isA = false;
          _this.opacity = true;
        }
      } else {
        _this.isA = false;
        _this.opacity = true;
        item.ischeck = true;
        _this.len++;
        _this.islen = true;
      }
    },

    open: function open() {
      var _this = this;
      if (_this.list.length !== 0) {
        _this.isshow = true;
        _this.isreally = false;
        _this.iscancel = false;
        _this.ischange = false;
        _this.isA = true;
        _this.opacity = false;
      }
    },
    cancel: function cancel() {
      var _this = this;
      _this.isshow = false;
      _this.iscancel = true;
      _this.isreally = true;
      _this.islen = true;
      _this.ischange = true;
      _this.isChoose = true;
      _this.cancelChooseAll();
    },
    toggleUp: function toggleUp(index) {
      if (this.select === index) {
        this.select = '';
        this.isup = '';
      } else {
        this.select = index;
        this.isup = index;
      }
    },
    deleted: function deleted() {
      var _this = this;
      _this.list.forEach(function (value) {
        if (value.ischeck) {
          _this.ids.push(value.id);
        }
      });
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].logDeteleted, { logIds: _this.ids.join(',') }).then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
          message: '删除成功',
          iconClass: 'icon-success'
        });
        _this.load();
        _this.index = '操作日志';
        _this.iscancel = true;
        _this.ischange = true;
        _this.isreally = true;
        _this.isshow = false;
        _this.restore();
      }).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
          message: error.response.data.message,
          iconClass: 'icon-error'
        });
      });
    },
    deleteone: function deleteone() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].logDeteleted, { logIds: this.fileId }).then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
          message: '删除成功',
          iconClass: 'icon-success'
        });
        _this.load();
        _this.restore();
      }).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
          message: error.response.data.error,
          iconClass: 'icon-error'
        });
        _this.select = '';
      });
    },
    itemDelete: function itemDelete(item) {
      this.fileId = item.id;
      this.sheetVisibla = true;
      this.sheetVisible = false;
    },
    sheetVisibles: function sheetVisibles() {
      var _this3 = this;

      if (this.list.length > 0) {
        this.list.forEach(function (rows) {
          console.log(rows.ischeck);
          if (rows.ischeck) {
            _this3.sheetVisibla = false;
            _this3.sheetVisible = true;
          }
        });
      }
    },
    one_delete: function one_delete() {
      var _this = this;
      if (this.list.length > 0) {
        __WEBPACK_IMPORTED_MODULE_3_mint_ui__["MessageBox"].confirm('删除', {
          message: '<div style="margin-bottom: 10px">日志删除</div>' + '<p style="font-size: .28rem;color: #9b9b9b">确定要删除吗？</p>' + '<p style="font-size: .28rem;color: #9b9b9b">删除后将无法恢复</p>',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].logsDeteleted).then(function () {
            Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
              message: '删除成功',
              iconClass: 'icon-success'
            });
            _this.load();
          }).catch(function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
              message: error.response.data.message,
              iconClass: 'icon-error'
            });
          });
        });
      } else {
        return false;
      }
    },

    restore: function restore() {
      this.page = 0;
      this.size = 20;
      this.list = [];
      this.isshow = false;
      this.iscancel = true;
      this.isreally = true;
      this.isup = false;
      this.islen = true;
      this.select = '';
      this.up = '';
      this.ischange = true;
      this.isA = true;
      this.opacity = false;
      this.sheetVisible = false;
      this.sheetVisibla = false;
      this.isChooseAll = false;
      this.len = 0;
      this.fileId = '';
      this.delArr = [];
      this.info = {
        page: 0,
        size: 20
      };
    }
  }
});

/***/ }),

/***/ "YZBe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_index_index__ = __webpack_require__("JXTs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_login_login__ = __webpack_require__("W2Q3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_account_register__ = __webpack_require__("pDJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_account_forget__ = __webpack_require__("9yZn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_more_setinfo__ = __webpack_require__("4qZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_more_showinfo__ = __webpack_require__("bKRh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_recycle_recycle__ = __webpack_require__("RxuB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_collect_collect__ = __webpack_require__("L1o+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_tabbar__ = __webpack_require__("MTyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_log_log__ = __webpack_require__("Rw+R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_more_accountsafe__ = __webpack_require__("kzLP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_more_changusername__ = __webpack_require__("Km26");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_myShare_myShare__ = __webpack_require__("29bF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_otherShare_otherShare__ = __webpack_require__("QYzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_shareFile_shareFile__ = __webpack_require__("Ae4w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_shareFile_install__ = __webpack_require__("zUEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_more_changephone__ = __webpack_require__("qSux");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_more_acceptcode__ = __webpack_require__("4tMn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_more_newphone__ = __webpack_require__("XKeC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_transfer_transfer__ = __webpack_require__("pDWz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_group_list__ = __webpack_require__("sSfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_layout_MainLayout__ = __webpack_require__("bIDK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_group_member__ = __webpack_require__("4ZNh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_modifyPassword_modifyPassword__ = __webpack_require__("nOlU");
/* eslint-disable */





























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$ajax = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  hashbang: false,
  history: true,
  routes: [{ path: '/',
    redirect: '/login',
    component: __WEBPACK_IMPORTED_MODULE_24__views_layout_MainLayout__["a" /* default */],
    hidden: true,
    children: [
    // {path: 'login', component: Login},
    { path: 'index', name: 'index', component: __WEBPACK_IMPORTED_MODULE_2__views_index_index__["a" /* default */] }, { path: 'ShareFile', component: __WEBPACK_IMPORTED_MODULE_17__views_shareFile_shareFile__["a" /* default */] }, { path: 'account/register', component: __WEBPACK_IMPORTED_MODULE_5__views_account_register__["a" /* default */] }, { path: 'account/forget', component: __WEBPACK_IMPORTED_MODULE_6__views_account_forget__["a" /* default */] }, {
      path: 'more/setInfo',
      component: __WEBPACK_IMPORTED_MODULE_7__views_more_setinfo__["a" /* default */]
    }, {
      path: 'more/showinfo',
      component: __WEBPACK_IMPORTED_MODULE_8__views_more_showinfo__["a" /* default */]
    }, {
      path: 'recycle/recycle',
      component: __WEBPACK_IMPORTED_MODULE_9__views_recycle_recycle__["a" /* default */]
    }, {
      path: 'collect/collect',
      component: __WEBPACK_IMPORTED_MODULE_10__views_collect_collect__["a" /* default */]
    }, {
      path: 'history',
      component: __WEBPACK_IMPORTED_MODULE_11__components_tabbar__["a" /* default */]
    }, {
      path: 'log/log',
      component: __WEBPACK_IMPORTED_MODULE_12__views_log_log__["a" /* default */]
    }, {
      path: 'more/accountsafe',
      component: __WEBPACK_IMPORTED_MODULE_13__views_more_accountsafe__["a" /* default */]
    }, {
      path: 'more/changephone',
      component: __WEBPACK_IMPORTED_MODULE_19__views_more_changephone__["a" /* default */]
    }, {
      path: 'more/changusername',
      component: __WEBPACK_IMPORTED_MODULE_14__views_more_changusername__["a" /* default */]
    }, {
      path: 'more/acceptcode',
      component: __WEBPACK_IMPORTED_MODULE_20__views_more_acceptcode__["a" /* default */]
    }, {
      path: 'more/newphone',
      component: __WEBPACK_IMPORTED_MODULE_21__views_more_newphone__["a" /* default */]
    }, {
      path: 'more/newphonecode',
      component: __WEBPACK_IMPORTED_MODULE_21__views_more_newphone__["a" /* default */]
    }, {
      path: 'myShare',
      component: __WEBPACK_IMPORTED_MODULE_15__views_myShare_myShare__["a" /* default */]
    }, {
      path: 'otherShare',
      component: __WEBPACK_IMPORTED_MODULE_16__views_otherShare_otherShare__["a" /* default */]
    }, {
      path: 'tabbar',
      component: __WEBPACK_IMPORTED_MODULE_11__components_tabbar__["a" /* default */]
    }, {
      path: 'shareFile',
      name: 'ShareFile',
      component: __WEBPACK_IMPORTED_MODULE_17__views_shareFile_shareFile__["a" /* default */]
    }, {
      path: 'shareFile/install',
      component: __WEBPACK_IMPORTED_MODULE_18__views_shareFile_install__["a" /* default */]
    }, {
      path: 'transfer',
      component: __WEBPACK_IMPORTED_MODULE_22__views_transfer_transfer__["a" /* default */]
    }, {
      path: 'groupManage',
      component: __WEBPACK_IMPORTED_MODULE_23__views_group_list__["a" /* default */]
    }, {
      path: 'memberManage',
      component: __WEBPACK_IMPORTED_MODULE_25__views_group_member__["a" /* default */]
    }]
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_4__views_login_login__["a" /* default */]
  }, {
    path: '/modifyPassword',
    name: 'modifyPassword',
    component: __WEBPACK_IMPORTED_MODULE_26__views_modifyPassword_modifyPassword__["a" /* default */]
  }]
}));

/***/ }),

/***/ "YgvM":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAM+SURBVFhH7VZbT1pBEOYnV60KaB/ENhWVplgExUSwlIqKF9Qqtj61Nm0VUJN6V7wLooKtt8cp3za7nD1nQY1tTRMfvgR2vpn5ds/s7JguLq/oPvEg4P8QcHZ+QSurazQ+PkEeTztVm630qKxcgtliJU+bl6IT7xkXPqpYepQUkM4c0eBQhKw1tYaE16Gm9gkNRiIshio2R1EBU1OfDTutqjZTq9tDoZ5eGh4ZldDp87FT0PIBrCGWKgdgEJDNnZLb3SYFcb5y0ez8PP08O5e4KqTShxSLJ8jZ0iLFgHDE1vMlASA0O14IJxz97Nyc5HAbTM/EyGKtEfEQWy9CCMid/pCSY9fHJ1mJrMX5xSVtbW3T9s4u+63iAJmjY3rpdEoikIvbhYCenj5Bamp2SCQt1jaS5O3ooCqzRfDxG2sbyaTSJ5ffdYO9SfDfdoeEjQnAteFGW/1TOsnmpAAcM7EEVTyuFFw9YIvF40rfo+MTqquzMV5ZeQU7OawzAa5WjzAsr6wanIG9/QOqrKoWyYLBbvaNv3ydpkAwKNZxU/YPUsoYC4vLgod+gjUTlPDFwJugwYnD3/Va8FS7xOlwe1cgYLBzuPOJOW9re4dMff39YmE3v0uVE4qM9wRcURUHcLndjANuscL8vrAo8oX7B8hUZ6tnf5odDqUDcJBKC6exsaiSA4y+GxM8VL+KA/CCRG6T7QYCUumMCIwkKg5wUwF2eyPjMAHhcOETLBUpQBwnigscqC/20PDuV+oTJDc3RT7kNu3s7rHqxwLussoJ8GmKMDI8ItkgKDwwIOylilAbBxeAXUPtInqC3gnQX8NOv5++Tc/Qh8lJeva8QayjKRW7hkvLK4LHi5kJgANvMHdtRPFEQumLRsTrDeD9RrTiociwMF7Xitu9civGN79NK+4Lh4VNCPi7j1HhaS76GAF4Ku2NBaV3fY4xF1ishSGl5HPMkc3lxNvA0eJqpUReCIYNPV8PDC3xxKxhIEELvnYg0eLjpykya74zB07F5/MbRrJQqJe1Yt4vOBADsVQ5gKICgPRhhg2lGDC1QW+COw+lWvwey9cpGp2gtnavYVgF5LF8/c+M5f8CDwLuWcAV/QJJyNJwEdGFWQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "ZKdX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZPUo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var imgType = ['jpg', 'gif', 'png', 'jpeg', 'bmp'];

var bytesToSize = function bytesToSize(bytes) {
  if (bytes === 0) return '0 B';
  if (bytes === '') return '';
  var k = 1024;
  var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return (bytes / Math.pow(k, i)).toPrecision(3) + sizes[i];
};

var sliceType = function sliceType(val, num, flag, fileNum, shareStatus) {
  if (shareStatus === -1) {
    return 'icon-default';
  }
  if ((num === 1 || fileNum > 1) && flag !== undefined) {
    return 'icon-shareDir';
  }
  if (num === 1 || fileNum > 1) {
    return 'icon-dir';
  }
  var point;
  if (typeof val === 'string' && (point = val.indexOf('.')) !== -1) {
    var type = val.substring(point + 1).toLowerCase();
    if (imgType.indexOf(type) !== -1) {
      return 'icon-pic';
    } else if (type === 'avi' || type === 'rmvb' || type === 'rm' || type === 'asf' || type === 'divx' || type === 'mpg' || type === 'mpeg' || type === 'mpe' || type === 'mp4' || type === 'mkv' || type === 'vob ') {
      return 'icon-video';
    } else if (type === 'WAVE' || type === 'AIFF' || type === 'MPEG' || type === 'MP3' || type === 'MIDI' || type === 'mp3') {
      return 'icon-muisc';
    } else if (type === 'txt') {
      return 'icon-txt';
    } else if (type === 'pdf') {
      return 'icon-pdf';
    } else if (type === 'doc' || type === 'docx') {
      return 'icon-word';
    } else if (type === 'ppt' || type === 'pptx') {
      return 'icon-ppt';
    } else if (type === 'xls' || type === 'xlsx') {
      return 'icon-excel';
    } else if (type === 'html' || type === 'htm') {
      return 'icon-html';
    } else if (type === 'wps' || type === 'wpt') {
      return 'icon-wps';
    } else if (type === 'zip' || type === 'rar') {
      return 'icon-package';
    } else {
      return 'icon-default';
    }
  }
};

var formaTime = function formaTime(val) {
  if (val !== '' || undefined || null) {
    return new Date(val).format('yyyy-MM-dd HH:mm');
  }
};

var prompt = function prompt(val, pid) {};

/* harmony default export */ __webpack_exports__["a"] = ({ bytesToSize: bytesToSize, sliceType: sliceType, formaTime: formaTime });

/***/ }),

/***/ "ZiMy":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAvpJREFUSA21lktMU0EUhv8ZSltoCJSHi+LCxKCS6IaVCDEkPtD4hDUxcauJiYpiDCIEA7gCIUYXGBJlbzRBFkaDCLhRfGxgY2Ji7QIoDcVIe2nvdc7QqfdeLlBQu2DuOfPPd+Zx5gwM6/zCNTXbY3H9jAH9BGNsp5AGUvKQYRhfGfiQ18OfFY2MBNfCMKeO2aojAc2ItYm+8wKU5aRRPhE4Kb4H3Mx7u2T8ZUj5VbsqwI+qg6dh6IOGgTwlyqRlDItgvKF0fPS5Wc/NRuhA9SXo+tPNwokhx4ixkmGCplcgZ05wwBLUpM3oUwB1cF6nViJhtOdyW/4S7qmogL+9jRNLMsWUZAA60K1si1oSy85G/sULKO7rQXJuTm5XKknAZCpqyW8bZYuC2VtXaSkKO9qRXVaGX0PDiHR0ygOh7PK6s3a4VvJ8/VS0Q5Xt3rcXRXe7wAvysfRmFJHOLgmnfpowsTldIjVgM23O4UNiS+5JeHxyEpGWVnG8ugVBbBfdUBHN0rGR4as/i4KrVwCR/MlwGPO3WmEsL68aRmw6ZHX9pYB5PPC3NCP31MlVA8jhq/sDpxnTzPVIxFErnAGXvaew4w68lfuRe6wW7t27sNDTCyORkDIKWtC4MnNyRPsfIf7xkx1hsWkFlvoRffAQejQqRb76Opl63O8XQSvhb7omt4U6ad8XHw9K3Tp/QixYWf1CCI6bRe7ychT3doP5fNKdnJkFz8sDy/FKm/Z7puEcEt/XLKIKN8yp5CpLtdrUFOYar8NYiklX1raSNJwcP8XMM4CD2JzqearkKr5stc9fEG66AUPTLP5EMCi25onF52TIiybYPPVYDDiJ4u8/YP5mc/qQSbPQd98xJR3GDxBb1iJ6LGQ9d1DFJt6lL5E2PY3Y2zEHldVFLGKSN+NynVt7VK5k6dVrK81m2ct1OgDp6LEQl7p7q28CwcXsLwcmxnpVXEsAcv7XJ5MC0EvkZjl7RBb0O2UXacw/0pCWxqhXzNJvNuzf/+Lflt/rU0bKD02pAAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "Zwg4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bIDK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainLayout_vue__ = __webpack_require__("p8Zz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76050d2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainLayout_vue__ = __webpack_require__("2MbT");
function injectStyle (ssrContext) {
  __webpack_require__("UZfP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76050d2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76050d2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bKRh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_showinfo_vue__ = __webpack_require__("pJgE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_068ee18c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_showinfo_vue__ = __webpack_require__("l1A3");
function injectStyle (ssrContext) {
  __webpack_require__("cqEJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-068ee18c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_showinfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_068ee18c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_showinfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cJ/I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_tools__ = __webpack_require__("jt1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tabbar_vue__ = __webpack_require__("MTyd");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isIphoneX: false,
      usedSize: '',
      quota: '',
      fsnum: '',
      isLink: true,
      nickName: '',
      actions: [{
        name: '确认退出登录吗',
        method: ''
      }, {
        name: '确认退出',
        method: this.loginout
      }],
      sheetVisible: false
    };
  },

  components: {
    bytesToSize: __WEBPACK_IMPORTED_MODULE_3__assets_js_tools__["b" /* bytesToSize */],
    tabbar: __WEBPACK_IMPORTED_MODULE_4__components_tabbar_vue__["a" /* default */]
  },
  created: function created() {
    this._conmentNum();
    this.nickName = JSON.parse(sessionStorage.mobileData).nickName;
    var isx = this.$store.state.isIphoneX;
    this.isIphoneX = isx;
  },
  updated: function updated() {
    this.rotateCircle();
  },

  methods: {
    rotateCircle: function rotateCircle() {
      function drawRing(w, h, val) {
        // 先创建一个canvas画布对象，设置宽高
        var c = document.getElementById('myCanvas');
        var ctx = c.getContext('2d');
        ctx.canvas.width = w;
        ctx.canvas.height = h;
        ctx.beginPath();
        ctx.lineWidth = 10; // 10px
        ctx.strokeStyle = '#97beee';
        // arc()方法创建弧/曲线（用于创建圆或部分圆）arc(圆心x,圆心y,半径,开始角度,结束角度)
        ctx.arc(50, 50, 40, 0, 2 * Math.PI);
        // 绘制已定义的路径
        ctx.stroke();
        // 绘制根据百分比变动的环
        ctx.beginPath();
        ctx.lineWidth = 10;
        ctx.strokeStyle = '#ffd329';
        // 设置开始处为0点钟方向（-90*Math.PI/180）
        // x为百分比值（0-100）
        ctx.arc(50, 50, 40, -90 * Math.PI / 180, (val * 3.6 - 90) * Math.PI / 180);
        ctx.stroke();
        // 绘制中间的文字
        ctx.font = '20px Arial';
        ctx.fillStyle = '#ffffff';
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'center';
        ctx.fillText(val + '%', 50, 50);
      }

      drawRing(100, 100, this.fsnum);
    },
    _conmentNum: function _conmentNum() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].show, {}).then(function (response) {
        window.sessionStorage.mobileData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data);
        _this.usedSize = Object(__WEBPACK_IMPORTED_MODULE_3__assets_js_tools__["b" /* bytesToSize */])(response.data.usedSize);
        _this.quota = Object(__WEBPACK_IMPORTED_MODULE_3__assets_js_tools__["b" /* bytesToSize */])(response.data.quota);
        var data = response.data;
        // if (data.usedSize < 536870912 & data.usedSize > 0) {
        //   _this.fsnum = 1
        // } else
        if (data.usedSize === 0) {
          _this.fsnum = 0;
        } else {
          _this.fsnum = data.usedSize / data.quota * 100 + '';
          _this.fsnum = _this.fsnum.substring(0, 4);
        }
      });
    },
    loginOut: function loginOut() {
      this.sheetVisible = true;
    },
    loginout: function loginout() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].logout, {}).then(function () {
        sessionStorage.removeItem('mobileData');
        // window.localStorage.clear()
        _this.$router.push('/login');
      });
    }
  }
});

/***/ }),

/***/ "cix8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cqEJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "evg2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ "fGAn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fclH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crumbs_vue__ = __webpack_require__("1AK6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268c2182_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_crumbs_vue__ = __webpack_require__("Svdy");
function injectStyle (ssrContext) {
  __webpack_require__("+ztV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-268c2182"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crumbs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268c2182_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_crumbs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fvI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gKhT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkShare_vue__ = __webpack_require__("O2Ex");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61c39cd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linkShare_vue__ = __webpack_require__("B963");
function injectStyle (ssrContext) {
  __webpack_require__("LYVb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61c39cd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkShare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61c39cd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linkShare_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gawV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"back_and_close"},[_c('img',{staticClass:"pic2",attrs:{"src":_vm.close},on:{"click":_vm.closeWindow}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gdx1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_history_vue__ = __webpack_require__("yN5e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8e04b0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__ = __webpack_require__("Q9NE");
function injectStyle (ssrContext) {
  __webpack_require__("+7Vn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f8e04b0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_history_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8e04b0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gedM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clipboard__ = __webpack_require__("V33R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addmember__ = __webpack_require__("KoGp");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    chooseMember: __WEBPACK_IMPORTED_MODULE_4__addmember__["a" /* default */]
  },
  name: 'share',
  data: function data() {
    return {
      isGenerateLink: false,
      time: 0,
      clipFlag: true,
      currentValue: true,
      isCopy: false,
      isSendWorkmate: false
    };
  },

  props: ['fileId'],
  created: function created() {},

  methods: {
    //      分享
    shareBegin: function shareBegin() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].share, { fileIds: _this.fileId, shareType: 0, validTime: _this.time }).then(function (res) {
        _this.isGenerateLink = true;
        _this.clipFlag = false;
        var shareLink = window.location.protocol + '//' + window.location.host + res.data.shareLink;
        /* eslint-disable */
        if (_this.clipFlag === false) {
          new __WEBPACK_IMPORTED_MODULE_3_clipboard___default.a('#clipboard', {
            text: function text() {
              return shareLink;
            }
          });
        }
      }).catch(function (error) {
        console.log(11111111111);
        Object(__WEBPACK_IMPORTED_MODULE_1_mint_ui__["Toast"])({
          message: error.response.data.message,
          iconClass: 'icon-error'
        });
      });
    },
    //      复制链接
    clip: function clip() {
      var _this = this;
      this.$emit('share', true);
      Object(__WEBPACK_IMPORTED_MODULE_1_mint_ui__["Toast"])({
        message: '链接已复制',
        iconClass: 'icon-success'
      });
      this.isGenerateLink = false;
    },
    sendWorkmate: function sendWorkmate() {
      this.isSendWorkmate = true;
    },
    cancelSendWorkmate: function cancelSendWorkmate() {
      this.isSendWorkmate = false;
    },
    confirmSendWorkmate: function confirmSendWorkmate(userIds) {
      var _this = this;
      this.isSendWorkmate = false;
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].shareWorkmate, { fileIds: this.fileId, receiveUserIds: userIds.join(','), validTime: this.time }).then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_1_mint_ui__["Toast"])({
          message: '分享成功',
          iconClass: 'icon-success'
        });
        _this.$emit('share', false);
      });
    }
  }
});

/***/ }),

/***/ "gsDw":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAAGWB6gOAAAAAXNSR0IArs4c6QAABA9JREFUWAm9mF2IVWUUhuc4zuTPEEEQSo2pTDjRRIM4RBETYhCCKAhz54V4F8gQWF1YdFF0kXRhKAwEDYhCNGYlYeEPemMX3Xqh6OBPM1NNjPQ3Wqnh7nn3+b591nf2t8/ZZ2ZqwTrfWu/7rvfbZ845+2fakiR5pS0WEEkMb8sRAIukzAiKh+xoRlgwqANFtAGs1Haww4HcEtQ5zgK2rpurTkYFgA/ECGFEp/Y8lbOrAxbTdyKcqFQqq+o4GdwA+z7FacbIX6xIPXnUYpr6kPxLoFZyfyDwDcTr5H1yj8dyK6TigF5ypAARxEZXv6QmEAognrYgfb/AFFNBdFuBr8FXi9Q2X6sgrniylZW5yxrOZqhPCCCmM7BBge6nVM2BRGWQo04wGxPAzTp+NMbnMMTvuoG7Iqnvuv6dnBigEgMtpmHf831rqvfabHW7a9kikHWbxzJRUYFwsRezPhvTgT9vNO2BBmK5IZ8IyIIGfa+ZWapD/s0BjxTMNISZXUnOyGiGnJNJsAMmPh4LiBINg4+64UkdUZd3Yu0pMZ9K0K41c10eXGLAvmZmaJ8y+iWBHsJ+9AMBaRp0G4xJh6FqJYJFRjRYY6oV3KDh0ytSvSbojXizJ8A2e9xjdi387WjICYdYpRtTX/R7KzTSkDFTW2girtn7fFUiF8O+aGnlaN7WERH3yH/SKknebNXkAzf4tx+kv+Ow9z3WcEX8kRu4VS8Ev+24kXou6BF94oS/BoRp4H93msMGrpWQXznBzzU0XqHTGUPxRaAAOJvCSTIZEA0a9D+4mepNBs13DhhvMBelmLvmZsfSLx3NhaiyBMis3s0uGfk/HmVykVxZYn7BJOy3gvyGnCR36IAeJL8lbeitr16wXSNG+D9OXiVtfJZJQZeRpy1LrQ+4NxMtQIHfOnKKtHGGZlnUHkJ3p19aNbW+xv3RgZIg8884H5YsjlN1lrJA2E4eyUarhb5vz5UycCLpSX9LUHWp+oY3H2VNcaiQI97JrTolbWrkIZ70py43lvo0vEQ08sxxuO7zzm7ViXerFdLrns6fkJ0sKXditkat1Ozylt/Jrbq8HCT9ZcbTe1vxnbeWXYf9zma9T7173uatGrDpG+YgVOpAbLzWquec9Oz4nt2VWk8m22XGOuR6liyiTyxz2twPYa1fWvpkmm2TJH9Sv+w1dgXXLZ2eh23En43tYLMaN52LDllX6j/IF5rNikf3IukfDinT+JjXZjd1oT0DHeSxdLz2cpNyfags1zE3QOpfDDY+pdH/LYoDwVLypJ2i/pF8sniqPINPHzlN2jhBk3vw0BX/vFVRXyfXlN+uvBLfHnKCtHGOpkufc/1f5BLY/3JPxD7d5DjpY0oHtJPUfcnn5MPl3+d/o/wXBEDyMQBTVR8AAAAASUVORK5CYII="

/***/ }),

/***/ "gzJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"head clearfix yp-topbar"},[_c('ul',[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],staticClass:"btn fl",on:{"click":function($event){return _vm.choose()}}},[_vm._v("\n        "+_vm._s(_vm.isChooseAll ? '取消全选' : '全选')+"\n      ")]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],staticClass:"btn fr",on:{"click":_vm.cancel}},[_vm._v("取消")]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.len),expression:"!len"}],staticClass:"tittle"},[_vm._v("我的收藏")]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.len),expression:"len"}],staticClass:"tittle"},[_vm._v("已选择"+_vm._s(_vm.len)+"文件")]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isA),expression:"!isA"}],staticClass:"check-mobile",attrs:{"id":"check-collect"},on:{"click":_vm.checkMobile}}),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isA),expression:"!isA"}],attrs:{"slot":"left","to":"/more/setinfo"},slot:"left"},[_c('li',{staticClass:"back"})])],1)]),_vm._v(" "),(_vm.list.length===0)?_c('div',{staticClass:"jpg"},[_vm._m(0)]):_c('ul',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],ref:"ulBox",staticClass:"ulbox",attrs:{"infinite-scroll-distance":"0","infinite-scroll-immediate-check":"false","infinite-scroll-disabled":"moreLoading"}},_vm._l((_vm.list),function(item,index){return _c('li',[_c('div',{staticClass:"liList"},[_c('div',{staticClass:"left"},[_c('em',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],ref:"mycheck",refInFor:true,staticClass:"check",class:{'checked': item.isB, 'nochecked': !item.isB},attrs:{"fileId":item.id},on:{"click":function($event){return _vm.checked(item)}}}),_vm._v(" "),(_vm.sliceType(item.fileName,item.isDir,item.fileCategory)!=='package')?_c('span',{class:_vm.styleObject(item.fileName,item.isDir,item.fileCategory)},[_c('i',{staticClass:"iconfont",class:_vm.classObject(item.fileName,item.isDir,item.fileCategory)})]):_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-package"}})])]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{staticClass:"contentIn",on:{"click":function($event){return _vm.deepPath(item.id,item.fileName,item.isDir,item.fileCategory)}}},[_c('h3',{staticClass:"filename"},[_vm._v(_vm._s(item.fileName))]),_vm._v(" "),_c('span',{staticClass:"filetime"},[_vm._v(_vm._s(item.gmtModified))])])])]),_vm._v(" "),_c('div',{class:{'more':_vm.up===index},attrs:{"id":"more"},on:{"click":function($event){return _vm.toggleUp(index)}}}),_vm._v(" "),(_vm.select===index)?_c('div',{staticClass:"div"},[_c('ul',{staticClass:"listBox clearfix"},[_c('li',[_c('i',{staticClass:"iconfont icon-fenxiang",staticStyle:{"font-size":".48rem","display":"block","color":"#999999"}}),_vm._v(" "),_c('p',{ref:"share",refInFor:true,attrs:{"id":item.id},on:{"click":function($event){return _vm.currency(item.id,'分享')}}},[_vm._v("分享")])]),_vm._v(" "),(false)?_c('li',[_c('i',{staticClass:"iconfont icon-xiazai",staticStyle:{"font-size":".48rem","display":"block","color":"#999999"}}),_vm._v(" "),_c('p',{ref:"download",refInFor:true,attrs:{"id":item.id},on:{"click":function($event){return _vm.download('1',item.id,item.isDir,'',item.fileName)}}},[_vm._v("下载")])]):_vm._e(),_vm._v(" "),_c('li',[_c('i',{staticClass:"iconfont icon-quxiaoshoucang",staticStyle:{"font-size":".48rem","display":"block","color":"#999999"}}),_vm._v(" "),_c('p',{ref:"nocollect",refInFor:true,attrs:{"id":item.id},on:{"click":_vm.noCollect}},[_vm._v("取消收藏")])])])]):_vm._e()])}),0),_vm._v(" "),_c('mt-tabbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.isA),expression:"isA"}],class:{'selected': _vm.isA, 'selected-t': _vm.opacity}},[_c('mt-tab-item',{attrs:{"id":"分享"}},[_c('i',{staticClass:"iconfont icon-fenxiang",staticStyle:{"font-size":".48rem","display":"block","margin":"0 auto"},on:{"click":function($event){return _vm.delActions('分享')}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.delActions('分享')}}},[_vm._v("分享")])]),_vm._v(" "),(false)?_c('mt-tab-item',{attrs:{"id":"下载"}},[_c('i',{staticClass:"iconfont icon-xiazai",staticStyle:{"font-size":".48rem","display":"block","margin":"0 auto"},on:{"click":function($event){return _vm.downloads('下载')}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.downloads('下载')}}},[_vm._v("下载")])]):_vm._e(),_vm._v(" "),_c('mt-tab-item',{attrs:{"id":"取消收藏"}},[_c('i',{staticClass:"iconfont icon-quxiaoshoucang",staticStyle:{"font-size":".48rem","display":"block","margin":"0 auto"},on:{"click":function($event){return _vm.noCollects('取消收藏')}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.noCollects('取消收藏')}}},[_vm._v("取消收藏")])])],1),_vm._v(" "),(_vm.currentValue)?_c('share',{attrs:{"fileId":_vm.fileId},on:{"share":_vm.listenToShare}}):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('div',{staticClass:"v-model",staticStyle:{"z-index":"2000","height":"100%"},on:{"click":function($event){_vm.currentValue=false;_vm.time=false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":__webpack_require__("2u6q"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("您还没有收藏文件夹～")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h6b3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logo_vue__ = __webpack_require__("D456");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2ff78a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logo_vue__ = __webpack_require__("jdJ+");
function injectStyle (ssrContext) {
  __webpack_require__("0WDf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e2ff78a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2ff78a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hYmq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forget_wrap"},[_c('mt-header',{attrs:{"fixed":"","title":"找回密码"}},[_c('router-link',{attrs:{"slot":"left","to":"/"},slot:"left"},[_c('span',{staticClass:"back"})])],1),_vm._v(" "),(_vm.isLogo)?_c('logo'):_vm._e(),_vm._v(" "),(_vm.isFirstStep)?_c('div',[_c('div',{staticStyle:{"background":"#ffffff"}},[_c('form',{staticClass:"forgetForm"},[(_vm.isShow)?_c('div',{staticClass:"errowShow"},[_vm._v(_vm._s(_vm.tishi))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"forget_label"},[_vm._v("手机号码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"inputForm phone",attrs:{"type":"number","placeholder":"输入手机号码","oninput":"if(value.length>11)value=value.slice(0,11)"},domProps:{"value":(_vm.phone)},on:{"focus":_vm.changePhone,"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('div',{ref:"getMsg",staticStyle:{"position":"absolute","right":".5rem","bottom":"0"},on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[(_vm.sendMsgDisabled)?_c('span',{staticClass:"getCode"},[_vm._v(" 获取验证码")]):_c('span',{staticClass:"getCode"},[_vm._v(_vm._s(_vm.time + '秒后获取'))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"forget_label"},[_vm._v("验证码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"inputForm",attrs:{"type":"text","placeholder":"输入验证码","oninput":"if(value.length>6)value=value.slice(0,6)"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticStyle:{"padding":".6rem .4rem"}},[_c('mt-button',{staticClass:"btn",attrs:{"type":"primary","size":"large"},on:{"click":_vm.nextHandler}},[_vm._v("下一步")])],1)]):_vm._e(),_vm._v(" "),(_vm.isSecondStep)?_c('div',[_c('div',{staticStyle:{"background":"#ffffff"}},[_c('form',{staticClass:"forgetForm"},[(_vm.isShow)?_c('div',{staticClass:"errowShow"},[_vm._v(_vm._s(_vm.tishi))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"forget_label"},[_vm._v("新密码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"inputForm",attrs:{"type":"password","placeholder":"输入新密码"},domProps:{"value":(_vm.password)},on:{"blur":_vm.changePassword,"focus":_vm.focusPassword,"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"forget_label"},[_vm._v("确认密码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirm_password),expression:"confirm_password"}],staticClass:"inputForm",attrs:{"type":"password","placeholder":"再次输入新密码"},domProps:{"value":(_vm.confirm_password)},on:{"blur":_vm.changeConfirm_password,"focus":_vm.focusConfirm_password,"input":function($event){if($event.target.composing){ return; }_vm.confirm_password=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticStyle:{"padding":".6rem .4rem"}},[_c('mt-button',{staticClass:"btn",attrs:{"type":"primary","size":"large"},on:{"click":_vm.nextDetermine}},[_vm._v("确定")])],1)]):_vm._e(),_vm._v(" "),(_vm.isThirdStep)?_c('div',{staticClass:"wrap"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticStyle:{"padding":".6rem .4rem","display":"block"},attrs:{"to":"/login"}},[_c('mt-button',{staticClass:"btn",attrs:{"type":"primary","size":"large"}},[_vm._v("返回登录页面")])],1)],1):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap_in"},[_c('div',[_c('img',{attrs:{"src":__webpack_require__("ZiMy"),"alt":""}})]),_vm._v(" "),_c('p',{staticStyle:{"font-size":".4rem"}},[_vm._v("密码设置成功")]),_vm._v(" "),_c('p',{staticClass:"info"},[_vm._v("您可以通过用户名+密码或 手机号+密码")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":".28rem","color":"#888888"}},[_vm._v("登陆法务云盘")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i3p+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_addmember__ = __webpack_require__("KoGp");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      triggerAddMember: false,
      tableData: [],
      isChoose: false, // 是否触发勾选
      isChooseAll: false,
      selectCount: 0,
      ids: [], // 需要操作的行
      selectRow: {},
      deleteTrigger: false, // 删除确认触发
      page: {
        pageNo: 0,
        pageSize: 20,
        totalElements: 0
      },
      isDialogShow: false,
      group: {
        groupName: '',
        groupId: ''
      }
    };
  },

  components: {
    addmember: __WEBPACK_IMPORTED_MODULE_4__components_addmember__["a" /* default */]
  },
  created: function created() {
    this.group.groupId = this.$route.query.groupId;
    this.group.groupName = this.$route.query.groupName;
    this.tableInit();
  },

  computed: {
    bottom: function bottom() {
      return this.isChoose ? '0.98rem' : 0;
    },
    isShadeShow: function isShadeShow() {
      return this.isDialogShow || this.deleteTrigger;
    }
  },
  methods: {
    triggerAddMemberMed: function triggerAddMemberMed() {
      this.triggerAddMember = true;
    },
    memberListScroll: function memberListScroll() {
      var content = document.getElementById('main');
      if (content.scrollHeight - content.scrollTop - content.offsetHeight < 10) {
        if (this.page.totalElements > this.tableData.length) {
          this.querymemberList();
        }
      }
    },
    confirmOperation: function confirmOperation(userIds) {
      var _this2 = this;

      var param = userIds.map(function (value) {
        return { id: value, type: 1 };
      });
      param = {
        id: this.group.groupId,
        users: param
      };
      __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].addMember, { param: encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param)) }).then(function () {
        _this2.triggerAddMember = false;
        _this2.tableInit();
      });
    },
    cancelOperation: function cancelOperation() {
      this.triggerAddMember = false;
    },

    // 触发checkbox显示
    triggerChoose: function triggerChoose() {
      this.isChoose = true;
      if (this.selectRow.isXiala) {
        this.selectRow.isXiala = !this.selectRow.isXiala;
        this.selectRow.isTransform = !this.selectRow.isTransform;
      }
    },

    // 删除选中群组
    confirmDelete: function confirmDelete() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].deleteMember, { userIds: this.ids.join(','), id: this.group.groupId }).then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
          message: '删除成功',
          iconClass: 'icon-success'
        });
        _this3.deleteTrigger = false;
        _this3.selectCount = 0;
        _this3.tableData = _this3.tableData.filter(function (row, index, array) {
          // 将未删除的数据重新赋值给列表数据
          if (_this3.ids.indexOf(row.id) === -1) {
            // 重新计算选中个数
            if (row.isSelected) {
              _this3.selectCount++;
            }
            return true;
          }
          return false;
        });
        _this3.ids = [];
        if (!_this3.tableData.length) {
          _this3.isChoose = false;
        }
      });
    },

    // 存储需要删除的行并弹出确认操作
    deleteGroup: function deleteGroup(item) {
      var _this4 = this;

      if (item) {
        this.ids.push(item.id);
      } else {
        this.tableData.forEach(function (value, index, array) {
          if (value.isSelected) {
            _this4.ids.push(value.id);
          }
        });
      }
      this.deleteTrigger = true;
    },

    // 点击下拉图标
    xialaClick: function xialaClick(item) {
      if (!item.isXiala) {
        if (this.selectRow.isXiala) {
          this.selectRow.isXiala = !this.selectRow.isXiala;
          this.selectRow.isTransform = !this.selectRow.isTransform;
        }
        this.selectRow = item;
      }
      item.isXiala = !item.isXiala;
      item.isTransform = !item.isTransform;
    },

    // 列表数据初始化
    tableInit: function tableInit() {
      this.tableData = [];
      this.page.pageNo = 0;
      this.page.totalElements = 0;
      this.querymemberList();
    },
    querymemberList: function querymemberList() {
      var _this5 = this;

      var _this = this;
      __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].memberListByGroup, {
        page: this.page.pageNo,
        size: this.page.pageSize,
        groupId: this.group.groupId
      }).then(function (resopnse) {
        resopnse.data.content.forEach(function (row, index, array) {
          row.isSelected = false;
          row.isXiala = false;
          row.isTransform = false;
        });
        _this.tableData = _this.tableData.concat(resopnse.data.content);
        for (var i = 0; i < _this5.tableData.length; i++) {
          if (_this.tableData[i].avator) {
            _this.tableData[i].avator = __WEBPACK_IMPORTED_MODULE_2__apis_index__["a" /* default */].app.cloudStorage.baseUrl + _this.tableData[i].avator;
          }
        }
        _this5.page.totalElements = resopnse.data.totalElements;
      });
      this.page.pageNo++;
    },

    // 返回
    returnBack: function returnBack() {
      this.$router.push('/groupManage');
    },

    // 全选或取消全选
    choose: function choose() {
      if (this.isChooseAll) {
        this.cancleChooseAll();
      } else {
        this.chooseAll();
      }
    },

    // 取消全选
    cancleChooseAll: function cancleChooseAll() {
      this.selectCount = 0;
      this.isChooseAll = false;
      this.tableData.forEach(function (row, index, array) {
        row.isSelected = false;
      });
    },

    // 全选
    chooseAll: function chooseAll() {
      this.selectCount = this.tableData.length;
      this.isChooseAll = true;
      this.tableData.forEach(function (row, index, array) {
        row.isSelected = true;
      });
    },
    cancle: function cancle() {
      this.isChoose = false;
      if (this.selectRow.isXiala) {
        this.selectRow.isXiala = !this.selectRow.isXiala;
        this.selectRow.isTransform = !this.selectRow.isTransform;
      }
      this.cancleChooseAll();
    },
    chooseOne: function chooseOne(item) {
      if (item.isSelected) {
        item.isSelected = false;
        this.selectCount--;
        if (this.isChooseAll) {
          this.isChooseAll = false;
        }
      } else {
        item.isSelected = true;
        this.selectCount++;
        if (this.selectCount === this.tableData.length) {
          this.isChooseAll = true;
        }
      }
    }
  }
});

/***/ }),

/***/ "ilG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__ = __webpack_require__("kRT9");





var prompt = function prompt(_this, title) {
  if (title === '个人文件') {
    __WEBPACK_IMPORTED_MODULE_2_mint_ui__["MessageBox"].prompt('新建文件夹', '', {
      inputValue: '新建文件夹',
      showInput: true,
      inputPattern: /^.{1,50}$/,
      inputErrorMessage: '名字长度为1-50个字符'
    }).then(function (_ref) {
      var value = _ref.value,
          action = _ref.action;

      if (action === 'confirm' && value !== null) {
        __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].mKdir, { dirName: value, pid: _this.pid }).then(function (response) {
          _this.parentId.push({ pid: _this.pid, index: _this.index });
          _this.pid = response.data.id;
          _this.index = value;
          _this.indexs = value;
          window.localStorage.setItem('index', response.data.fileName);
          window.localStorage.setItem('pid', response.data.id);
          var parentArr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.parentId);
          window.localStorage.setItem('parentId', parentArr);
          _this.$store.commit('changeId', response.data.id);
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].searchFile, { fileId: response.data.id, page: 0, size: 20 }).then(function (res) {
            var data = res.data.content;
            _this.hello = [];
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: '新建成功',
              iconClass: 'icon-success'
            });
          });
        }).catch(function (error) {
          Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
            message: error.response.data.message,
            iconClass: 'icon-error'
          });
        });
      }
    });
  } else if (title === '共享文件') {
    __WEBPACK_IMPORTED_MODULE_2_mint_ui__["MessageBox"].prompt('新建文件夹', '', {
      showInput: true,
      inputValue: '新建文件夹',
      inputPattern: /^.{1,50}$/,
      inputErrorMessage: '名字长度为1-50个字符'
    }).then(function (_ref2) {
      var value = _ref2.value,
          action = _ref2.action;

      if (action === 'confirm' && value !== null) {
        var api = _this.sharePid === '' ? __WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].mkFirstShareDr : __WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].mKDir;
        __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(api, { dirName: value, pid: _this.sharePid }).then(function (response) {
          // _this.hello.unshift(response.data)
          _this.shareParentId.push({ pid: _this.sharePid, index: _this.shareIndex, LvType: _this.LvType });
          _this.sharePid = response.data.id;
          _this.index = response.data.fileName;
          _this.shareIndex = response.data.fileName;
          window.localStorage.setItem('shareIndex', response.data.fileName);
          window.localStorage.setItem('sharePid', response.data.id);
          var parentArr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.shareParentId);
          window.localStorage.setItem('shareParentId', parentArr);
          _this.$store.commit('changeId', response.data.id);
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(_this.message, { fileId: response.data.id, page: 0, size: 20 }).then(function (response) {
            var data = response.data.content;
            _this.hello = data;
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: '新建成功',
              iconClass: 'icon-success'
            });
          });
        }).catch(function (error) {
          Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
            message: error.response.data.message,
            iconClass: 'icon-error'
          });
        });
      }
    });
  }
};

var rename = function rename(_this) {
  __WEBPACK_IMPORTED_MODULE_2_mint_ui__["MessageBox"].prompt('重命名', '', {
    showInput: true,
    inputValue: _this.fileName,
    inputPattern: /^.{1,50}$/,
    inputErrorMessage: '名字长度为1-50个字符'
  }).then(function (_ref3) {
    var value = _ref3.value,
        action = _ref3.action;

    if (action === 'confirm' && value !== null) {
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].rename, { name: value, fileId: _this.fileId }).then(function (response) {
        _this.hello[_this.indexing].fileName = value;
        Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
          message: '重命名成功',
          iconClass: 'icon-success'
        });
      }).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
          message: error.response.data.message,
          iconClass: 'icon-error'
        });
      });
    }
  });
};

var del = function del(_this, type) {
  __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].removeFiles, { fileIds: _this.fileId }).then(function (response) {
    for (var i = 0; i < _this.delArr.length; i++) {
      _this.hello.removeByValue(_this.delArr[i]);
    }
    Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
      message: '删除成功',
      iconClass: 'icon-success'
    });
    _this.restore();
    if (type === 1) {
      _this.index = window.localStorage.getItem('index');
      _this.indexs = _this.index;
    } else {
      _this.shareIndex = window.localStorage.getItem('shareIndex');
    }
    if (_this.hello.length <= 0) {
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(_this.message, { fileId: _this.pid, page: _this.page, size: _this.size }).then(function (response) {
        var data = response.data.content;
        if (data.length > 0) {
          for (var _i = 0; _i < data.length; _i++) {
            _this.hello.push(data[_i]);
          }
        }
        return false;
      }).catch(function (error) {});
    }
  }).catch(function (error) {
    Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
      message: error.response.data.message,
      iconClass: 'icon-error'
    });
  });
};

var collect = function collect(_this) {
  if (_this.isFavorite === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
      message: '请勿重复收藏',
      iconClass: 'icon-error'
    });
    return false;
  }
  __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].addFavorite, { fileIds: _this.fileId }).then(function (res) {
    Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
      message: '收藏成功',
      iconClass: 'icon-success'
    });
  }).catch(function (error) {
    Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
      message: error.response.data.message,
      iconClass: 'icon-error'
    });
  });
};

var delActions = function delActions(_this, type) {
  if (!_this.fs) {
    var checkbox = _this.$refs.mybox;
    var arr = '';
    for (var i = 0; i < checkbox.length; i++) {
      if (checkbox[i].className.indexOf('checked') !== -1) {
        arr += checkbox[i].getAttribute('fileId') + ',';
      }
    }
    arr = arr.substring(0, arr.length - 1);
    _this.delArr = arr.split(',');
    _this.copyfileId = _this.delArr;
    _this.fileId = arr;
  } else {
    var _checkbox = _this.$refs.hbox;
    var _arr = '';
    for (var _i2 = 0; _i2 < _checkbox.length; _i2++) {
      if (_checkbox[_i2].className.indexOf('checked') !== -1) {
        _arr += _checkbox[_i2].getAttribute('fileId') + ',';
      }
    }
    _arr = _arr.substring(0, _arr.length - 1);
    _this.delArr = _arr.split(',');
    _this.copyfileId = _this.delArr;
    _this.fileId = _arr;
  }
  if (type === '删除') {
    _this.fileId !== '' ? _this.delVisible = true : _this.delVisible = false;
  } else if (type === '分享') {
    _this.fileId !== '' ? _this.currentValue = true : _this.currentValue = false;
  } else if (type === '移动到') {
    if (_this.fileId !== '') {
      _this.moveFile();
    }
  } else if (type === '复制到') {
    if (_this.fileId !== '') {
      _this.copy();
    }
  } else if (type === '下载') {
    if (_this.fileId !== '') {
      _this.downLoad('1', _this.fileId, '0', _this.name);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ prompt: prompt, rename: rename, del: del, collect: collect, delActions: delActions });

/***/ }),

/***/ "jdJ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"head_in"},[_c('div',{staticClass:"logo iconfont icon-yiyun"}),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.productName))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jt1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bytesToSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formaTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return sliceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sliceName; });
var bytesToSize = function bytesToSize(bytes) {
  if (bytes === 0) return '0 B';
  if (bytes === '') return '-';
  var k = 1024;
  var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return (bytes / Math.pow(k, i)).toPrecision(3) + sizes[i];
};
var formaTime = function formaTime(val) {
  if (val !== '' || undefined || null) {
    return new Date(val).format('yyyy-MM-dd HH:mm');
  } else {
    return '永久有效';
  }
};
var sliceType = function sliceType(val, num) {
  if (val !== '' || undefined) {
    var point = val.lastIndexOf('.');
    var type = val.substring(point + 1).toLowerCase();
    if (this.isDir === 1) {
      return 'dir';
    }
    if (type === 'jpg' || type === 'gif' || type === 'JPG' || type === 'GIF' || type === 'png') {
      return 'pic';
    } else if (type === 'avi' || type === 'rmvb' || type === 'rm' || type === 'asf' || type === 'divx' || type === 'mpg' || type === 'mpeg' || type === 'mpe' || type === 'mp4' || type === 'mkv' || type === 'vob ') {
      return 'video';
    } else if (this.isDir === 1) {
      return 'dir';
    } else if (type === 'txt') {
      return 'txt';
    } else if (type === 'pdf') {
      return 'pdf';
    } else if (type === 'doc' || type === 'docx') {
      return 'word';
    } else if (type === 'ppt' || type === 'pptx') {
      return 'ppt';
    } else if (type === 'xls' || type === 'xlsx') {
      return 'excel';
    } else if (type === 'html' || type === 'htm') {
      return 'html';
    } else if (type === 'wps' || type === 'wpt') {
      return 'wps';
    } else if (type === 'zip' || type === 'rar') {
      return 'package';
    } else {
      return 'default';
    }
  }
};

var GetQueryString = function GetQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

var sliceName = function sliceName(val, le) {
  if (val.length > le) {
    return val.substring(0, le / 2) + '...' + val.substring(val.length - le / 2);
  } else {
    return val;
  }
};



/***/ }),

/***/ "kRT9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  test: {
    path: '/test',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: true,
      data: {
        name: 'demo1'
      }
    }
  },
  // 权限按钮配置
  getPermissionBtn: {
    app: 'cloudStorage',
    path: '/api/menu/pagePermissions',
    method: 'get'
  },
  /* 个人信息修改 */
  info: {
    path: '/api/user/info/modify',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  /* 个人信息展示 */
  show: {
    path: '/api/user/details/search',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 登录
  login: {
    path: '/spacex/login?ajax=true',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    timeout: 5000,
    mock: {
      enable: false,
      data: {}
    }
  },
  getCode: {
    path: '/api/captcha/generateBase64',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json',
    timeout: 5000
  },
  // 校验验证码
  checkCode: {
    path: '/spacex/captcha/validate',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json',
    timeout: 5000,
    mock: {
      enable: false,
      data: {}
    }
  },
  // 注册时验证手机号码是否存在
  phoneValidate: {
    path: '/api/user/phone/validate',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'text',
    timeout: 5000,
    mock: {
      enable: false,
      data: {}
    }
  },
  // 校验手机验证码
  checkPhoneCode: {
    path: '/api/sms/code/check',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'text',
    timeout: 5000,
    mock: {
      enable: false,
      data: {}
    }
  },
  // 校验图片验证码
  checkPicCode: {
    path: '/captcha/validate',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'text',
    timeout: 5000,
    mock: {
      enable: false,
      data: {}
    }
  },
  /* 发送验证码 */
  sendMsg: {
    path: '/api/sms/code/send',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 用户注册
  register: {
    path: '/api/user/register',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 密码找回身份认证
  psdIdentity: {
    path: '/api/user/identity/validate',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 重置密码
  reset: {
    path: '/api/user/password/update',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 删除文件／文件夹
  removeFiles: {
    path: '/api/file/removeFiles',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 用户名唯一性验证
  vWebsite: {
    path: '/api/user/website/validate',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 下载单个文件
  unifileD: {
    path: '/api/file/download/single',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 日志查询
  log: {
    path: '/api/log/mine/list',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 日志一键删除
  logsDeteleted: {
    path: '/api/log/mine/removeAll',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 日志单独删除
  logDeteleted: {
    path: '/api/log/mine/remove',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'json',
    // traditional: true,
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 回收站的日志查询
  delList: {
    path: '/api/file/delList',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'json',
    defaultParam: {
      order: 0,
      type: 'gmt_create'
    },
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 清空已删除文件
  clearRemovedFile: {
    path: '/api/file/clearRemovedFile',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 彻底删除
  permRemove: {
    path: '/api/file/permRemove',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 文件恢复
  recover: {
    path: '/api/file/recover',
    app: 'cloudStorage',
    method: 'POST',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 多文件打包下载
  multifilesD: {
    path: '/api/file/download/multi',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json',
    mock: {
      enable: false,
      data: {
        name: 'demo1'
      }
    }
  },
  // 新建文件夹接口
  mKdir: {
    path: '/api/file/mkdir',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 重命名接口
  rename: {
    path: '/api/file/rename',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 个人文件查询接口
  searchFile: {
    path: '/api/file/list',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    defaultParam: {
      order: 1,
      type: 'gmt_modified'
    }
  },
  // 获取文件夹列表
  getFolderLists: {
    path: '/api/file/dir/list',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 获取历史版本列表
  getVertionLists: {
    path: '/api/fileVersion/list',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 文件设置为最新
  setNewest: {
    path: '/api/fileVersion/goBack',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // logoOut
  logout: {
    path: '/spacex/logout',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 某文件的某个版本下载
  versionUnifileD: {
    path: '/api/fileVersion/download/single',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 添加分享
  share: {
    path: '/api/share/publish',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 已分享列表
  sharelist: {
    path: '/api/share/list',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 分享给同事
  shareWorkmate: {
    path: '/api/assignedShare/save',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 取消分享给同事
  cancelShareWorkmate: {
    path: '/api/assignedShare/cancel',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 取消分享文件
  delateShare: {
    path: '/api/share/delete',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 上传
  simpleUpload: {
    path: '/api/file/simpleUpload',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 上传
  simpleNewUpload: {
    path: '/api/fileVersion/simpleUpload',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 头像上传
  avator: {
    path: '/api/user/avator/upload',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    contentType: 'multipart/form-data'
  },
  // 已收藏列表
  favorite: {
    path: '/api/favorite/list',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    defaultParam: {
      order: 0,
      type: 'gmt_create'
    }
  },
  // 取消收藏
  removeFavorite: {
    path: '/api/favorite/remove',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 添加收藏
  addFavorite: {
    path: '/api/favorite/add',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 文件或文件夹移动
  moveFiles: {
    path: '/api/file/move',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 文件或文件夹复制
  copyFiles: {
    path: '/api/file/copy',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 文件保存
  saveFiles: {
    path: '/api/share/save',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 是否需要加密
  isPrivate: {
    path: '/api/share/isPrivate',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 查询分享文件
  checkShareFile: {
    path: '/api/share/checkShareFile',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 按目录查询分享文件
  listShareFile: {
    path: '/api/share/listShareFile',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 分享文件下载
  shareDownload: {
    path: '/api/share/download',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json'
  },
  // 共享文件对应全选用户列表
  userList: {
    path: '/api/shareFile/user/list',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json'
  },
  // 共享文件查询
  shareFiles: {
    path: '/api/shareFile/list',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    defaultParam: {
      order: 1,
      type: 'gmt_modified'
    }
  },
  // 文件预览
  preview: {
    path: '/api/file/preview',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json'
  },
  // 新建共享文件夹接口
  mKDir: {
    path: '/api/shareFile/mkDir',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  mkFirstShareDr: {
    path: '/api/shareFile/publish',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 所有用户
  allUser: {
    path: '/api/user/search',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  userCount: {
    path: '/api/shareFile/user/count',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json'
  },
  addUser: {
    path: '/api/shareFile/user/add',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  removeUser: {
    path: '/api/shareFile/user/remove',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 文件夹目录结构查询
  fileCatalog: {
    path: '/api/file/fileCatalog',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json'
  },
  // 查询群组列表
  groupList: {
    path: '/api/userGroup/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 删除群组
  deleteGroup: {
    path: '/api/userGroup/remove',
    app: 'cloudStorage',
    method: 'post'
  },
  // 新增群组
  addGroup: {
    path: '/api/userGroup/save',
    app: 'cloudStorage',
    method: 'post'
  },
  // 修改群组
  modifyGroup: {
    path: '/api/userGroup/rename',
    app: 'cloudStorage',
    method: 'post'
  },
  // 成员列表
  memberListByGroup: {
    path: '/api/user/groupUser/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 删除成员
  deleteMember: {
    path: '/api/userGroup/removeUser',
    app: 'cloudStorage',
    method: 'post'
  },
  // 部门列表
  deptList: {
    path: '/api/org/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 根据部门id查成员列表
  memberListByDept: {
    path: '/api/user/orgUser/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 所有用户列表
  allMemberList: {
    path: '/api/user/search',
    app: 'cloudStorage',
    method: 'post'
  },
  // 个人文件搜索
  fileSearch: {
    path: '/api/file/search',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json',
    defaultParam: {
      order: 1,
      type: 'gmt_modified'
    }
  },
  // 共享文件搜索
  shareSearch: {
    path: '/api/shareFile/search',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json',
    defaultParam: {
      order: 1,
      type: 'gmt_modified'
    }
  },
  // 他人分享搜索
  assignedShare: {
    path: '/api/assignedShare/search',
    app: 'cloudStorage',
    method: 'get',
    dataType: 'json',
    defaultParam: {
      order: 1,
      type: 'gmt_modified'
    }
  },
  // 新增成员
  addMember: {
    path: '/api/userGroup/addUser',
    app: 'cloudStorage',
    method: 'post'
  },
  // 包含租户的城市列表
  cityList: {
    path: '/api/city/hasTenant/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 包含租户的区域列表
  townList: {
    path: '/api/district/hasTenant/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 查询区域下的租户列表
  addressList: {
    path: '/api/tenant/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 查询租户log
  lesseeLogo: {
    path: '/api/tenant/getLogo',
    app: 'cloudStorage',
    method: 'get'
  },
  // 他人分享
  otherSharelist: {
    path: '/api/assignedShare/receiveUser/file/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 分享给他人的文件
  shareOther: {
    path: '/api/assignedShare/list',
    app: 'cloudStorage',
    method: 'get'
  },
  // 删除别人分享给我的文件
  deleteOtherShare: {
    path: '/api/assignedShare/receiveUser/removeFile',
    app: 'cloudStorage',
    method: 'post'
  },
  // 保存别人分享的文件
  saveOtherShare: {
    path: '/api/assignedShare/receiveUser/saveFile',
    app: 'cloudStorage',
    method: 'post'
  },
  // 他人分享预览文件
  otherSharePreview: {
    path: '/api/assignedShare/preview',
    app: 'cloudStorage',
    method: 'get'
  },
  // 他人分享图片预览
  otherShareImg: {
    path: '/api/assignedShare/receiveUser/downloadFile',
    app: 'cloudStorage',
    method: 'get'
  },
  // 记录用户的登陆信息
  record: {
    path: '/api/user/login/record',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false
    }
  },
  // 单点登录
  login2: {
    path: '/api/open/sz/login',
    app: 'cloudStorage',
    method: 'post',
    dataType: 'json',
    mock: {
      enable: false
    }
  }
});

/***/ }),

/***/ "kht+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_logo__ = __webpack_require__("h6b3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__ = __webpack_require__("kRT9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      time: 60,
      tishi: '',
      isShow: false,
      username: '',
      password: '',
      phone: '',
      code: '',
      confirm_password: '',
      isFirstStep: true,
      isSecondStep: false,
      isThirdStep: false,
      isLogo: true,
      sendMsgDisabled: true
    };
  },

  mounted: function mounted() {},
  components: {
    logo: __WEBPACK_IMPORTED_MODULE_0__common_logo__["a" /* default */]
  },
  methods: {
    nextStep: function nextStep() {
      var self = this;
      if (self.username.trim() === '' || self.password.trim() === '' || self.confirm_password.trim() === '') {
        self.isShow = true;
        self.tishi = '该内容不能为空';
      } else if (self.password !== self.confirm_password) {
        self.isShow = true;
        self.tishi = '两次密码输入不一致';
      } else {
        self.isFirstStep = false;
        self.isSecondStep = true;
        self.isThirdStep = false;
      }
    },
    focusUsername: function focusUsername() {
      this.isShow = false;
    },
    changeUsername: function changeUsername() {
      // 只能包括中文字、英文字母、数字和下划线
      var reg = /^[a-zA-Z]+([\u0391-\uFFE5\w]*)$/;
      var self = this;
      var username = self.username;
      if (username.trim() === '') {
        self.isShow = true;
        self.tishi = '请输入用户名';
        return false;
      }
      if (username.length < 6) {
        self.isShow = true;
        self.tishi = '用户名最少由六个字符组成';
        return false;
      }
      if (username.length > 16) {
        self.isShow = true;
        self.tishi = '用户名最多由十六个字符组成';
        return false;
      }
      if (!reg.test(username)) {
        self.isShow = true;
        self.tishi = '以字母开头的字符，可包括中文、英文、数字或下划线';
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].vWebsite, { website: username }).then(function (data) {
        self.isShow = false;
      }).catch(function (error) {
        self.isShow = true;
        self.tishi = error.response.data.message;
      });
    },
    changePassword: function changePassword() {
      var reg = /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,16}$/;
      var self = this;
      var password = self.password;
      if (password.trim() === '') {
        self.isShow = true;
        self.tishi = '密码不能为空';
        return false;
      }
      if (password.length < 6) {
        self.isShow = true;
        self.tishi = '密码长度不能小于6个字符';
        return false;
      }
      if (password.length > 16) {
        self.isShow = true;
        self.tishi = '密码长度不能大于16个字符';
        return false;
      }
      if (!reg.test(password)) {
        self.isShow = true;
        self.tishi = '密码必须是6-16位字母、数字或符号两种以上组合';
        return false;
      }
    },
    focusPassword: function focusPassword() {
      this.isShow = false;
    },
    changeConfirm_password: function changeConfirm_password() {
      var self = this;
      var confirmpassword = self.confirm_password;
      var password = self.password;
      if (confirmpassword.trim() === '') {
        self.isShow = true;
        self.tishi = '请输入密码';
        return false;
      }
      if (confirmpassword !== password) {
        self.isShow = true;
        self.tishi = '两次密码输入不一致';
        return false;
      }
    },
    focusConfirm_password: function focusConfirm_password() {
      this.isShow = false;
    },
    checkPhone: function checkPhone() {
      var self = this;
      var reg = /^1[3|4|5|7|8][0-9]{9}$/;
      var phone = self.phone.trim();
      if (phone.length === 0) {
        self.isShow = true;
        self.tishi = '手机号码不能为空';
        return false;
      }
      if (!reg.test(phone)) {
        self.isShow = true;
        self.tishi = '请正确填写您的手机号码';
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].phoneValidate, { phone: phone }).then(function () {
        self.isShow = false;
        __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].sendMsg, { type: 1, phone: phone }).then(function (data) {
          // 倒计时
          self.isShow = false;
          var cur = self.$refs.getMsg;
          self.sendMsgDisabled = false;
          cur.disabled = true;
          var interval = setInterval(function () {
            self.time--;
            if (self.time-- <= 0) {
              self.time = 60;
              self.sendMsgDisabled = true;
              cur.disabled = false;
              clearInterval(interval);
            }
          }, 1000);
        }).catch(function (error) {
          self.isShow = true;
          self.tishi = error.response.data.message;
        });
      }).catch(function (error) {
        self.isShow = true;
        self.tishi = error.response.data.message;
      });
    },
    nextStep1: function nextStep1() {
      var self = this;
      var data = { 'website': self.username, 'password': self.password, 'phone': self.phone, 'smsCode': self.code };
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].register, data).then(function () {
        // window.alert(1)
        self.isFirstStep = false;
        self.isSecondStep = false;
        self.isThirdStep = true;
        self.isLogo = false;
      }).catch(function (error) {});
    }
  }
});

/***/ }),

/***/ "kzLP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accountsafe_vue__ = __webpack_require__("oweP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a48556de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accountsafe_vue__ = __webpack_require__("JZ8t");
function injectStyle (ssrContext) {
  __webpack_require__("Mh5X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a48556de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accountsafe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a48556de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accountsafe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l1A3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all"},[_c('div',{staticClass:"head clearfix yp-topbar"},[_c('span',{staticClass:"setting"},[_vm._v("个人设置")]),_vm._v(" "),_c('router-link',{staticStyle:{"display":"inline-block","vertical-align":"middle","position":"absolute","left":"0","top":"32%"},attrs:{"slot":"left","to":"/more/setinfo"},slot:"left"},[_c('span',{staticClass:"back"})])],1),_vm._v(" "),_c('div',{staticClass:"main_list"},[_c('div',[_c('mt-cell',{attrs:{"title":"帐号"}},[_c('span',{staticStyle:{"color":"#9b9b9b"}},[_vm._v(_vm._s(_vm.website))])])],1),_vm._v(" "),_c('div',[_c('mt-cell',{attrs:{"title":"姓名"}},[_c('span',{staticStyle:{"color":"#9b9b9b"}},[_vm._v(_vm._s(_vm.nickName))])])],1),_vm._v(" "),_c('div',{staticClass:"avatar",on:{"click":_vm.newAvatar}},[_c('uploader',{staticStyle:{"display":"none"},attrs:{"options":_vm.uploadOptions},on:{"file-success":_vm.fileSuccess}},[_c('uploader-btn',{staticClass:"newAvatar",attrs:{"attrs":_vm.attrs}},[_vm._v("select images")])],1),_vm._v(" "),_c('form',{staticStyle:{"display":"inline-block"},attrs:{"enctype":"multipart/form-data","id":"uploadForm"}},[_c('label',{staticStyle:{"font-size":"16px"},attrs:{"for":"imgFile"}},[_vm._v("头像")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#9b9b9b"}},[_c('img',{ref:"img",staticClass:"header-img",attrs:{"src":_vm.avatar,"alt":""}})]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-right",staticStyle:{"position":"absolute","right":".12rem","color":"#c7c7cc","font-size":".3rem","font-weight":"900"}})])],1),_vm._v(" "),_c('div',{on:{"click":_vm.changePhone}},[_c('mt-cell',{attrs:{"title":"手机号码","is-link":""}},[_c('span',{staticStyle:{"color":"#9b9b9b"}},[_vm._v(_vm._s(_vm.phone))])])],1)]),_vm._v(" "),_c('mt-actionsheet',{attrs:{"actions":_vm.actions},model:{value:(_vm.sheetVisible),callback:function ($$v) {_vm.sheetVisible=$$v},expression:"sheetVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lW/G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m9nA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mHay":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var operaPermission = {
  '1': ['下载', '预览', '分享', '查看历史版本', '更多', '加入收藏'],
  '2': ['上传', '下载', '预览', '分享', '查看历史版本', '上传新版本', '更多', '加入收藏'],
  '3': ['上传', '下载', '预览', '分享', '删除', '重命名', '查看历史版本', '上传新版本', '移动到', '复制到', '新建文件夹', '更多', '加入收藏'],
  '4': ['上传', '下载', '预览', '分享', '删除', '重命名', '查看历史版本', '上传新版本', '移动到', '复制到', '新建文件夹', '设置', '更多', '加入收藏'],
  '5': ['上传', '下载', '预览', '分享', '删除', '重命名', '查看历史版本', '上传新版本', '移动到', '复制到', '新建文件夹', '更多', '加入收藏'],
  '6': ['下载', '分享']
};

var permissionJudge = function permissionJudge(permission, operation, map) {
  permission = String(permission);
  operation = String(operation);
  if (map[permission].indexOf(operation) !== -1) {
    return true;
  }
  return false;
};

var operaPermissionJudge = function operaPermissionJudge(permission, operation) {
  return permissionJudge(permission, operation, operaPermission);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  operaPermissionJudge: operaPermissionJudge
});

/***/ }),

/***/ "mbqF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('mt-header',{attrs:{"title":"设置昵称"}},[_c('router-link',{attrs:{"slot":"left","to":"/more/showinfo"},slot:"left"},[_c('span',{staticClass:"quxiao"},[_vm._v("取消")])]),_vm._v(" "),_c('mt-button',{class:{'selected': _vm.isA, 'selected-t': _vm.opacity},attrs:{"slot":"right"},on:{"click":function($event){return _vm.finish()}},slot:"right"},[_c('span',{ref:"finish",attrs:{"disabled":"disabled"}},[_vm._v("完成")])])],1),_vm._v(" "),_c('div',{staticClass:"usernameShow"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],ref:"txt",staticClass:"input",attrs:{"type":"text"},domProps:{"value":(_vm.username)},on:{"focus":function($event){return _vm.lightingColor()},"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"iconfont icon-guanbi1 icon",on:{"click":_vm.Null}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nOlU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modifyPassword_vue__ = __webpack_require__("H0Qc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49931542_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modifyPassword_vue__ = __webpack_require__("wrVy");
function injectStyle (ssrContext) {
  __webpack_require__("fvI9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49931542"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modifyPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49931542_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modifyPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ncsR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oGO4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linkShare__ = __webpack_require__("gKhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmateShare__ = __webpack_require__("z7yf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0_mint_ui__["Navbar"],
    TabItem: __WEBPACK_IMPORTED_MODULE_0_mint_ui__["TabItem"],
    linkShare: __WEBPACK_IMPORTED_MODULE_1__linkShare__["a" /* default */],
    workmateShare: __WEBPACK_IMPORTED_MODULE_2__workmateShare__["a" /* default */]
  },
  name: 'myShare',
  data: function data() {
    return {
      selectedTab: 'sendWorkmate', // 选中tab页
      index: '我的分享',
      indexs: '我的分享',
      shareArr: [],
      delArr: [],
      up: '',
      info: {
        page: 0,
        size: 20
      },
      page: 0,
      size: 20,
      totalPages: '',
      shareUrl: '',
      domin: ''
    };
  },

  methods: {
    back: function back() {
      this.$router.push('/more/setinfo');
    }
  }
});

/***/ }),

/***/ "oweP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_crypto__ = __webpack_require__("FuCC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isshow: true,
      isShow: false,
      isA: true,
      tishi: '',
      password: '',
      newPassword: '',
      confirm_password: '',
      index: '',
      form: '',
      rules: {
        password: [{
          required: true,
          message: '请输入旧密码',
          trigger: 'blur'
        }],
        newPassword: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }]
      }
    };
  },

  computed: {
    opacity: function opacity() {
      return this.password && this.newPassword && this.confirm_password && !this.isShow;
    }
  },
  components: {
    Toast: __WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"]
  },
  methods: {
    back: function back() {
      if (this.isshow) {
        this.$router.push('/more/setinfo');
      } else {
        this.isshow = true;
      }
    },

    goFirst: function goFirst() {
      this.isshow = false;
      this.index = '完成';
    },
    focusPassword: function focusPassword() {
      this.isShow = false;
    },
    changeNewpassword: function changeNewpassword() {
      var reg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!-\/:-@\[-`{-~])[!-~]{8,20}$/;
      var _this = this;
      if (_this.newPassword.length === 0) {
        _this.isShow = true;
        _this.tishi = '密码不能为空';
        return false;
      }
      if (_this.newPassword.length < 6) {
        _this.isShow = true;
        _this.tishi = '密码长度不能小于6个字符';
        return false;
      }
      if (_this.newPassword.length > 16) {
        _this.isShow = true;
        _this.tishi = '密码长度不能大于16个字符';
        return false;
      }
      if (!reg.test(_this.newPassword)) {
        _this.isShow = true;
        _this.tishi = '密码必须是8-16位字母、数字和符号三种组合';
        return false;
      }
    },
    focusNewpassword: function focusNewpassword() {
      this.isShow = false;
      //        this.opacity = true
    },
    focusConfirmpassword: function focusConfirmpassword() {
      this.isShow = false;
      if (this.password !== '' && this.newPassword !== '') {}
    },
    finish: function finish() {
      var validate = this.changeNewpassword();
      if (validate === false) {
        return validate;
      }
      if (this.password !== '' && this.newPassword !== '') {
        this.isA = false;
        if (this.confirm_password.trim() === '') {
          this.isShow = true;
          this.tishi = '请输入新密码';
          return false;
        }
        if (this.confirm_password !== this.newPassword) {
          this.isShow = true;
          this.tishi = '两次密码输入不一致';
          return false;
        } else {
          this.isShow = false;
          var oldPassword = this.password;
          var value = this.newPassword;
          var _this = this;
          __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].info, { value: __WEBPACK_IMPORTED_MODULE_3__utils_crypto__["a" /* default */].Encrypt(value), type: 4, oldPassword: __WEBPACK_IMPORTED_MODULE_3__utils_crypto__["a" /* default */].Encrypt(oldPassword) }).then(function (response) {
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: '修改成功',
              iconClass: 'icon-success'
            });
            _this.password = '';
            _this.newPassword = '';
            _this.confirm_password = '';
            //            let instance = Toast('修改成功')
            //            setTimeout(() => {
            //              instance.close()
            //            }, 2000)
            _this.isshow = true;
            _this.isA = true;
          }).catch(function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
              message: error.response.data.message,
              iconClass: 'icon-error'
            });
            _this.password = '';
            _this.isA = true;
            //            let instance = Toast(error.response.data.message)
            //            setTimeout(() => {
            //              instance.close()
            //            }, 2000)
          });
        }
      }
    }
  }
});

/***/ }),

/***/ "p8Zz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_tools__ = __webpack_require__("jt1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_event_bus__ = __webpack_require__("evg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_backAndClose_vue__ = __webpack_require__("2nT8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'index',
  components: {
    Toast: __WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"],
    sliceName: __WEBPACK_IMPORTED_MODULE_3__assets_js_tools__["d" /* sliceName */],
    aaa: __WEBPACK_IMPORTED_MODULE_5__components_backAndClose_vue__["a" /* default */]
  },
  data: function data() {
    return {
      file: '',
      isShows: false,
      attrs: {
        accept: '*'
      },
      directory: false,
      uploadOptions: {
        testChunks: false,
        uploadMethod: 'POST',
        target: __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].app.cloudStorage.baseUrl + '/api/file/simpleUpload',
        testMethod: 'POST',
        preprocess: this.preprocess,
        withCredentials: true,
        chunkSize: 10485760,
        forceChunkSize: true,
        query: this.queryFun,
        allowDuplicateUploads: true,
        headers: {
          'CS-PLATFORM': 'mobile'
        }
      },
      listShow: false,
      btnShow: false,
      uploader: '',
      fileList: {
        success: [],
        error: [],
        wait: []
      },
      delShow: '',
      isInitPermission: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('getPermissionBtns').then(function () {
      _this.isInitPermission = true;
      _this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uploader-drop').hide();
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uploader-list').hide();
        _this.uploader = _this.$refs.uploader.uploader;
      });
    });
  },

  updated: function updated() {
    this.$nextTick(function () {
      // 读取当前url 判断是否显示列表
      if (window.location.hash === '#/transfer') {
        this.listShow = true;
      } else {
        this.listShow = false;
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uploader-list').hide();
      }
      // 读取当前是否有上传的操作 来显示上传按钮
      if (window.location.hash === '#/index' || window.location.hash === '#/shareFile') {
        this.btnShow = true;
      } else {
        this.btnShow = false;
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uploader-drop').hide();
      }
    });
  },
  methods: {
    // 文件上传前判断是否携带分片信息
    preprocess: function preprocess(e) {
      var file = e.file;
      var chunk = {};
      var progress = (e.startByte / file.size).toFixed(2);
      this.$store.commit('uploading', { id: file.id, progress: progress });
      if (parseInt(file.size) > parseInt(10485760)) {
        chunk.chunk = e.offset;
        chunk.chunks = file.chunks.length;
        // this.queryFun(e.file, chunk, true)
      }
      e.preprocessFinished();
    },
    // 参数上传配置
    queryFun: function queryFun(file, chunk, type) {
      if (!file.guid) {
        file.guid = file.uniqueIdentifier + new Date().getTime();
      }
      var query = {
        guid: file.guid,
        dirId: this.$store.state.fileId,
        size: file.size,
        type: file.fileType,
        name: file.name,
        lastModifiedDate: file.file.lastModifiedDate
      };
      if (parseInt(chunk.file.size) > parseInt(10485760)) {
        query.chunk = chunk.offset;
        query.chunks = chunk.file.chunks.length;
      }
      return query;
    },
    // 文件加入队列
    fileAdded: function fileAdded(file, event) {
      // this.fileList.wait.push(file)
      var usedSize = JSON.parse(window.sessionStorage.mobileData).usedSize;
      var quota = JSON.parse(window.sessionStorage.mobileData).quota;

      if (file.size <= quota - usedSize) {
        this.$store.commit('fileListPush', { type: 0, file: file });
      } else {
        file.ignored = true;
        Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
          message: '空间不足,请申请或清空回收站',
          iconClass: 'icon-error'
        });
        this.isShows = true;
      }
    },
    // 文件开始上传
    uploadfileStart: function uploadfileStart(index) {
      if (!this.isShows) {
        Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
          message: '文件已添加至上传列表...',
          iconClass: 'icon-success'
        });
      }
      this.isShows = false;
      this.$router.push('/transfer');
    },
    // 文件上传失败
    fileError: function fileError(rootFile, file, message, chunk) {
      // Toast({
      //   message: JSON.parse(message).message,
      //   iconClass: 'icon-error'
      // })
      file.newDate = new Date();
      file.message = JSON.parse(message).message;
      this.$store.commit('fileListRemove', { type: 0, file: file });
      this.$store.commit('fileListPush', { type: 2, file: file });
    },
    // 文件上传成功
    fileSuccess: function fileSuccess(rootFile, file, message, chunk) {
      file.newDate = new Date();
      this.$store.commit('fileListRemove', { type: 0, file: file });
      this.$store.commit('fileListPush', { type: 1, file: file });
    },
    // 文件上传结束
    fileProgress: function fileProgress(rootFile, file, chunk) {
      //        this.$store.commit('fileListRemove', {type: 0, file: file})
    },
    // 文件上传完成
    fileComplete: function fileComplete(rootFile) {
      Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
        message: '上传成功',
        iconClass: 'icon-success'
      });
      __WEBPACK_IMPORTED_MODULE_4__utils_event_bus__["a" /* eventBus */].$emit('initShareData');
      __WEBPACK_IMPORTED_MODULE_4__utils_event_bus__["a" /* eventBus */].$emit('initFileData');
    }
  }
});

/***/ }),

/***/ "pDJX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__ = __webpack_require__("kht+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec10da0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__ = __webpack_require__("tVqC");
function injectStyle (ssrContext) {
  __webpack_require__("2IMp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ec10da0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec10da0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pDWz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_transfer_vue__ = __webpack_require__("40PK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecbb9a14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transfer_vue__ = __webpack_require__("1Knd");
function injectStyle (ssrContext) {
  __webpack_require__("lW/G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ecbb9a14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_transfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecbb9a14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pJgE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tabbar_vue__ = __webpack_require__("MTyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      uploadOptions: {
        testChunks: false,
        uploadMethod: 'POST',
        target: __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].app.cloudStorage.baseUrl + '/api/user/avator/upload',
        testMethod: 'POST',
        withCredentials: true,
        chunkSize: 16777216000000000,
        forceChunkSize: true
      },
      avatar: '',
      nickName: '',
      website: '',
      attrs: {
        accept: 'image/*'
      },
      phone: '',
      sheetVisible: false,
      actions: [{
        name: '拍照',
        method: this.photos
      }, {
        name: '从手机相册选择',
        method: this.choose
      }],
      avatarId: ''
    };
  },

  components: {
    tabbar: __WEBPACK_IMPORTED_MODULE_2__components_tabbar_vue__["a" /* default */],
    Actionsheet: __WEBPACK_IMPORTED_MODULE_3_mint_ui__["Actionsheet"],
    Toast: __WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"]
  },
  created: function created() {
    this._showList();
  },

  methods: {
    fileSuccess: function fileSuccess(rootFile, file, message, chunk) {
      var _this = this;
      this.avatarId = message.split('\"').join('');
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].info, { value: this.avatarId, type: 1 }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].show).then(function (res) {
          _this.avatar = __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].app.cloudStorage.baseUrl + res.data.avatar;
        });
        Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
          message: '修改成功',
          iconClass: 'icon-success'
        });
      }).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
          message: error.response.data.message,
          iconClass: 'icon-error'
        });
      });
    },
    newAvatar: function newAvatar() {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.newAvatar').click();
    },
    _showList: function _showList() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_1__apis_cloudStorageApi__["a" /* default */].show, {}).then(function (response) {
        _this.avatar = __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].app.cloudStorage.baseUrl + response.data.avatar;
        _this.nickName = response.data.nickName;
        _this.website = response.data.website;
        _this.phone = response.data.phone;
      });
    },
    changeUsername: function changeUsername() {
      this.$router.push({ path: '/more/changusername' });
    },
    changePhone: function changePhone() {
      this.$router.push({ path: '/more/acceptcode' });
    }
  }
});

/***/ }),

/***/ "pVVV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yp-wrap"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.status.isSearch),expression:"!status.isSearch"}],staticClass:"yp-header yp-topbar yp-head-infor"},[_c('div',{staticClass:"yp-header-left"}),_vm._v(" "),_c('div',{staticClass:"yp-header-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"yp-header-right"},[_c('span',{on:{"click":_vm.cancel}},[_vm._v("取消")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status.isSearch),expression:"status.isSearch"}],staticClass:"yp-header yp-topbar yp-header-search"},[_c('div',{staticClass:"yp-header-search-input"},[_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchMemberList.search),expression:"searchMemberList.search"}],staticClass:"icon-guanbi-container"},[_c('i',{staticClass:"iconfont icon-guanbi1",on:{"click":function($event){_vm.searchMemberList.search = ''}}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchMemberList.search),expression:"searchMemberList.search"}],attrs:{"placeholder":"按姓名或拼音搜索"},domProps:{"value":(_vm.searchMemberList.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchMemberList, "search", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"yp-header-cancel",on:{"click":_vm.cancelSearch}},[_vm._v("\n      取消\n    ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchMemberList.search),expression:"searchMemberList.search"}],staticClass:"yp-main"},[_c('div',{staticClass:"yp-content-main search-content",on:{"scroll":_vm.searchContentScroll}},[_c('ul',_vm._l((_vm.searchMemberList.data),function(item,index){return _c('li',{on:{"click":function($event){return _vm.memberRowClick(item)}}},[_c('div',{staticClass:"li-checkbox"},[_c('div',{staticClass:"checkbox-icon",class:{'selected': item.isSelected = _vm.status.selectedMemberId.indexOf(item.id)!==-1}})]),_vm._v(" "),_c('img',{staticClass:"li-img",attrs:{"alt":"","src":item.avator}}),_vm._v(" "),_c('div',{staticClass:"li-name"},[_vm._v(_vm._s(item.realName))]),_vm._v(" "),_c('div',{staticClass:"li-right"},[_vm._v(_vm._s(item.phoneNumber))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.searchMemberList.search),expression:"!searchMemberList.search"}],staticClass:"yp-main",attrs:{"id":"main"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.status.isSearch),expression:"!status.isSearch"}],staticClass:"yp-search"},[_c('div',{staticClass:"yp-search-input top-search",on:{"click":function($event){_vm.status.isSearch = true}}},[_c('i',{staticClass:"iconfont icon-sousuo"}),_vm._v(" "),_c('span',[_vm._v("按姓名或拼音搜索")])])]),_vm._v(" "),_c('div',{staticClass:"yp-menu"},[_vm._l((_vm.menuList),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.status.triggerCrumbs),expression:"!status.triggerCrumbs"}],key:index,staticClass:"yp-menu-list"},[_c('i',{staticClass:"yp-menu-icon iconfont",class:item.icon}),_vm._v(" "),_c('div',{staticClass:"yp-menu-content",on:{"click":item.event}},[_vm._v(_vm._s(item.menuName))])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status.triggerCrumbs),expression:"status.triggerCrumbs"}],staticClass:"yp-menu-crumbs"},[_c('crumbs',{attrs:{"routes":_vm.crumbs.routes,"crumbTrigger":_vm.crumbs.crumbTrigger}})],1)],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status.isAllMember),expression:"status.isAllMember"}],staticClass:"yp-content-title"},[_vm._v("联系人")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status.isAllMember),expression:"status.isAllMember"}],staticClass:"yp-content",attrs:{"id":"memberListContent"},on:{"scroll":_vm.memberListScroll}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.memberList.data.length),expression:"!memberList.data.length"}],staticClass:"yp-ul-noData"},[_vm._v("暂无数据")]),_vm._v(" "),_c('div',{staticClass:"yp-content-main"},[_c('ul',_vm._l((_vm.memberList.data),function(item,index){return _c('li',{on:{"click":function($event){return _vm.memberRowClick(item)}}},[_c('div',{staticClass:"li-checkbox"},[_c('div',{staticClass:"checkbox-icon",class:{'selected': item.isSelected = _vm.status.selectedMemberId.indexOf(item.id)!==-1}})]),_vm._v(" "),_c('img',{staticClass:"li-img",attrs:{"alt":"","src":item.avator}}),_vm._v(" "),_c('div',{staticClass:"li-name"},[_vm._v(_vm._s(item.realName))]),_vm._v(" "),_c('div',{staticClass:"li-right"},[_vm._v(_vm._s(item.phoneNumber))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.status.isAllMember && _vm.status.isSelectDept),expression:"!status.isAllMember && status.isSelectDept"}],staticClass:"yp-content"},[_c('div',{staticClass:"yp-content-main"},[_c('ul',_vm._l((_vm.deptList.renderData),function(item,index){return _c('li',[_c('div',{staticClass:"li-name"},[_vm._v(_vm._s(item.orgName))]),_vm._v(" "),_c('div',{staticClass:"li-right li-link"},[_c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.deptExpend(item)}}},[_vm._v("展开\n              ")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(item.children.length),expression:"item.children.length"}],on:{"click":function($event){$event.stopPropagation();return _vm.nextDept(item)}}},[_vm._v("下级\n              ")])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.status.isAllMember && !_vm.status.isSelectDept),expression:"!status.isAllMember && !status.isSelectDept"}],staticClass:"yp-content",attrs:{"id":"groupListContent"},on:{"scroll":_vm.groupListScroll}},[_c('div',{staticClass:"yp-content-main"},[_c('ul',_vm._l((_vm.groupList.renderData),function(item,index){return _c('li',[_c('div',{staticClass:"li-name"},[_vm._v(_vm._s(item.groupName))]),_vm._v(" "),_c('div',{staticClass:"li-right li-link"},[_c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.groupExpend(item)}}},[_vm._v("展开")])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"yp-footer"},[_c('span',[_vm._v("已选择"+_vm._s(_vm.status.selectedMemberId.length)+"个")]),_vm._v(" "),_c('button',{staticClass:"confirm-button",class:{'disabled': !_vm.status.selectedMemberId.length},attrs:{"disabled":!_vm.status.selectedMemberId.length},on:{"click":_vm.confirm}},[_vm._v("\n      确定（"+_vm._s(_vm.status.selectedMemberId.length)+"/"+_vm._s(_vm.constant.maxSelect)+"）\n    ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status.isSearch&&!_vm.searchMemberList.search),expression:"status.isSearch&&!searchMemberList.search"}],staticClass:"shade"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-sousuo-container"},[_c('i',{staticClass:"iconfont icon-sousuo"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qSux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_changephone_vue__ = __webpack_require__("qwiE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70fe9630_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_changephone_vue__ = __webpack_require__("UtRH");
function injectStyle (ssrContext) {
  __webpack_require__("QKLI")
  __webpack_require__("CSMX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70fe9630"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_changephone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70fe9630_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_changephone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qwiE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import apis from '../../apis/index'
//  import cloudApi from '../../apis/cloudStorageApi'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      phone: '',
      phone1: ''
    };
  },
  created: function created() {
    this.phone = JSON.parse(sessionStorage.mobileData).phone;
    //      this.phone1 = this.phone.substr(0, 3) + '****' + this.phone.substr(7)
  },

  methods: {
    sendMsg: function sendMsg() {
      var _this = this;
      _this.$router.push({ path: '/more/acceptcode' });
    }
  }
});

/***/ }),

/***/ "r5sU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sMIb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routerSplitCharacter; });
var routerSplitCharacter = '#$%@';

/***/ }),

/***/ "sSfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__("Mg8F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2161d48a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__("1HsE");
function injectStyle (ssrContext) {
  __webpack_require__("JHQG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2161d48a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2161d48a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sp5F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tVqC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register_wrap"},[_c('mt-header',{attrs:{"fixed":"","title":"注册"}},[_c('router-link',{attrs:{"slot":"left","to":"/"},slot:"left"},[_c('span',{staticClass:"back"})])],1),_vm._v(" "),(_vm.isLogo)?_c('logo'):_vm._e(),_vm._v(" "),(_vm.isFirstStep)?_c('div',{staticClass:"wrap_register"},[_c('div',{staticStyle:{"background":"#ffffff"}},[_c('form',{staticClass:"registerForm",attrs:{"autocomplete":"nope"}},[(_vm.isShow)?_c('div',{staticClass:"errowShow"},[_vm._v(_vm._s(_vm.tishi))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"register_label"},[_vm._v("帐户名")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"account inputForm",attrs:{"type":"text","placeholder":"输入帐户名"},domProps:{"value":(_vm.username)},on:{"blur":_vm.changeUsername,"focus":_vm.focusUsername,"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"register_label"},[_vm._v("登录密码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"password inputForm",attrs:{"type":"password","placeholder":"输入登录密码"},domProps:{"value":(_vm.password)},on:{"blur":_vm.changePassword,"focus":_vm.focusPassword,"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"register_label"},[_vm._v("确认密码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirm_password),expression:"confirm_password"}],staticClass:"confirm_password inputForm",attrs:{"type":"password","placeholder":"输入确认密码"},domProps:{"value":(_vm.confirm_password)},on:{"blur":_vm.changeConfirm_password,"focus":_vm.focusConfirm_password,"input":function($event){if($event.target.composing){ return; }_vm.confirm_password=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticStyle:{"padding":".6rem .25rem"}},[_c('mt-button',{staticClass:"btn",attrs:{"type":"primary","size":"large"},on:{"click":_vm.nextStep}},[_vm._v("下一步")])],1)]):_vm._e(),_vm._v(" "),(_vm.isSecondStep)?_c('div',{staticClass:"wrap_register"},[_c('div',{staticStyle:{"background":"#ffffff"}},[_c('form',{attrs:{"autocomplete":"off"}},[(_vm.isShow)?_c('div',{staticClass:"errowShow"},[_vm._v(_vm._s(_vm.tishi))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"register_label"},[_vm._v("手机号码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"inputForm",attrs:{"type":"number","placeholder":"输入手机号码","oninput":"if(value.length>11)value=value.slice(0,11)"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('div',{ref:"getMsg",staticStyle:{"position":"absolute","right":".5rem","bottom":"0"},on:{"click":function($event){$event.preventDefault();return _vm.checkPhone.apply(null, arguments)}}},[(_vm.sendMsgDisabled)?_c('span',{staticClass:"getCode"},[_vm._v(" 获取验证码")]):_c('span',{staticClass:"getCode"},[_vm._v(_vm._s(_vm.time + '秒后获取'))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"register_label"},[_vm._v("验证码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"inputForm",attrs:{"type":"number","placeholder":"输入验证码","oninput":"if(value.length>6)value=value.slice(0,6)"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticStyle:{"padding":".6rem .25rem"}},[_c('mt-button',{staticClass:"btn",attrs:{"type":"primary","size":"large"},on:{"click":_vm.nextStep1}},[_vm._v("下一步")])],1)]):_vm._e(),_vm._v(" "),(_vm.isThirdStep)?_c('div',{staticClass:"wrap"},[_vm._m(1),_vm._v(" "),_c('router-link',{staticStyle:{"padding":".6rem .4rem","display":"block"},attrs:{"to":"/login"}},[_c('mt-button',{staticClass:"btn",attrs:{"type":"primary","size":"large"}},[_vm._v("返回登录页面")])],1)],1):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",staticStyle:{"display":"none"}},[_c('input',{attrs:{"type":"text"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap_in"},[_c('div',[_c('img',{attrs:{"src":__webpack_require__("ZiMy"),"alt":""}})]),_vm._v(" "),_c('p',{staticStyle:{"font-size":".4rem"}},[_vm._v("注册成功")]),_vm._v(" "),_c('p',{staticClass:"info"},[_vm._v("您可以通过用户名+密码或 手机号+密码")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":".28rem","color":"#888888"}},[_vm._v("登陆法务云盘")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tlhh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    sendNewmsg: function sendNewmsg() {
      // 这里需要发送请求
      var _this = this;
      _this.$router.push({ path: '/more/newphonecode' });
    }
  }
});

/***/ }),

/***/ "uDHu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('mt-header',{attrs:{"title":"输入新手机号"}},[_c('router-link',{attrs:{"slot":"left","to":"/more/showinfo"},slot:"left"},[_c('span',{staticClass:"quxiao"},[_vm._v("取消")])])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 .4rem"}},[_c('mt-button',{staticClass:"btn",attrs:{"type":"primary","size":"large"},on:{"click":_vm.sendNewmsg}},[_vm._v("发送验证码")])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('span',{staticClass:"tip"},[_vm._v("目前绑定手机号码是，请输入你希望绑定的新号码。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phoneNum"},[_c('label',{staticClass:"label"},[_vm._v("手机号码")]),_vm._v(" "),_c('input',{staticClass:"input",attrs:{"type":"text","placeholder":"请输入验证码","maxlength":"6","autocomplete":"off"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uaVK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import GetQueryString from '../assets/js/tools'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tabbar',
  data: function data() {
    return {
      isIphoneX: false
    };
  },

  props: ['id'],
  methods: {},
  created: function created() {
    var isx = this.$store.state.isIphoneX;
    this.isIphoneX = isx;
  }
});

/***/ }),

/***/ "v0AA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vnB+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.triggerAddMember),expression:"!triggerAddMember"}],attrs:{"id":"group-wrap"}},[_c('div',{staticClass:"yp-topbar",attrs:{"id":"header"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isChoose),expression:"!isChoose"}],staticClass:"topbar"},[_c('div',{staticClass:"top-left"},[_c('i',{staticClass:"back",on:{"click":_vm.returnBack}})]),_vm._v(" "),_c('div',{staticClass:"top-center"},[_vm._v(_vm._s(_vm.group.groupName))]),_vm._v(" "),_c('div',{staticClass:"top-right"},[_c('i',{staticClass:"open-mobile",on:{"click":_vm.triggerAddMemberMed}}),_vm._v(" "),_c('i',{staticClass:"check-mobile",on:{"click":_vm.triggerChoose}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChoose),expression:"isChoose"}],staticClass:"topbar"},[_c('div',{staticClass:"top-left"},[_c('span',{on:{"click":_vm.choose}},[_vm._v("\n        "+_vm._s(_vm.isChooseAll ? '取消全选' : '全选')+"\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectCount > 0),expression:"selectCount > 0"}],staticClass:"top-center"},[_vm._v("已选"+_vm._s(_vm.selectCount)+"个群组")]),_vm._v(" "),_c('div',{staticClass:"top-right"},[_c('span',{on:{"click":_vm.cancle}},[_vm._v("取消")])])])]),_vm._v(" "),_c('div',{style:(("bottom:" + _vm.bottom)),attrs:{"id":"main"},on:{"scroll":_vm.memberListScroll}},[_c('ul',_vm._l((_vm.tableData),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"list-row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChoose),expression:"isChoose"}],staticClass:"checkbox",class:{'select': item.isSelected, 'unselect': !item.isSelected},on:{"click":function($event){return _vm.chooseOne(item)}}}),_vm._v(" "),_c('div',{staticClass:"list-left"},[_c('img',{staticClass:"head-img",attrs:{"alt":"","src":item.avator}})]),_vm._v(" "),_c('div',{staticClass:"list-center1"},[_c('div',{staticClass:"groupName"},[_vm._v(_vm._s(item.realName))])]),_vm._v(" "),_c('div',{staticClass:"list-right"},[_c('i',{staticClass:"more",class:{'transform':item.isTransform},on:{"click":function($event){return _vm.xialaClick(item)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isXiala),expression:"item.isXiala"}],staticClass:"xiala-div toolbar"},[_c('div',{staticClass:"operation",on:{"click":function($event){return _vm.deleteGroup(item)}}},[_c('i',{staticClass:"iconfont icon-lajitong"}),_vm._v(" "),_c('div',[_vm._v("删除")])])])])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChoose&&!_vm.selectCount),expression:"isChoose&&!selectCount"}],attrs:{"id":"footer-shade"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChoose),expression:"isChoose"}],staticClass:"toolbar",attrs:{"id":"footer"}},[_c('button',{on:{"click":function($event){return _vm.deleteGroup(null)}}},[_vm._v("删除")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShadeShow),expression:"isShadeShow"}],attrs:{"id":"shade"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.deleteTrigger),expression:"deleteTrigger"}],staticClass:"dialog"},[_c('div',{staticClass:"dialog-title"},[_vm._v("删除")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"dialog-footer"},[_c('div',{staticClass:"dialog-left",on:{"click":function($event){_vm.deleteTrigger = false;_vm.ids = []}}},[_vm._v("取消")]),_vm._v(" "),_c('div',{staticClass:"dialog-right",on:{"click":_vm.confirmDelete}},[_vm._v("确定")])])])]),_vm._v(" "),(_vm.triggerAddMember)?_c('div',{attrs:{"id":"addMember"}},[_c('addmember',{attrs:{"confirmOperation":_vm.confirmOperation,"cancelOperation":_vm.cancelOperation,"dataList":_vm.tableData,"isFilter":"true"}})],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-content"},[_c('span',{staticClass:"content"},[_vm._v("确认删除所选成员？")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vyk3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w3r+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard__ = __webpack_require__("V33R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tabbar_vue__ = __webpack_require__("MTyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_history_vue__ = __webpack_require__("gdx1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_share_vue__ = __webpack_require__("Eg0l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_copy_vue__ = __webpack_require__("2DrX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_download_js__ = __webpack_require__("AuSF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_image_lightbox__ = __webpack_require__("wOxb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_image_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_image_lightbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_methods__ = __webpack_require__("ilG3");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















__webpack_require__("NV5O");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'otherShare',
  components: {
    tabbar: __WEBPACK_IMPORTED_MODULE_5__components_tabbar_vue__["a" /* default */],
    downLoadFile: __WEBPACK_IMPORTED_MODULE_9__components_download_js__["a" /* downLoadFile */],
    Popup: __WEBPACK_IMPORTED_MODULE_2_mint_ui__["Popup"],
    Lightbox: __WEBPACK_IMPORTED_MODULE_10_vue_image_lightbox___default.a,
    history: __WEBPACK_IMPORTED_MODULE_6__components_history_vue__["a" /* default */],
    share: __WEBPACK_IMPORTED_MODULE_7__components_share_vue__["a" /* default */],
    copy: __WEBPACK_IMPORTED_MODULE_8__components_copy_vue__["a" /* default */]
  },
  data: function data() {
    return {
      mark: 1,
      isShow: true,
      isRoot: true, // 是否是根目录
      shareFile: false,
      isSearch: false,
      isClose: false,
      value: '',
      file: '',
      FileModalshow: false,
      FileModalHtml: '',
      attrs: {
        uploadMethod: 'POST',
        accept: '*',
        testMethod: 'POST'
      },
      imgArray: [],
      tab: 1,
      hisFlag: false,
      opacity: true,
      up: '',
      //        查看历史版本
      //        全选反选数据
      ish: false,
      //        其他
      history: false,
      fs: false,
      actionh: [{
        name: '保存到',
        method: this.moveFile
      }],
      //        当前共享文件夹的id
      sharePid: '',
      shareParentId: [],
      shareFileIds: '',
      shareTarget: true,
      shareIndex: '共享文件',
      //        移动成功后重新加载数据的pid
      movePid: '',
      //        复制移动
      model: '复制',
      //        控制复制移动页面的弹出
      move: false,
      //        待复制和移动文件的id
      copyfileId: [],
      copyparam: {
        page: 0,
        size: 20
      },
      copyPage: '',
      copySize: '',
      //        点击复制移动时记住之前的页面数据
      copyArr: [],
      copyIndex: '',
      copyParentId: [],
      copyId: '',
      //        分享
      currentValue: false,
      shareVisible: false,
      //        删除
      delVisible: false,
      delaction: [{
        name: '确认删除',
        method: this.delate
      }],
      //        添加
      sheetVisible: false,
      //        更多
      sheet: false,
      select: '',
      flag: false,
      //        正在操作的文件索引
      indexing: 0,
      index: '他人分享',
      indexs: '个人文件',
      //        存储所有文件的数组
      hello: [],
      //        删除文件的id
      delArr: [],
      //        控制全选反选和选择添加的显示隐藏
      isA: false,
      //        控制文件被是否被选中
      isB: false,
      message: __WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].otherSharelist,
      pid: null,
      //        返回上一级文件夹所需id
      parentId: [{ pid: null, index: '他人分享' }],
      check: '全选',
      whenId: null,
      page: 0,
      size: 20,
      totalPages: '',
      fileName: '',
      inputVlaue: '',
      checkedItem: [],
      operaRow: {
        id: null,
        fileId: null // 正在操作的行
      } };
  },
  created: function created() {
    this.load();
    this.slicetype = __WEBPACK_IMPORTED_MODULE_12_vue__["default"].filter('sliceType');
  },

  methods: {
    search: function search() {
      this.isShow = false;
    },
    test: function test() {
      this.sheetVisible = false;
      __WEBPACK_IMPORTED_MODULE_11_jquery___default()('.uploader-btn').click();
    },
    uploadNewFile: function uploadNewFile(val, val2, val3) {
      __WEBPACK_IMPORTED_MODULE_11_jquery___default()('.btnuploader-btn').click();
    },

    closeModal: function closeModal() {
      this.FileModalshow = false;
    },
    listenToMove: function listenToMove(somedata) {
      this.operaRow.id = null;
      this.operaRow.fileId = null;
      var _this = this;
      _this.move = false;
      _this.restore();
    },
    //      保存到
    moveFile: function moveFile() {
      this.model = '保存 (' + this.copyfileId.length + ')';
      this.move = true;
    },
    //      点击返回上一级目录
    back: function back() {
      if (this.isRoot) {
        this.$router.push('/more/setinfo');
        return;
      }
      this.checkedItem = [];
      var _this = this;
      var length = _this.parentId.length - 2;
      var fileId = _this.parentId[length].pid;
      var assignedShareId = _this.parentId[length].assignedShareId;
      _this.whenId = fileId;
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(this.message, { fileId: fileId, page: 0, assignedShareId: assignedShareId, size: 20 }).then(function (res) {
        if (!assignedShareId) {
          _this.isRoot = true;
        }
        _this.index = _this.parentId[length].index;
        _this.indexs = _this.parentId[length].index;
        _this.pid = fileId;
        _this.parentId.pop();
        _this.hello = res.data.content;
        if (_this.parentId.length === 0) {
          _this.person = false;
          _this.share = false;
          _this.kind = false;
          _this.shareFileIds = '';
        }
        _this.restore();
      }).catch(function (res) {});
    },
    //      点击进入下一级目录
    next: function next(index, assignedShareId, fileName, isDir, fileNum, shareStatus) {
      if (shareStatus === -1) {
        return;
      }
      this.whenId = index;
      var _this = this;
      if (isDir === 1 || fileNum > 1) {
        this.checkedItem = [];
        this.isRoot = false;
        var ulBox = _this.$refs.ulBox;
        ulBox.scrollTop = 0;
        __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(this.message, { fileId: index, assignedShareId: assignedShareId, page: 0, size: 20 }).then(function (res) {
          _this.hello = [];
          ulBox.scrollTop = 0;
          _this.parentId.push({ pid: index, assignedShareId: assignedShareId, index: fileName });
          _this.pid = index;
          _this.index = fileName;
          _this.indexs = fileName;
          var data = res.data.content;
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              _this.hello.push(data[i]);
            }
          }
          ulBox.scrollTop = 0;
          _this.restore();
        }).catch(function (res) {});
      } else {
        this.filePreview.apply(this, arguments);
      }
    },
    //      点击选择多个文件
    checkMobile: function checkMobile() {
      this.sheetVisible = false;
      this.flag ? this.flag = false : this.flag = true;
      this.isA ? this.isA = false : this.isA = true;
      this.select = '';
    },
    listenToCopy: function listenToCopy(somedata) {
      this.move = somedata;
      this.restore();
    },
    //      还原
    restore: function restore() {
      this.up = '';
      this.opacity = true;
      this.select = '';
      this.check = '全选';
      this.isA = false;
      this.isB = false;
      this.delArr = [];
      this.fileId = '';
      this.flag = false;
      this.currentValue = false;
      this.page = 0;
      this.size = 20;
      var checkbox = this.$refs.mybox;
      for (var i = 0; i < checkbox.length; i++) {
        checkbox[i].setAttribute('class', 'check');
      }
    },
    //      删除
    delate: function delate() {
      var _this2 = this;

      var assignedShareIds = [];
      if (this.operaRow.id) {
        assignedShareIds.push(this.operaRow.id);
      } else {
        this.checkedItem.forEach(function (value, index) {
          assignedShareIds.push(value.id);
        });
      }
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].deleteOtherShare, { assignedShareIds: assignedShareIds.join(',') }).then(function (res) {
        // this.hello.forEach((value, index, array) => {
        //   if (assignedShareIds.indexOf(value.id) !== -1) {
        //     this.hello.splice(index, 1)
        //   }
        // })
        _this2.hello = _this2.hello.filter(function (value, index) {
          return assignedShareIds.indexOf(value.id) === -1;
        });
        Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
          message: '删除分享记录成功',
          iconClass: 'icon-success'
        });
        _this2.operaRow.id = null;
        _this2.checkedItem.forEach(function (value, index, array) {
          if (assignedShareIds.indexOf(value.id) !== -1) {
            array.splice(index, 1);
          }
        });
        // 添加
        _this2.restore();
        _this2.index = '他人分享';
      });
    },
    //      操作多个文件
    delActions: function delActions(type) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_13__components_methods__["a" /* default */].delActions(_this, type);
    },
    //      删除单个文件
    delAction: function delAction(itemId, type, fileId) {
      this.operaRow.id = itemId;
      this.operaRow.fileId = fileId;
      if (type === '删除') {
        this.delArr = [itemId];
        this.delVisible = true;
      } else if (type === '保存到') {
        this.copyfileId = [itemId];
        this.moveFile();
      }
    },
    //      下拉操作
    selected: function selected(index) {
      if (this.select === index) {
        this.select = '';
        this.up = '';
      } else {
        this.select = index;
        this.up = index;
      }
    },
    //      单个文件选中
    checked: function checked(index, fileId, assignedShareId) {
      var length = this.hello.length;
      var _this = this;
      var num = this.$refs.mybox[index].className.indexOf('checked');
      var checkbox = this.$refs.mybox;
      var flag = 0;
      if (num === -1) {
        this.checkedItem.push({
          id: assignedShareId,
          fileId: fileId
        });
        var className = this.$refs.mybox[index].getAttribute('class');
        checkbox[index].setAttribute('class', className + ' ' + 'checked');
        for (var i = 0; i < checkbox.length; i++) {
          if (checkbox[i].className.indexOf('checked') !== -1) {
            flag++;
          }
        }
        if (flag > 0) {
          _this.index = '\u5DF2\u9009\u62E9' + flag + '\u4E2A\u6587\u4EF6';
          _this.opacity = false;
        }
        if (flag === length) {
          _this.check = '取消全选';
          _this.isB = true;
        }
      } else {
        this.checkedItem.some(function (value, index, array) {
          if (value.fileId === fileId && value.id === assignedShareId) {
            array.splice(index, 1);
            return true;
          }
          return false;
        });
        _this.opacity = true;
        checkbox[index].setAttribute('class', 'check');
        for (var _i = 0; _i < checkbox.length; _i++) {
          if (checkbox[_i].className.indexOf('checked') !== -1) {
            flag++;
          }
        }
        if (flag > 0) {
          _this.index = '\u5DF2\u9009\u62E9' + flag + '\u4E2A\u6587\u4EF6';
          _this.check = '全选';
          _this.opacity = false;
        } else {
          _this.index = _this.indexs;
        }
        if (flag === 0) {
          if (_this.check === '取消全选') {
            _this.checkAll();
          }
        }
      }
    },
    //      全选
    checkAll: function checkAll() {
      var _this = this;
      if (_this.hello.length === 0) {
        return false;
      }
      if (_this.check === '全选') {
        this.checkedItem = _this.hello.concat([]);
        var checkboxs = _this.$refs.mybox;
        for (var i = 0; i < checkboxs.length; i++) {
          checkboxs[i].setAttribute('class', 'check checked');
        }
        _this.isB = true;
        this.check = '取消全选';
        this.opacity = false;
        var checkbox = this.$refs.mybox.length;
        _this.index = '\u5DF2\u9009\u62E9' + checkbox + '\u4E2A\u6587\u4EF6';
        var box = this.$refs.mybox;
        var arr = '';
        for (var _i2 = 0; _i2 < box.length; _i2++) {
          arr += box[_i2].getAttribute('fileId') + ',';
        }
        arr = arr.substring(0, arr.length - 1);
        _this.delArr = arr.split(',');
        _this.fileId = arr;
      } else {
        this.checkedItem = [];
        this.isB = false;
        this.check = '全选';
        this.opacity = true;
        _this.index = _this.indexs;
      }
    },
    //      取消选中状态
    cancel: function cancel() {
      this.checkedItem = [];
      this.index = this.indexs;
      this.check = '全选';
      this.isB = false;
      this.fileId = '';
      this.select = '';
      this.up = '';
      this.opacity = true;
      this.isA ? this.isA = false : this.isA = true;
      var checkbox = this.$refs.mybox;
      for (var i = 0; i < checkbox.length; i++) {
        checkbox[i].setAttribute('class', 'check');
      }
    },
    load: function load() {
      var _this3 = this;

      this.page = 0;
      var queryParam = this.parentId[this.parentId.length - 1];
      __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(this.message, {
        fileId: queryParam.pid,
        assignedShareId: queryParam.assignedShareId,
        page: 0,
        size: 20
      }).then(function (response) {
        var data = response.data.content;
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            _this3.hello.push(data[i]);
          }
          _this3.totalPages = response.data.totalPages;
        } else {
          _this3.hello = [];
        }
        return false;
      }).catch(function (error) {});
    },
    loadMore: function loadMore() {
      var _this4 = this;

      // if (!this.value) {
      if (this.mark === 1) {
        this.loading = true;
        setTimeout(function () {
          var _this = _this4;
          if (_this.page < _this.totalPages) {
            _this.page++;
          } else {
            return false;
          }
          var queryParam = _this4.parentId[_this4.parentId.length - 1];
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(_this.message, {
            fileId: queryParam.pid,
            assignedShareId: queryParam.assignedShareId,
            page: _this.page,
            size: _this.size
          }).then(function (res) {
            var list0 = [];
            var data = res.data.content;
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                list0.push(data[i]);
              }
              if (_this.hello && list0) {
                _this.hello = _this.hello.concat(list0);
              }
            }
          });
          _this4.loading = false;
        }, 250);
      } else {
        this.loading = true;
        setTimeout(function () {
          var _this = _this4;
          if (_this.page < _this.totalPages) {
            _this.page++;
          } else {
            return false;
          }
          __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].assignedShare, {
            key: _this.value,
            page: _this.page,
            size: _this.size
          }).then(function (res) {
            var list0 = [];
            var data = res.data.content;
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                list0.push(data[i]);
              }
              if (_this.hello && list0) {
                _this.hello = _this.hello.concat(list0);
              }
            }
          });
          _this4.loading = false;
        }, 250);
      }
    },

    // 文件预览
    filePreview: function filePreview() {
      var _this5 = this,
          _arguments = arguments;

      var _this = this;
      this.$store.dispatch('getPermissionBtns').then(function () {
        if (!_this5.$customFunctions.checkPermission('preview')) {
          Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
            message: '您没有权限进行此操作!',
            duration: 2000,
            iconClass: 'icon-error'
          });
        } else {
          var params = '';
          _this5.imgArray = [];
          var sliceType = __WEBPACK_IMPORTED_MODULE_12_vue__["default"].filter('sliceType');
          for (var i = 0; i < _this.hello.length; i++) {
            if (sliceType(_this.hello[i].fileName) === 'icon-pic') {
              params = window.encodeURI(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                fileArr: [{
                  assignedShareId: _this.hello[i].id,
                  fileIds: [_this.hello[i].fileId]
                }],
                type: 2
              }));
              // const url = apis.app.cloudStorage.baseUrl + cloudApi.otherShareImg.path + '?fileIds=' + _this.hello[i].fileId + '&assignedShareId=' +  _this.hello[i].id
              var url = __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].app.cloudStorage.baseUrl + __WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].otherShareImg.path + '?queryStr=' + params;
              _this.hello[i].src = _this.hello[i].thumb = url;
              var obj = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.hello[i]));
              _this.imgArray.push(obj);
            }
          }
          if (sliceType(_arguments[2]) === 'icon-pic') {
            var idx = '';
            _this.imgArray.forEach(function (value, index) {
              if (value.fileName === _arguments[2]) {
                idx = index;
              }
            });
            _this5.$refs.lightbox.showImage(idx);
          } else {
            var list = ['txt', 'doc', 'docx', 'xlsx', 'xls', 'pdf', 'wps', 'wpt', 'xls', 'pptx', 'ppt'];
            var fileType = _arguments[2].lastIndexOf('.');
            var type = _arguments[2].substring(fileType + 1).trim();
            if (list.indexOf(type) !== -1) {
              var uSized = _arguments[6] / 1024 / 1024;
              if (uSized < 10) {
                __WEBPACK_IMPORTED_MODULE_2_mint_ui__["Indicator"].open('加载中...');
                __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].otherSharePreview, { fileId: _arguments[0], assignedShareId: _arguments[1] }).then(function (response) {
                  if (!response.data.code) {
                    __WEBPACK_IMPORTED_MODULE_2_mint_ui__["Indicator"].close();
                    _this.FileModalHtml = response.data.text;
                    _this.FileModalshow = true;
                  } else {
                    __WEBPACK_IMPORTED_MODULE_2_mint_ui__["Indicator"].close();
                    Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
                      message: '文件正在预览处理中,请稍后再试！',
                      // position: 'bottom',
                      duration: 5000
                    });
                  }
                }).catch(function (error) {
                  __WEBPACK_IMPORTED_MODULE_2_mint_ui__["Indicator"].close();
                  Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
                    message: '预览文件失败,请稍后重试',
                    position: 'bottom',
                    duration: 5000
                  });
                });
              } else {
                Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
                  message: '您预览文件较大,请下载后预览',
                  duration: 5000
                });
              }
            } else {
              Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])({
                message: '当前文件格式暂不支持预览',
                iconClass: 'icon-error'
              });
            }
          }
        }
      });
    },
    downLoad: function downLoad() {
      Object(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])('文件正在下载...');
      __WEBPACK_IMPORTED_MODULE_9__components_download_js__["a" /* downLoadFile */].apply(undefined, arguments);
    },
    focusInput: function focusInput() {
      this.isClose = true;
    },
    blurInput: function blurInput() {
      if (this.value !== '') {
        this.isClose = true;
      } else {
        this.isClose = false;
      }
    },
    clear: function clear() {
      if (this.value !== '') {
        this.value = '';
        this.load();
        this.hello = [];
        this.restore();
      }
    },
    cancelSearch: function cancelSearch() {
      this.isShow = true;
      this.value = '';
      this.mark = 1;
      this.load();
      this.restore();
      this.hello = [];
    },
    serchContent: function serchContent() {
      var _this = this;
      if (_this.value !== '') {
        _this.hello = [];
        _this.mark = 2;
        _this.page = 0;
        __WEBPACK_IMPORTED_MODULE_1__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_3__apis_cloudStorageApi__["a" /* default */].assignedShare, {
          key: _this.value,
          page: _this.page,
          size: _this.size
        }).then(function (res) {
          var data = res.data.content;
          _this.totalPages = res.data.totalPages;
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              if (data[i].fileName.length > _this.maxLen) {
                data[i].fileName = data[i].fileName.substring(0, _this.maxLen) + '...';
              }
              _this.hello.push(data[i]);
            }
          } else {
            _this.$refs.dis.innerText = '未搜索到相关文件/文件夹';
          }
        });
        _this.restore();
      } else {
        _this.mark = 1;
        _this.hello = [];
        _this.load();
      }
    }
  },
  watch: {
    whenId: function whenId(val) {
      this.$store.commit('changeId', val);
    }
  }
});

/***/ }),

/***/ "wAke":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wrVy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_c('span',{staticClass:"iconfont icon-left return",on:{"click":_vm.returnBack}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('logo'),_vm._v(" "),_c('div',{staticClass:"content"},[(_vm.isShow)?_c('div',{staticClass:"errowShow"},[_vm._v(_vm._s(_vm.tishi))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"login_label"},[_vm._v("帐号")]),_vm._v(" "),_c('input',{staticClass:"account inputForm",staticStyle:{"background":"none"},attrs:{"for":"username","type":"text","disabled":"disabled"},domProps:{"value":_vm.account}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"login_label"},[_vm._v("旧密码")]),_vm._v(" "),((_vm.textThree)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.oldPassword),expression:"oldPassword"}],staticClass:"account inputForm",staticStyle:{"background":"none"},attrs:{"for":"username","placeholder":"请输入旧密码","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.oldPassword)?_vm._i(_vm.oldPassword,null)>-1:(_vm.oldPassword)},on:{"change":function($event){var $$a=_vm.oldPassword,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.oldPassword=$$a.concat([$$v]))}else{$$i>-1&&(_vm.oldPassword=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.oldPassword=$$c}}}}):((_vm.textThree)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.oldPassword),expression:"oldPassword"}],staticClass:"account inputForm",staticStyle:{"background":"none"},attrs:{"for":"username","placeholder":"请输入旧密码","type":"radio"},domProps:{"checked":_vm._q(_vm.oldPassword,null)},on:{"change":function($event){_vm.oldPassword=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.oldPassword),expression:"oldPassword"}],staticClass:"account inputForm",staticStyle:{"background":"none"},attrs:{"for":"username","placeholder":"请输入旧密码","type":_vm.textThree},domProps:{"value":(_vm.oldPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.oldPassword=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"togglePsd",staticStyle:{"top":"0.25rem","width":"0.4rem","height":"0.4rem"},attrs:{"src":_vm.changePsdthree},on:{"click":_vm.togglePsdThree}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"login_label"},[_vm._v("新密码")]),_vm._v(" "),((_vm.textOne)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"}],staticClass:"account inputForm",attrs:{"for":"username","placeholder":"请输入8位以上数字字母特殊符号组合","maxlength":"16","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.newPassword)?_vm._i(_vm.newPassword,null)>-1:(_vm.newPassword)},on:{"blur":_vm.changeNewpassword,"focus":_vm.focusNewpassword,"change":function($event){var $$a=_vm.newPassword,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.newPassword=$$a.concat([$$v]))}else{$$i>-1&&(_vm.newPassword=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.newPassword=$$c}}}}):((_vm.textOne)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"}],staticClass:"account inputForm",attrs:{"for":"username","placeholder":"请输入8位以上数字字母特殊符号组合","maxlength":"16","type":"radio"},domProps:{"checked":_vm._q(_vm.newPassword,null)},on:{"blur":_vm.changeNewpassword,"focus":_vm.focusNewpassword,"change":function($event){_vm.newPassword=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"}],staticClass:"account inputForm",attrs:{"for":"username","placeholder":"请输入8位以上数字字母特殊符号组合","maxlength":"16","type":_vm.textOne},domProps:{"value":(_vm.newPassword)},on:{"blur":_vm.changeNewpassword,"focus":_vm.focusNewpassword,"input":function($event){if($event.target.composing){ return; }_vm.newPassword=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"togglePsd",staticStyle:{"top":"0.25rem","width":"0.4rem","height":"0.4rem"},attrs:{"src":_vm.changePsdone},on:{"click":_vm.togglePsdOne}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"login_label"},[_vm._v("新密码")]),_vm._v(" "),((_vm.textTwo)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirm_password),expression:"confirm_password"}],staticClass:"account inputForm",attrs:{"for":"username","placeholder":"请再次输入新密码","maxlength":"16","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.confirm_password)?_vm._i(_vm.confirm_password,null)>-1:(_vm.confirm_password)},on:{"mousedown":_vm.focusConfirmpassword,"change":function($event){var $$a=_vm.confirm_password,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.confirm_password=$$a.concat([$$v]))}else{$$i>-1&&(_vm.confirm_password=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.confirm_password=$$c}}}}):((_vm.textTwo)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirm_password),expression:"confirm_password"}],staticClass:"account inputForm",attrs:{"for":"username","placeholder":"请再次输入新密码","maxlength":"16","type":"radio"},domProps:{"checked":_vm._q(_vm.confirm_password,null)},on:{"mousedown":_vm.focusConfirmpassword,"change":function($event){_vm.confirm_password=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirm_password),expression:"confirm_password"}],staticClass:"account inputForm",attrs:{"for":"username","placeholder":"请再次输入新密码","maxlength":"16","type":_vm.textTwo},domProps:{"value":(_vm.confirm_password)},on:{"mousedown":_vm.focusConfirmpassword,"input":function($event){if($event.target.composing){ return; }_vm.confirm_password=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"togglePsd",staticStyle:{"top":"0.25rem","width":"0.4rem","height":"0.4rem"},attrs:{"src":_vm.changePsdtwo},on:{"click":_vm.togglePsdTwo}})]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0.4rem 0.4rem 0"}},[_c('mt-button',{staticClass:"btn",attrs:{"type":"primary","size":"large"},on:{"click":_vm.finsh}},[_vm._v("完成")])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modifyPsd"},[_c('span',[_vm._v("初始密码修改")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_index_js__ = __webpack_require__("0xDb");
//
//
//
//
//
//


__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "0OCa"));
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {};
  },
  created: function created() {
    if (window.__wxjs_environment !== undefined && window.__wxjs_environment === 'miniprogram') {
      var isx = Object(__WEBPACK_IMPORTED_MODULE_0__utils_index_js__["a" /* default */])();
      this.$store.commit('setSystemStatus', isx);
    }
  }
});

/***/ }),

/***/ "xPDF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yN5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_index__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__ = __webpack_require__("kRT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_event_bus__ = __webpack_require__("evg2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'history',
  data: function data() {
    return {
      page: 0,
      historyArr: [],
      title: '历史版本',
      up: '',
      select: ''
    };
  },
  created: function created() {
    this.list();
  },

  methods: {
    list: function list() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].getVertionLists, { fileId: _this.fileId, page: 0, size: 20 }).then(function (res) {
        var data = res.data.content;
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            _this.historyArr.push(data[i]);
          }
        }
      }).catch(function (error) {});
    },
    historyScroll: function historyScroll() {
      var _this = this;
      var ulBox = _this.$refs.historyBox;
      if (ulBox.scrollTop + ulBox.clientHeight >= ulBox.scrollHeight) {
        _this.page++;
        __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].getVertionLists, {
          fileId: _this.fileId,
          page: _this.page,
          size: 20
        }).then(function (res) {
          var data = res.data.content;
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              _this.historyArr.push(data[i]);
            }
          }
        }).catch(function (error) {
          Object(__WEBPACK_IMPORTED_MODULE_1_mint_ui__["Toast"])({
            message: error.response.data.message,
            iconClass: 'icon-error'
          });
        });
      }
    },
    backhistory: function backhistory() {
      this.$emit('history', false);
      __WEBPACK_IMPORTED_MODULE_3__utils_event_bus__["a" /* eventBus */].$emit('initFileData');
    },
    //      历史版本下拉
    hselected: function hselected(index) {
      if (this.select === index) {
        this.select = '';
        this.up = '';
      } else {
        this.select = index;
        this.up = index;
      }
    },
    goBack: function goBack(fileId) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__apis_index__["a" /* default */].request(__WEBPACK_IMPORTED_MODULE_2__apis_cloudStorageApi__["a" /* default */].setNewest, { vid: fileId }).then(function (res) {
        Object(__WEBPACK_IMPORTED_MODULE_1_mint_ui__["Toast"])({
          message: '已设为最新',
          iconClass: 'icon-success'
        });
        _this.historyArr = [];
        _this.list();
      }).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_1_mint_ui__["Toast"])({
          message: error.response.data.message,
          iconClass: 'icon-error'
        });
      });
    }
  },
  props: ['fileId']
});

/***/ }),

/***/ "yh+b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z7yf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workmateShare_vue__ = __webpack_require__("TQWo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c804f00e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_workmateShare_vue__ = __webpack_require__("L3yj");
function injectStyle (ssrContext) {
  __webpack_require__("JRU0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c804f00e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workmateShare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c804f00e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_workmateShare_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zUEV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_install_vue__ = __webpack_require__("EmL7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32bec0fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_install_vue__ = __webpack_require__("Qhen");
function injectStyle (ssrContext) {
  __webpack_require__("Zwg4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32bec0fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_install_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32bec0fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_install_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.69033880a0ba8cf15bb8.js